// vehicle category
const allMake = [
    {
        make: 'Audi',
        models: [
            'Q3',
            'SQ5',
            'R8',
            'Q5',
            'A7',
            'A6',
            'A4',
            'Q7',
            'Q8',
            'RS 5',
            'A8',
            'A3',
            'S5',
            'A4 allroad',
            'e-tron',
            'RS 3',
            'A5',
            'S3',
            'S4',
            'TT',
            'A3 Sportback e-tron',
            'S7',
            'S6',
            'S8',
            'RS 7',
            'A5 Sport',
            'allroad',
            'RS 4',
            'A4 (2005.5)',
            'S4 (2005.5)',
            'RS 6',
            'Cabriolet',
            '90',
            'Quattro',
            '100',
            '80',
            'A6 allroad',
        ],
        categories: ['SUV', 'Coupe', 'Convertible', 'Sedan', 'Wagon', 'Hatchback'],
    },
    {
        make: 'Chevrolet',
        models: [
            'Malibu',
            'Corvette',
            'Silverado 2500 HD Crew Cab',
            'Colorado Crew Cab',
            'Silverado 3500 HD Crew Cab',
            'Traverse',
            'Camaro',
            'Equinox',
            'Blazer',
            'Suburban',
            'Spark',
            'Silverado 1500 Crew Cab',
            'Bolt EV',
            'Tahoe',
            'Impala',
            'Trax',
            'Cruze',
            'Express 2500 Cargo',
            'Colorado Extended Cab',
            'Express 2500 Passenger',
            'Express 3500 Passenger',
            'Silverado 2500 HD Double Cab',
            'Silverado 1500 Regular Cab',
            'Express 3500 Cargo',
            'Silverado 1500 LD Double Cab',
            'Silverado 2500 HD Regular Cab',
            'Silverado 1500 Double Cab',
            'Sonic',
            'Volt',
            'Suburban 3500HD',
            'City Express',
            'Silverado 3500 HD Double Cab',
            'Silverado 3500 HD Regular Cab',
            'SS',
            'Cruze Limited',
            'Impala Limited',
            'Malibu Limited',
            'Spark EV',
            'Captiva Sport',
            'Express 1500 Cargo',
            'Express 1500 Passenger',
            'Suburban 1500',
            'Avalanche',
            'Silverado 2500 HD Extended Cab',
            'Silverado 3500 HD Extended Cab',
            'Silverado 1500 Extended Cab',
            'Suburban 2500',
            'Colorado Regular Cab',
            'Aveo',
            'HHR',
            'Cobalt',
            'TrailBlazer',
            'Malibu (Classic)',
            'Uplander Cargo',
            'Uplander Passenger',
            'Silverado (Classic) 3500 Extended Cab',
            'Silverado (Classic) 2500 HD Crew Cab',
            'Silverado (Classic) 1500 Crew Cab',
            'Silverado (Classic) 1500 Regular Cab',
            'Silverado (Classic) 1500 Extended Cab',
            'Silverado (Classic) 1500 HD Crew Cab',
            'Silverado (Classic) 3500 Crew Cab',
            'Monte Carlo',
            'Silverado (Classic) 3500 Regular Cab',
            'Silverado (Classic) 2500 HD Regular Cab',
            'Silverado (Classic) 2500 HD Extended Cab',
            'Avalanche 2500',
            'Avalanche 1500',
            'SSR',
            'Silverado 3500 Crew Cab',
            'Silverado 3500 Extended Cab',
            'Silverado 3500 Regular Cab',
            'Silverado 1500 HD Crew Cab',
            'Astro Cargo',
            'Classic',
            'Astro Passenger',
            'Cavalier',
            'Venture Passenger',
            'Venture Cargo',
            'Silverado 2500 Extended Cab',
            'S10 Crew Cab',
            'Silverado 2500 Crew Cab',
            'Silverado 2500 Regular Cab',
            'Tracker',
            'S10 Extended Cab',
            'S10 Regular Cab',
            'Prizm',
            'Metro',
            'Lumina',
            '2500 HD Regular Cab',
            '2500 Crew Cab',
            '2500 HD Extended Cab',
            '3500 Crew Cab',
            '3500 Extended Cab',
            '3500 Regular Cab',
            'Tahoe (New)',
            '1500 Extended Cab',
            '2500 Regular Cab',
            'G-Series 1500',
            '1500 Regular Cab',
            '2500 Extended Cab',
            'G-Series 3500',
            'G-Series 2500',
            'Beretta',
            'G-Series G30',
            'Lumina Passenger',
            'Sportvan G30',
            'Corsica',
            'Lumina Cargo',
            'Caprice Classic',
            '3500 HD Extended Cab',
            'G-Series G20',
            'G-Series G10',
            '3500 HD Regular Cab',
            'Sportvan G20',
            'S10 Blazer',
            'Lumina APV',
            'Sportvan G10',
            'APV Cargo',
            'Caprice',
            'Trailblazer',
        ],
        categories: [
            'Sedan',
            'Coupe',
            'Convertible',
            'Pickup',
            'SUV',
            'Hatchback',
            'Van/Minivan',
            'Wagon',
        ],
    },
    {
        make: 'Cadillac',
        models: [
            'Escalade ESV',
            'XT6',
            'XT5',
            'XT4',
            'CT6-V',
            'Escalade',
            'CT5',
            'CTS-V',
            'CT6',
            'CTS',
            'XTS',
            'ATS-V',
            'ATS',
            'ELR',
            'SRX',
            'Escalade EXT',
            'DTS',
            'STS',
            'XLR',
            'DeVille',
            'Seville',
            'Eldorado',
            'Catera',
            'Fleetwood',
            'Allante',
            'Sixty Special',
            'Brougham',
            'CT4',
        ],
        categories: ['SUV', 'Sedan', 'Coupe', 'Wagon', 'Pickup', 'Convertible'],
    },
    {
        make: 'Acura',
        models: [
            'RLX',
            'TLX',
            'MDX',
            'RDX',
            'MDX Sport Hybrid',
            'RLX Sport Hybrid',
            'NSX',
            'ILX',
            'TSX',
            'TL',
            'ZDX',
            'RL',
            'RSX',
            'CL',
            'Integra',
            'SLX',
            'Legend',
            'Vigor',
        ],
        categories: ['Sedan', 'SUV', 'Coupe', 'Wagon', 'Hatchback', 'Convertible'],
    },
    {
        make: 'BMW',
        models: [
            '3 Series',
            'X3',
            '7 Series',
            'X7',
            'X5',
            '4 Series',
            '2 Series',
            '5 Series',
            'M5',
            'i8',
            '8 Series',
            'M6',
            'i3',
            '6 Series',
            'M4',
            'X6 M',
            'X2',
            'X1',
            'X6',
            'X4',
            'M2',
            'Z4',
            'M3',
            'X5 M',
            '1 Series',
            'Z4 M',
            'Alpina B7',
            'Z8',
            'Z3',
            'M',
        ],
        categories: ['Sedan', 'SUV', 'Convertible', 'Coupe', 'Wagon', 'Hatchback'],
    },
    {
        make: 'Chrysler',
        models: [
            'Pacifica',
            'Voyager',
            'Pacifica Hybrid',
            '300',
            '200',
            'Town & Country',
            'PT Cruiser',
            'Sebring',
            'Aspen',
            'Crossfire',
            '300M',
            'Concorde',
            'Prowler',
            'LHS',
            'Cirrus',
            'Grand Voyager',
            'New Yorker',
            'LeBaron',
            'Fifth Ave',
            'Imperial',
        ],
        categories: ['Van/Minivan', 'Sedan', 'Convertible', 'Wagon', 'SUV', 'Coupe'],
    },
    {
        make: 'Ford',
        models: [
            'Fusion',
            'EcoSport',
            'Escape',
            'Mustang',
            'Edge',
            'F150 SuperCrew Cab',
            'Ranger SuperCab',
            'Expedition MAX',
            'Expedition',
            'Ranger SuperCrew',
            'Explorer',
            'F150 Super Cab',
            'F250 Super Duty Regular Cab',
            'F150 Regular Cab',
            'F450 Super Duty Crew Cab',
            'F350 Super Duty Crew Cab',
            'Fiesta',
            'F250 Super Duty Crew Cab',
            'F350 Super Duty Super Cab',
            'Flex',
            'Transit 150 Van',
            'Fusion Energi',
            'Transit Connect Cargo',
            'Transit 150 Wagon',
            'Transit 350 Van',
            'F250 Super Duty Super Cab',
            'Transit 250 Van',
            'Transit 350 Wagon',
            'Transit Connect Passenger',
            'Taurus',
            'C-MAX Hybrid',
            'F350 Super Duty Regular Cab',
            'Focus',
            'Transit 350 HD Van',
            'C-MAX Energi',
            'Expedition EL',
            'Focus ST',
            'E350 Super Duty Cargo',
            'E150 Passenger',
            'E150 Cargo',
            'E250 Cargo',
            'E350 Super Duty Passenger',
            'Crown Victoria',
            'Ranger Super Cab',
            'Ranger Regular Cab',
            'E150 Super Duty Passenger',
            'Explorer Sport Trac',
            'Taurus X',
            'E250 Super Duty Cargo',
            'E150 Super Duty Cargo',
            'Freestar Cargo',
            'Five Hundred',
            'Freestar Passenger',
            'Freestyle',
            'GT',
            'Excursion',
            'Thunderbird',
            'F150 (Heritage) Super Cab',
            'F150 (Heritage) Regular Cab',
            'Explorer Sport',
            'Windstar Cargo',
            'ZX2',
            'Windstar Passenger',
            'Econoline E250 Cargo',
            'Econoline E350 Super Duty Passenger',
            'Econoline E150 Cargo',
            'Econoline E150 Passenger',
            'Econoline E350 Super Duty Cargo',
            'Escort',
            'Contour',
            'Econoline E350 Cargo',
            'F250 Regular Cab',
            'F250 Super Cab',
            'Club Wagon',
            'Aerostar Passenger',
            'Aspire',
            'Aerostar Cargo',
            'Probe',
            'F350 Crew Cab',
            'F350 Regular Cab',
            'F250 Crew Cab',
            'F350 Super Cab',
            'Bronco',
            'Tempo',
            'Festiva',
            'Bronco Sport',
            'Transit Connect Cargo Van',
        ],
        categories: [
            'Sedan',
            'SUV',
            'Coupe',
            'Convertible',
            'Pickup',
            'Hatchback',
            'Van/Minivan',
            'Wagon',
        ],
    },
    {
        make: 'Buick',
        models: [
            'Envision',
            'Encore',
            'Enclave',
            'Regal Sportback',
            'Regal TourX',
            'Cascada',
            'LaCrosse',
            'Regal',
            'Verano',
            'Lucerne',
            'Rendezvous',
            'Terraza',
            'Rainier',
            'Century',
            'Park Avenue',
            'LeSabre',
            'Riviera',
            'Skylark',
            'Roadmaster',
            'Encore GX',
        ],
        categories: ['SUV', 'Sedan', 'Wagon', 'Convertible', 'Van/Minivan', 'Coupe'],
    },
    {
        make: 'INFINITI',
        models: [
            'QX80',
            'QX50',
            'QX60',
            'Q60',
            'Q50',
            'Q70',
            'QX30',
            'QX70',
            'Q40',
            'EX',
            'QX',
            'G',
            'JX',
            'FX',
            'M',
            'Q',
            'I',
            'J',
        ],
        categories: ['SUV', 'Coupe', 'Sedan', 'Convertible'],
    },
    {
        make: 'GMC',
        models: [
            'Sierra 2500 HD Crew Cab',
            'Sierra 3500 HD Crew Cab',
            'Terrain',
            'Sierra 1500 Crew Cab',
            'Yukon XL',
            'Yukon',
            'Acadia',
            'Canyon Crew Cab',
            'Sierra 1500 Double Cab',
            'Sierra 1500 Limited Double Cab',
            'Sierra 2500 HD Double Cab',
            'Sierra 2500 HD Regular Cab',
            'Canyon Extended Cab',
            'Sierra 1500 Regular Cab',
            'Savana 2500 Passenger',
            'Savana 3500 Passenger',
            'Savana 3500 Cargo',
            'Savana 2500 Cargo',
            'Sierra 3500 HD Double Cab',
            'Sierra 3500 HD Regular Cab',
            'Acadia Limited',
            'Savana 1500 Cargo',
            'Savana 1500 Passenger',
            'Yukon XL 1500',
            'Sierra 3500 HD Extended Cab',
            'Sierra 1500 Extended Cab',
            'Yukon XL 2500',
            'Sierra 2500 HD Extended Cab',
            'Canyon Regular Cab',
            'Envoy',
            'Sierra (Classic) 1500 HD Crew Cab',
            'Sierra (Classic) 3500 Crew Cab',
            'Sierra (Classic) 1500 Crew Cab',
            'Sierra (Classic) 1500 Extended Cab',
            'Sierra (Classic) 2500 HD Crew Cab',
            'Sierra (Classic) 1500 Regular Cab',
            'Sierra (Classic) 3500 Extended Cab',
            'Sierra (Classic) 3500 Regular Cab',
            'Sierra (Classic) 2500 HD Extended Cab',
            'Sierra (Classic) 2500 HD Regular Cab',
            'Envoy XL',
            'Sierra 3500 Crew Cab',
            'Sierra 1500 HD Crew Cab',
            'Sierra 3500 Extended Cab',
            'Sierra 3500 Regular Cab',
            'Envoy XUV',
            'Safari Cargo',
            'Safari Passenger',
            'Sierra 2500 Regular Cab',
            'Sonoma Crew Cab',
            'Sierra 2500 Crew Cab',
            'Sierra 2500 Extended Cab',
            'Sonoma Extended Cab',
            'Sonoma Regular Cab',
            'Jimmy',
            'Yukon Denali',
            'Sierra (Classic) 2500 Crew Cab',
            '2500 Crew Cab',
            '3500 Regular Cab',
            '1500 Club Coupe',
            '3500 Extended Cab',
            '2500 HD Regular Cab',
            '2500 HD Extended Cab',
            '3500 Crew Cab',
            'Suburban 2500',
            'Suburban 1500',
            '2500 Club Coupe',
            '2500 Regular Cab',
            '1500 Regular Cab',
            '3500 Club Coupe',
            'Sonoma Club Coupe Cab',
            '2500 HD Club Coupe',
            'Rally Wagon G3500',
            'Vandura G3500',
            'Rally Wagon G2500',
            'Vandura G2500',
            'Vandura G1500',
            'Rally Wagon 2500',
            'Rally Wagon 3500',
            'Vandura 1500',
            'Vandura 3500',
            'Vandura 2500',
            'Rally Wagon 1500',
            'Sonoma Club Cab',
            'Hummer EV',
        ],
        categories: ['Pickup', 'SUV', 'Van/Minivan'],
    },
    {
        make: 'Honda',
        models: [
            'Insight',
            'Civic',
            'Accord Hybrid',
            'Odyssey',
            'Ridgeline',
            'Passport',
            'Accord',
            'Pilot',
            'CR-V',
            'HR-V',
            'Clarity Electric',
            'Civic Type R',
            'Clarity Fuel Cell',
            'Clarity Plug-in Hybrid',
            'Fit',
            'CR-Z',
            'Crosstour',
            'Accord Crosstour',
            'Element',
            'S2000',
            'Prelude',
            'del Sol',
            'CR-V Hybrid',
        ],
        categories: [
            'Sedan',
            'Hatchback',
            'Coupe',
            'Van/Minivan',
            'Pickup',
            'SUV',
            'Convertible',
            'Wagon',
        ],
    },
    {
        make: 'Hyundai',
        models: [
            'Santa Fe',
            'Sonata',
            'Kona Electric',
            'NEXO',
            'Veloster',
            'Elantra GT',
            'Kona',
            'Palisade',
            'Elantra',
            'Venue',
            'Ioniq Plug-in Hybrid',
            'Tucson',
            'Accent',
            'Ioniq Electric',
            'Sonata Hybrid',
            'Ioniq Hybrid',
            'Sonata Plug-in Hybrid',
            'Santa Fe XL',
            'Santa Fe Sport',
            'Azera',
            'Tucson Fuel Cell',
            'Genesis',
            'Genesis Coupe',
            'Equus',
            'Veracruz',
            'Entourage',
            'Tiburon',
            'XG350',
            'XG300',
            'Scoupe',
            'Excel',
        ],
        categories: ['SUV', 'Sedan', 'Coupe', 'Hatchback', 'Wagon', 'Van/Minivan'],
    },
    {
        make: 'Jeep',
        models: [
            'Gladiator',
            'Compass',
            'Cherokee',
            'Grand Cherokee',
            'Renegade',
            'Wrangler',
            'Wrangler Unlimited',
            'Patriot',
            'Liberty',
            'Commander',
            'Comanche Regular Cab',
            'Grand Cherokee L',
            'Grand Wagoneer',
        ],
        categories: ['Pickup', 'SUV'],
    },
    {
        make: 'Genesis',
        models: ['G70', 'G80', 'G90', 'GV80'],
        categories: ['Sedan', 'SUV'],
    },
    {
        make: 'Dodge',
        models: [
            'Durango',
            'Charger',
            'Challenger',
            'Journey',
            'Grand Caravan Passenger',
            'Viper',
            'Dart',
            'Avenger',
            'Caliber',
            'Grand Caravan Cargo',
            'Nitro',
            'Ram 2500 Regular Cab',
            'Ram 1500 Quad Cab',
            'Dakota Extended Cab',
            'Ram 1500 Crew Cab',
            'Dakota Crew Cab',
            'Ram 2500 Mega Cab',
            'Ram 1500 Regular Cab',
            'Ram 3500 Crew Cab',
            'Ram 2500 Crew Cab',
            'Ram 3500 Mega Cab',
            'Ram 3500 Regular Cab',
            'Ram 3500 Quad Cab',
            'Ram 2500 Quad Cab',
            'Sprinter 2500 Cargo',
            'Sprinter 2500 Passenger',
            'Magnum',
            'Ram 1500 Mega Cab',
            'Sprinter 3500 Cargo',
            'Caravan Passenger',
            'Caravan Cargo',
            'Dakota Quad Cab',
            'Dakota Club Cab',
            'Stratus',
            'Neon',
            'Dakota Regular Cab',
            'Intrepid',
            'Ram Van 1500',
            'Ram Van 2500',
            'Ram Van 3500',
            'Ram Wagon 2500',
            'Ram Wagon 1500',
            'Ram Wagon 3500',
            'Ram 1500 Club Cab',
            'Ram 2500 Club Cab',
            'Ram 3500 Club Cab',
            'Stealth',
            'Spirit',
            'Ram Van B250',
            'Ram Wagon B350',
            'Colt',
            'Ram Van B150',
            'Ram Van B350',
            'Ram Wagon B150',
            'Shadow',
            'Ram Wagon B250',
            'D350 Club Cab',
            'D250 Club Cab',
            'D150 Club Cab',
            'D350 Regular Cab',
            'D150 Regular Cab',
            'D250 Regular Cab',
            'Dynasty',
            'Ram 50 Regular Cab',
            'Daytona',
            'Ramcharger',
            'Monaco',
        ],
        categories: [
            'SUV',
            'Sedan',
            'Coupe',
            'Van/Minivan',
            'Wagon',
            'Pickup',
            'Convertible',
            'Hatchback',
        ],
    },
    {
        make: 'Jaguar',
        models: [
            'E-PACE',
            'I-PACE',
            'F-PACE',
            'F-TYPE',
            'XE',
            'XF',
            'XJ',
            'XK',
            'S-Type',
            'X-Type',
        ],
        categories: ['SUV', 'Convertible', 'Sedan', 'Wagon', 'Coupe'],
    },
    {
        make: 'Kia',
        models: [
            'Sorento',
            'Rio',
            'Sedona',
            'Optima',
            'Sportage',
            'Optima Hybrid',
            'Optima Plug-in Hybrid',
            'Telluride',
            'Forte',
            'Soul',
            'Stinger',
            'Niro',
            'Niro Plug-in Hybrid',
            'Cadenza',
            'K900',
            'Niro EV',
            'Soul EV',
            'Forte5',
            'Forte Koup',
            'Rondo',
            'Amanti',
            'Borrego',
            'Spectra',
            'Optima (2006.5)',
            'Sephia',
            'K5',
            'Seltos',
        ],
        categories: ['SUV', 'Sedan', 'Hatchback', 'Van/Minivan', 'Wagon', 'Coupe'],
    },
    {
        make: 'Land Rover',
        models: [
            'Discovery Sport',
            'Range Rover Evoque',
            'Range Rover Sport',
            'Range Rover',
            'Discovery',
            'Range Rover Velar',
            'LR4',
            'LR2',
            'LR3',
            'Freelander',
            'Discovery Series II',
            'Defender 90',
            'Defender 110',
        ],
        categories: ['SUV'],
    },
    {
        make: 'Lexus',
        models: [
            'ES',
            'LC',
            'LX',
            'RC',
            'GX',
            'IS',
            'GS',
            'LS',
            'UX',
            'NX',
            'RX',
            'CT',
            'HS',
            'LFA',
            'IS F',
            'SC',
        ],
        categories: ['Sedan', 'Coupe', 'SUV', 'Hatchback', 'Convertible'],
    },
    {
        make: 'Mercedes-Benz',
        models: [
            'GLS',
            'CLA',
            'G-Class',
            'C-Class',
            'GLA',
            'E-Class',
            'GLE',
            'GLC',
            'A-Class',
            'Mercedes-AMG C-Class',
            'CLS',
            'Mercedes-AMG CLA',
            'GLC Coupe',
            'Mercedes-AMG CLS',
            'Mercedes-AMG E-Class',
            'Mercedes-AMG GLE',
            'Mercedes-AMG G-Class',
            'Mercedes-AMG GLA',
            'Mercedes-AMG S-Class',
            'SL',
            'Mercedes-AMG GT',
            'Metris Passenger',
            'Mercedes-AMG GLE Coupe',
            'Mercedes-Maybach S-Class',
            'Mercedes-AMG GLC Coupe',
            'Sprinter 2500 Cargo',
            'S-Class',
            'Metris Cargo',
            'SLC',
            'Mercedes-AMG SLC',
            'Mercedes-AMG GLC',
            'Mercedes-AMG SL',
            'Mercedes-AMG GLS',
            'Sprinter 2500 Crew',
            'Metris WORKER Cargo',
            'Metris WORKER Passenger',
            'Sprinter 3500 XD Cargo',
            'Sprinter 2500 Passenger',
            'Sprinter WORKER Cargo',
            'Sprinter 3500 Cargo',
            'B-Class',
            'Sprinter WORKER Passenger',
            'CLS-Class',
            'GL-Class',
            'GLE Coupe',
            'Mercedes-Maybach S 600',
            'SLK',
            'Mercedes-AMG SLK',
            'M-Class',
            'CLA-Class',
            'GLK-Class',
            'GLA-Class',
            'SLS-Class',
            'SL-Class',
            'SLK-Class',
            'CL-Class',
            'R-Class',
            'CLK-Class',
            'SLR McLaren',
            '300 E',
            '190 E',
            '300 D',
            '300 SD',
            '300 CE',
            '500 SEL',
            '400 SEL',
            '500 SL',
            '500 E',
            '300 SL',
            '600 SEC',
            '300 TE',
            '400 E',
            '300 SE',
            '600 SL',
            '600 SEL',
            '500 SEC',
            '400 SE',
            'GLB',
        ],
        categories: ['SUV', 'Sedan', 'Convertible', 'Coupe', 'Wagon', 'Van/Minivan', 'Hatchback'],
    },
    {
        make: 'Mitsubishi',
        models: [
            'Outlander Sport',
            'Eclipse Cross',
            'Mirage G4',
            'Mirage',
            'Outlander',
            'Outlander PHEV',
            'Lancer',
            'i-MiEV',
            'Lancer Evolution',
            'Eclipse',
            'Galant',
            'Endeavor',
            'Raider Double Cab',
            'Raider Extended Cab',
            'Montero',
            'Diamante',
            'Montero Sport',
            '3000GT',
            'Mighty Max Regular Cab',
            'Expo',
            'Mighty Max Macro Cab',
            'Precis',
        ],
        categories: ['SUV', 'Sedan', 'Hatchback', 'Coupe', 'Convertible', 'Pickup', 'Wagon'],
    },
    {
        make: 'Lincoln',
        models: [
            'MKZ',
            'Aviator',
            'Navigator',
            'Corsair',
            'Navigator L',
            'Nautilus',
            'Continental',
            'MKT',
            'MKC',
            'MKX',
            'MKS',
            'Town Car',
            'Mark LT',
            'LS',
            'Zephyr',
            'Blackwood',
            'Mark VIII',
            'Mark VII',
        ],
        categories: ['Sedan', 'SUV', 'Pickup', 'Coupe'],
    },
    {
        make: 'MAZDA',
        models: [
            'CX-30',
            'MAZDA3',
            'CX-5',
            'MAZDA6',
            'CX-9',
            'MX-5 Miata RF',
            'MX-5 Miata',
            'CX-3',
            'MAZDA5',
            'MAZDA2',
            'CX-7',
            'RX-8',
            'Tribute',
            'B-Series Regular Cab',
            'B-Series Extended Cab',
            'MPV',
            'B-Series Cab Plus',
            'Protege5',
            'Protege',
            '626',
            'Millenia',
            'MX-6',
            'MX-3',
            '929',
            'RX-7',
            '323',
            'Navajo',
        ],
        categories: [
            'SUV',
            'Sedan',
            'Hatchback',
            'Convertible',
            'Van/Minivan',
            'Coupe',
            'Pickup',
            'Wagon',
        ],
    },
    {
        make: 'Nissan',
        models: [
            'Armada',
            'Kicks',
            'Murano',
            'NV3500 HD Passenger',
            'NV1500 Cargo',
            'Maxima',
            '370Z',
            'Altima',
            'GT-R',
            'NV3500 HD Cargo',
            'Pathfinder',
            'Rogue',
            'NV200',
            'Rogue Sport',
            'NV2500 HD Cargo',
            'Versa',
            'TITAN XD Crew Cab',
            'Titan Crew Cab',
            'Frontier King Cab',
            'Frontier Crew Cab',
            'LEAF',
            'Sentra',
            'TITAN Single Cab',
            'NV200 Taxi',
            'Titan King Cab',
            'TITAN XD Single Cab',
            'Versa Note',
            'TITAN XD King Cab',
            'Quest',
            'JUKE',
            'Rogue Select',
            'Xterra',
            'cube',
            '350Z',
            'Pathfinder Armada',
            'Frontier Regular Cab',
            '200SX',
            '240SX',
            'Regular Cab',
            'King Cab',
            '300ZX',
            'NX',
            'Stanza',
        ],
        categories: [
            'SUV',
            'Van/Minivan',
            'Sedan',
            'Coupe',
            'Convertible',
            'Pickup',
            'Hatchback',
            'Wagon',
        ],
    },
    {
        make: 'MINI',
        models: [
            'Countryman',
            'Convertible',
            'Hardtop 2 Door',
            'Hardtop 4 Door',
            'Clubman',
            'Paceman',
            'Coupe',
            'Roadster',
            'Hardtop',
            'Cooper',
        ],
        categories: ['SUV', 'Convertible', 'Hatchback', 'Coupe'],
    },
    {
        make: 'Porsche',
        models: [
            'Panamera',
            'Taycan',
            '911',
            'Macan',
            'Cayenne Coupe',
            'Cayenne',
            '718 Boxster',
            '718 Cayman',
            'Cayman',
            'Boxster',
            'Carrera GT',
            '968',
            '928',
            '718 Spyder',
        ],
        categories: ['Sedan', 'Convertible', 'SUV', 'Coupe', 'Hatchback'],
    },
    {
        make: 'Ram',
        models: [
            '3500 Crew Cab',
            '1500 Crew Cab',
            '2500 Crew Cab',
            '2500 Mega Cab',
            '1500 Classic Quad Cab',
            '1500 Classic Crew Cab',
            '1500 Classic Regular Cab',
            '1500 Quad Cab',
            '2500 Regular Cab',
            '3500 Mega Cab',
            'ProMaster Cargo Van',
            'ProMaster City',
            'ProMaster Window Van',
            '3500 Regular Cab',
            '1500 Regular Cab',
            'C/V Tradesman',
            'ProMaster 3500 Cargo',
            'ProMaster 2500 Cargo',
            'ProMaster 1500 Cargo',
            'C/V',
            'Dakota Crew Cab',
            'Dakota Extended Cab',
        ],
        categories: ['Pickup', 'Van/Minivan'],
    },
    {
        make: 'Subaru',
        models: [
            'BRZ',
            'WRX',
            'Impreza',
            'Ascent',
            'Legacy',
            'Crosstrek',
            'Forester',
            'Outback',
            'XV Crosstrek',
            'Tribeca',
            'B9 Tribeca',
            'Baja',
            'SVX',
            'Loyale',
            'Justy',
        ],
        categories: ['Coupe', 'Sedan', 'Wagon', 'SUV', 'Pickup', 'Hatchback'],
    },
    {
        make: 'Toyota',
        models: [
            'Avalon',
            'Camry',
            'Corolla Hatchback',
            'Corolla',
            '86',
            'Avalon Hybrid',
            '4Runner',
            'C-HR',
            'Camry Hybrid',
            'Corolla Hybrid',
            'GR Supra',
            'Highlander',
            'Prius',
            'Prius Prime',
            'RAV4',
            'Tacoma Access Cab',
            'Sienna',
            'Land Cruiser',
            'Yaris',
            'RAV4 Hybrid',
            'Highlander Hybrid',
            'Sequoia',
            'Tundra Double Cab',
            'Tacoma Double Cab',
            'Tundra CrewMax',
            'Yaris Hatchback',
            'Mirai',
            'Prius c',
            'Corolla iM',
            'Yaris iA',
            'Prius v',
            'Tundra Regular Cab',
            'Prius Plug-in Hybrid',
            'Venza',
            'FJ Cruiser',
            'Tacoma Regular Cab',
            'Matrix',
            'Solara',
            'Tundra Access Cab',
            'Celica',
            'Echo',
            'MR2',
            'Tacoma Xtracab',
            'Supra',
            'T100 Regular Cab',
            'T100 Xtracab',
            'Tercel',
            'Paseo',
            'Previa',
            'Regular Cab',
            'Xtra Cab',
            'Cressida',
            'RAV4 Prime',
        ],
        categories: [
            'Sedan',
            'Hatchback',
            'Coupe',
            'SUV',
            'Pickup',
            'Van/Minivan',
            'Wagon',
            'Convertible',
        ],
    },
    {
        make: 'Volkswagen',
        models: [
            'Passat',
            'Tiguan',
            'Jetta',
            'Atlas',
            'Golf SportWagen',
            'Arteon',
            'e-Golf',
            'Golf',
            'Golf GTI',
            'Jetta GLI',
            'Beetle',
            'Golf Alltrack',
            'Golf R',
            'Tiguan Limited',
            'CC',
            'Touareg',
            'Eos',
            'GTI',
            'Routan',
            'Jetta SportWagen',
            'New Beetle',
            'Rabbit',
            'Touareg 2',
            'GLI',
            'R32',
            'Phaeton',
            'Jetta (New)',
            'Eurovan',
            'Cabrio',
            'Passat (New)',
            'Cabrio (New)',
            'Golf (New)',
            'GTI (New)',
            'Golf III',
            'Jetta III',
            'Corrado',
            'Cabriolet',
            'Fox',
            'Atlas Cross Sport',
        ],
        categories: ['Sedan', 'SUV', 'Wagon', 'Hatchback', 'Convertible', 'Coupe', 'Van/Minivan'],
    },
    {
        make: 'Volvo',
        models: [
            'XC40',
            'XC60',
            'XC90',
            'S60',
            'V60',
            'V90',
            'S90',
            'S80',
            'XC70',
            'C30',
            'C70',
            'V50',
            'S40',
            'V70',
            'S40 (New)',
            'V40',
            'S70',
            '850',
            '960',
            '940',
            '240',
            '740',
        ],
        categories: [
            'SUV',
            'SUV1992',
            'Sedan',
            'Wagon',
            'SUV2020',
            'Hatchback',
            'Convertible',
            'Coupe',
        ],
    },
    {
        make: 'Alfa Romeo',
        models: ['4C Spider', 'Stelvio', 'Giulia', '4C', '164', 'Spider'],
        categories: ['Convertible', 'SUV', 'Sedan', 'Coupe'],
    },
    {
        make: 'FIAT',
        models: ['500L', '500e', '500', '500c', '500 Abarth', '124 Spider', '500X', '500c Abarth'],
        categories: ['Hatchback', 'Convertible', 'SUV'],
    },
    {
        make: 'Freightliner',
        models: [
            'Sprinter 2500 Cargo',
            'Sprinter 2500 Crew',
            'Sprinter 3500 Cargo',
            'Sprinter WORKER Cargo',
            'Sprinter 3500XD Cargo',
            'Sprinter 2500 Passenger',
            'Sprinter WORKER Passenger',
        ],
        categories: ['Van/Minivan'],
    },
    {
        make: 'Maserati',
        models: ['Levante', 'Ghibli', 'Quattroporte', 'GranTurismo', 'GranSport', 'Coupe'],
        categories: ['SUV', 'Sedan', 'Coupe', 'Convertible'],
    },
    {
        make: 'Tesla',
        models: ['Model X', 'Model 3', 'Model S'],
        categories: ['SUV', 'Sedan'],
    },
    {
        make: 'Aston Martin',
        models: [
            'Vanquish S',
            'DB11',
            'Rapide S',
            'Vanquish',
            'Vantage',
            'DB9 GT',
            'DB9',
            'Rapide',
            'DBS',
            'Virage',
        ],
        categories: ['Convertible', 'Coupe', 'Sedan'],
    },
    {
        make: 'Bentley',
        models: [
            'Bentayga',
            'Flying Spur',
            'Continental',
            'Mulsanne',
            'Azure T',
            'Brooklands',
            'Arnage',
            'Azure',
        ],
        categories: ['SUV', 'Sedan', 'Convertible', 'Coupe'],
    },
    {
        make: 'Ferrari',
        models: [
            'GTC4Lusso',
            '488 GTB',
            '812 Superfast',
            'Portofino',
            '488 Spider',
            'F12berlinetta',
            'California',
            'FF',
            '458 Italia',
            '458 Speciale',
            '458 Spider',
            '599 GTB Fiorano',
            '599 GTO',
            '612 Scaglietti',
            '430 Scuderia',
            'F430',
        ],
        categories: ['Hatchback', 'Coupe', 'Convertible'],
    },
    {
        make: 'Lamborghini',
        models: ['Huracan', 'Aventador', 'Gallardo', 'Murcielago', 'Murcielago LP640'],
        categories: ['Coupe', 'Convertible'],
    },
    {
        make: 'Lotus',
        models: ['Evora 400', 'Evora', 'Elise', 'Exige', 'Exige S'],
        categories: ['Coupe'],
    },
    {
        make: 'McLaren',
        models: ['570GT', '720S', '570S', '650S', '675LT', 'MP4-12C'],
        categories: ['Coupe', 'Convertible'],
    },
    {
        make: 'Rolls-Royce',
        models: ['Ghost', 'Wraith', 'Dawn', 'Phantom'],
        categories: ['Sedan', 'Coupe', 'Convertible'],
    },
    {
        make: 'smart',
        models: [
            'fortwo electric drive',
            'fortwo electric drive cabrio',
            'fortwo cabrio',
            'fortwo',
        ],
        categories: ['Hatchback', 'Convertible'],
    },
    {
        make: 'Scion',
        models: ['iA', 'tC', 'iM', 'FR-S', 'iQ', 'xB', 'xD', 'xA'],
        categories: ['Sedan', 'Coupe', 'Hatchback'],
    },
    {
        make: 'SRT',
        models: ['Viper'],
        categories: ['Coupe'],
    },
    {
        make: 'Suzuki',
        models: [
            'SX4',
            'Kizashi',
            'Grand Vitara',
            'Equator Extended Cab',
            'Equator Crew Cab',
            'XL7',
            'Reno',
            'Forenza',
            'Aerio',
            'XL-7',
            'Verona',
            'Vitara',
            'Esteem',
            'Swift',
            'Sidekick',
            'X-90',
            'Samurai',
        ],
        categories: ['Sedan', 'Hatchback', 'SUV', 'Pickup', 'Wagon'],
    },
    {
        make: 'Fisker',
        models: ['Karma'],
        categories: ['Sedan'],
    },
    {
        make: 'Maybach',
        models: ['62', '57'],
        categories: ['Sedan'],
    },
    {
        make: 'Mercury',
        models: [
            'Milan',
            'Mariner',
            'Grand Marquis',
            'Mountaineer',
            'Sable',
            'Montego',
            'Monterey',
            'Marauder',
            'Villager',
            'Cougar',
            'Mystique',
            'Tracer',
            'Capri',
            'Topaz',
        ],
        categories: ['Sedan', 'SUV', 'Van/Minivan', 'Wagon', 'Coupe', 'Convertible'],
    },
    {
        make: 'Saab',
        models: ['9-4X', '3-Sep', '5-Sep', '9-7X', '9-2X', '900', '9000'],
        categories: ['SUV', 'Sedan', 'Convertible', 'Wagon', 'Hatchback', 'Coupe'],
    },
    {
        make: 'HUMMER',
        models: ['H3T', 'H3', 'H2', 'H1'],
        categories: ['Pickup', 'SUV', 'Wagon'],
    },
    {
        make: 'Pontiac',
        models: [
            'Vibe',
            'G6',
            'G3',
            'G6 (2009.5)',
            'Solstice',
            'G8',
            'Torrent',
            'G5',
            'Grand Prix',
            'GTO',
            'Montana SV6',
            'Bonneville',
            'Aztek',
            'Grand Am',
            'Montana',
            'Sunfire',
            'Firebird',
            'Trans Sport',
            'Sunbird',
            'LeMans',
        ],
        categories: ['Wagon', 'Sedan', 'Hatchback', 'Coupe', 'Convertible', 'SUV', 'Van/Minivan'],
    },
    {
        make: 'Saturn',
        models: ['VUE', 'Outlook', 'Aura', 'SKY', 'Astra', 'Relay', 'Ion', 'L-Series', 'S-Series'],
        categories: ['SUV', 'Sedan', 'Convertible', 'Hatchback', 'Van/Minivan', 'Coupe', 'Wagon'],
    },
    {
        make: 'Isuzu',
        models: [
            'i-370 Extended Cab',
            'i-290 Extended Cab',
            'Ascender',
            'i-370 Crew Cab',
            'i-350 Crew Cab',
            'i-280 Extended Cab',
            'Axiom',
            'Rodeo',
            'Rodeo Sport',
            'Trooper',
            'VehiCROSS',
            'Amigo',
            'Hombre Spacecab',
            'Hombre Regular Cab',
            'Oasis',
            'Regular Cab',
            'Spacecab',
            'Stylus',
            'Impulse',
        ],
        categories: ['Pickup', 'SUV', 'Van/Minivan', 'Sedan', 'Hatchback'],
    },
    {
        make: 'Panoz',
        models: ['Esperante'],
        categories: ['Coupe', 'Convertible'],
    },
    {
        make: 'Oldsmobile',
        models: [
            'Bravada',
            'Alero',
            'Silhouette',
            'Aurora',
            'Intrigue',
            'Cutlass',
            'LSS',
            '88',
            'Achieva',
            'Regency',
            'Cutlass Supreme',
            'Ciera',
            '98',
            'Cutlass Ciera',
            'Cutlass Cruiser',
            'Toronado',
            'Custom Cruiser',
        ],
        categories: ['SUV', 'Coupe', 'Sedan', 'Van/Minivan', 'Wagon', 'Convertible'],
    },
    {
        make: 'Daewoo',
        models: ['Nubira', 'Leganza', 'Lanos'],
        categories: ['Sedan', 'Wagon', 'Hatchback'],
    },
    {
        make: 'Plymouth',
        models: [
            'Neon',
            'Grand Voyager',
            'Breeze',
            'Voyager',
            'Prowler',
            'Acclaim',
            'Laser',
            'Colt',
            'Colt Vista',
            'Sundance',
        ],
        categories: ['Sedan', 'Van/Minivan', 'Convertible', 'Coupe', 'Hatchback', 'Wagon'],
    },
    {
        make: 'Eagle',
        models: ['Talon', 'Vision', 'Summit', 'Premier'],
        categories: ['Hatchback', 'Sedan', 'Coupe', 'Wagon'],
    },
    {
        make: 'Geo',
        models: ['Metro', 'Prizm', 'Tracker', 'Storm'],
        categories: ['Coupe', 'Sedan', 'SUV', 'Hatchback', 'Convertible'],
    },
    {
        make: 'Daihatsu',
        models: ['Rocky', 'Charade'],
        categories: ['SUV', 'Sedan', 'Hatchback'],
    },
    {
        make: 'Polestar',
        models: ['2'],
        categories: ['Hatchback'],
    },
    {
        make: 'Rivian',
        models: ['R1S', 'R1T'],
        categories: ['SUV', 'Pickup'],
    },
];
export const carMake = allMake.map((item) => item.make);
export const carModels = (selectedMake) => {
    const carModel = allMake
        .filter((item) => item.make.toLocaleLowerCase() === selectedMake)
        .map((item) => item.models);
    return carModel[0];
};
export const vehicleAccessoriesType = [
    'Car Tuning & Styling',
    'Wheel Rims & Tyres',
    'Exterior Accessories',
    'Brakes, Suspension, Steering',
    'Engine & Drivetrain',
    'Headlights & Lighting',
    'Oils & Fluids',
    'Safety & Security',
    'Wheels & Parts',
    'Motorcycle Parts',
    'Interior Accessories',
    'In-Car Audio & GPS',
    'Watercraft & Boat Parts',
    'Clothes, Helmets & Boots',
    'Other',
];
export const otherVehicleType = [
    'LPG Tanks',
    'Forklifts',
    'Tractors',
    'Concrete Mixers',
    'Wheel Loaders',
    'Pneumatic Rollers',
    'Piling Machine',
    'Boom Lifts',
    'Bulldozers',
    'Dumpers Truck',
    'Excavators',
    'Pipe Layers',
    'Road Roller',
    'Scissor Lifts',
    'Storage Tanks',
    'Asphalt Pavers',
    'Crane Forks',
    'Crushers',
    'Drilling Rigs',
    'Farm Machines',
    'Graders',
    'Mobile Crusher',
    'Pallet Stackers',
    'Vibratory Rollers',
    'Concrete Pumps',
    'other',
];

// motorbike category
export const motorbikeMake = {
    6301: [
        'Honda',
        'TVS',
        'Bajaj',
        'Yamaha',
        'Qlink',
        'American Ironhorse',
        'Aprilia',
        'Apsonic',
        'Autodex',
        'Beach',
        'Benelli',
        'Bimota',
        'BMW',
        'Boss Hoss',
        'Buell',
        'CAD',
        'Can-Am',
        'CFMoto',
        'CityCoco',
        'Custom Built Motorcycles',
        'Daelim',
        'Daylong',
        'Dayun',
        'Denstar',
        'Ducati',
        'Evalast',
        'Focin',
        'Gilera',
        'Haojin',
        'Haojue',
        'Harley-Davidson',
        'Hero',
        'Husqvarna',
        'Hyosung',
        'Indian',
        'Jinan Qingqi',
        'Jincheng',
        'Kary-Go',
        'Kasea',
        'Kawasaki',
        'KR Motors',
        'KTM',
        'Kymco',
        'Kymstone',
        'Lifan',
        'Mahindra',
        'Max-S',
        'Moto Guzzi',
        'MTR',
        'Muoner',
        'Peugeot',
        'Piaggio',
        'Polaris',
        'Premier',
        'Royal',
        'Sanya',
        'Senke',
        'Sinoki',
        'Skygo',
        'Sonlink',
        'Super Gallant',
        'Suzuki',
        'SYM',
        'Toprich',
        'Tricycle',
        'Triumph',
        'Twinco',
        'Vento',
        'Zongshen',
        'Other',
    ],
    6302: [
        'Vespa',
        'Honda',
        'Piaggio',
        'Yamaha',
        'Suzuki',
        'TVS Motor',
        'Aprilia',
        'Kymco',
        'SYM',
        'Hero MotoCorp',
        'Bajaj Auto',
        'Peugeot',
        'Lambretta',
        'Genuine Scooters',
        'Royal Alloy',
        'SYMPL',
        'Gogoro',
        'Zero Motorcycles',
        'Ola Electric',
        'Segway-Ninebot',
        'Lime',
        'Other',
    ],
};
export const motorbikeType = [
    'Cruiser',
    'Dual Sport',
    'Motocross',
    'Quad (ATV)',
    'Retro',
    'Sport Bike',
    'Standard',
    'Touring',
    'Tricycle',
    'Other',
];

// properties
export const propertyType = {
    5104: [
        'Filling Station',
        'Terraced Duplex',
        'Shop',
        'Hotel',
        'Office Space',
        'Bakery',
        'Church',
        'Factory',
        'Fish Farm',
        'Garage',
        'Gas Plant',
        'Hall',
        'Hospital',
        'Hostel',
        'Laundry Business',
        'Open Space',
        'Pharmacy',
        'Plaza',
        'Poultry Farm',
        'Recreation Centre',
        'Restaurant',
        'Salons',
        'School',
        'Showroom',
        'Supermarket',
        'Tank Farm',
        'Warehouse',
        'Apartment',
        'Penthouse',
        'Villa',
        'Condo',
        'Maisonette',
        'Chalet',
        'Mini Flat',
        'House',
        'Block of Flats',
        'Room & Parlour',
        'Studio Apartment',
        'Bungalow',
        'Mansion',
        'Townhouse/Terrace',
        'Duplex',
    ],
    5105: [
        'Commercial Land',
        'Farmland',
        'Industrial Land',
        'Mixed-Use-Land',
        'Quarry',
        'Residential Land',
    ],
    5106: [
        'Apartment',
        'Penthouse',
        'Villa',
        'Condo',
        'Maisonette',
        'Chalet',
        'Mini Flat',
        'House',
        'Block of Flats',
        'Room & Parlour',
        'Bungalow',
    ],
    5108: [
        'Filling Station',
        'Terraced Duplex',
        'Shop',
        'Hotel',
        'Office Space',
        'Bakery',
        'Church',
        'Factory',
        'Fish Farm',
        'Garage',
        'Gas Plant',
        'Hall',
        'Hospital',
        'Hostel',
        'Laundry Business',
        'Open Space',
        'Pharmacy',
        'Plaza',
        'Poultry Farm',
        'Recreation Centre',
        'Restaurant',
        'Salons',
        'School',
        'Showroom',
        'Supermarket',
        'Tank Farm',
        'Warehouse',
    ],
    5109: [
        'Filling Station',
        'Terraced Duplex',
        'Shop',
        'Hotel',
        'Office Space',
        'Bakery',
        'Church',
        'Factory',
        'Fish Farm',
        'Garage',
        'Gas Plant',
        'Hall',
        'Hospital',
        'Hostel',
        'Laundry Business',
        'Open Space',
        'Pharmacy',
        'Plaza',
        'Poultry Farm',
        'Recreation Centre',
        'Restaurant',
        'Salons',
        'School',
        'Showroom',
        'Supermarket',
        'Tank Farm',
        'Warehouse',
    ],
    default: [
        'Apartment',
        'Penthouse',
        'Villa',
        'Condo',
        'Maisonette',
        'Chalet',
        'Mini Flat',
        'House',
        'Block of Flats',
        'Room & Parlour',
        'Studio Apartment',
        'Bungalow',
        'Mansion',
        'Townhouse/Terrace',
        'Duplex',
    ],
};
export const propertyFacilities = {
    5101: [
        'Wi-Fi',
        'Wardrobe',
        'Dining Area',
        'Tiled Floor',
        '24-hour Electricity',
        'Air Conditioning',
        'Chandelier',
        'Dishwasher',
        'Hot Water',
        'Kitchen Cabinets',
        'Pre-Paid Meter',
        'Refrigerator',
        'Microwave',
        'Pop Ceiling',
        'Sectionals',
        'TV',
        'Ensuite',
    ],
    5102: [
        'Wi-Fi',
        'Wardrobe',
        'Dining Area',
        'Tiled Floor',
        '24-hour Electricity',
        'Air Conditioning',
        'Chandelier',
        'Dishwasher',
        'Hot Water',
        'Kitchen Cabinets',
        'Pre-Paid Meter',
        'Refrigerator',
        'Microwave',
        'Pop Ceiling',
        'Sectionals',
        'TV',
        'Ensuite',
    ],
    5103: [
        'Wi-Fi',
        'Wardrobe',
        'Dining Area',
        'Tiled Floor',
        '24-hour Electricity',
        'Air Conditioning',
        'Chandelier',
        'Dishwasher',
        'Hot Water',
        'Kitchen Cabinets',
        'Pre-Paid Meter',
        'Refrigerator',
        'Microwave',
        'Pop Ceiling',
        'Sectionals',
        'TV',
        'Ensuite',
    ],
    5104: [
        'Wi-Fi',
        'Wardrobe',
        'Dining Area',
        'Tiled Floor',
        '24-hour Electricity',
        'Air Conditioning',
        'Chandelier',
        'Dishwasher',
        'Hot Water',
        'Kitchen Cabinets',
        'Pre-Paid Meter',
        'Refrigerator',
        'Microwave',
        'Pop Ceiling',
        'Sectionals',
        'TV',
        'Ensuite',
    ],
    5105: [
        'Electricity Supply',
        'Gas Supply',
        'Car Parking',
        'Domestic Sewage',
        'Rain Water Drainage',
        'Water Supply',
    ],
    5106: [
        'Electricity Supply',
        'Gas Supply',
        'Car Parking',
        'Domestic Sewage',
        'Rain Water Drainage',
        'Water Supply',
    ],
    5107: [
        'Wi-Fi',
        'Wardrobe',
        'Dining Area',
        'Tiled Floor',
        '24-hour Electricity',
        'Air Conditioning',
        'Chandelier',
        'Dishwasher',
        'Hot Water',
        'Kitchen Cabinets',
        'Pre-Paid Meter',
        'Refrigerator',
        'Microwave',
        'Pop Ceiling',
        'Sectionals',
        'TV',
        'Ensuite',
    ],
    5108: [
        'Electricity Supply',
        'Gas Supply',
        'Car Parking',
        'Domestic Sewage',
        'Rain Water Drainage',
        'Water Supply',
    ],
    5109: [
        'Electricity Supply',
        'Gas Supply',
        'Car Parking',
        'Domestic Sewage',
        'Rain Water Drainage',
        'Water Supply',
    ],
    default: [
        'Constant light',
        'Fully furnished',
        'Jacuzzi Bath',
        'Gated',
        'Furnished',
        'Parking Space',
        'Tarred Road',
        'Balcony',
        'Semi furnished',
        'En suites',
        'C of O',
        'Security',
        'other',
    ],
};

// services category
export const servicesType = {
    5201: [
        'Accounting',
        'Office Service',
        'Writing & Literature',
        'General Office Services',
        'Marketing',
        'Storage',
        'Health & Safety',
        'Courier Services',
        'Recruitment',
        'Advertising Agencies',
        'Leaflet Distribution',
        'Interpreting & Translation',
        'Secretarial Services',
        'Shipping',
        'Printing Services',
        'Tax & Financial services',
        'Other',
    ],
    5202: [
        'Griller',
        'Mesuya',
        'Nutritionist',
        'Restaurants and Bars',
        'Caterer',
        'Groceries',
        'Baker',
        'Chef',
        'Cook',
        'Others',
    ],
    5203: [
        'Photography & Film',
        'Cars & Transportation',
        'Catering & Services',
        'Organisers & Planners',
        'Entertainment',
        'Marquee Hire',
        'Other',
    ],
    5204: ['Babysitting', 'Nannies', 'Childminders', 'Creche', 'Other'],
    5205: [
        'Cleaners',
        'Property Maintenance Services',
        'Housekeepers',
        'Facility managers',
        'Interior Designers',
        'Satellite, Aerial & TV',
        'Drain & Pipe Cleaning',
        'Other',
    ],
    5206: [
        'Lessons',
        'Online',
        'Private Teacher',
        'Training',
        'Academic',
        'Driving Lessons & Instructors',
        'Music',
        'Other',
    ],
    5207: ['Seamstress', 'Tailoring', 'Dry Cleaning & Laundry', 'Other'],
    5208: [
        'Taxi Services',
        'Detailing Services',
        'Car Wash',
        'Auto-tuning Services',
        'Car Repair',
        'Other',
    ],
    5209: [
        'DJ & Disco Hire',
        'Entertainers',
        'Bands & Musicians',
        'Banqueting Facilities',
        'Sound Engineering',
        'Rental Equipments',
        'Music Production',
        'Master of Ceremony Services',
        'Other forms of entertainment',
        'Other',
    ],
    5210: ['Travel & tourism agent', 'Ticketing & Reservation', 'Other'],
    5211: [
        'Manufacturers',
        'Distributors',
        'Writing & Literature',
        'Wholesalers',
        'Retailers',
        'Other',
    ],
    5212: [
        'Business Name Registration',
        'Registration Services',
        'Registration of Business',
        'Preparation of Documents',
        'Legal Consultation',
        'Assignment Deed',
        'Contracts Drafting',
        'Legal Bookkeeping',
        'Land & Property Search',
        'Mediation and Arbitration',
        'Ownership Restructuring',
        'Product Registration',
        'Property Consultant',
        'Real Estate Transactions',
        'Representation of Interests',
        'Civil Proceedings',
        'Clients representation',
        'Sale Contracts',
        'Drafting and Negotiation of NDAs',
        'Review, Negotiation, and Drafting',
        'Trademark Register',
        'Vehicle License Registration',
        'Wills Drafting Services',
        'Other',
        'Mortgage Brokers',
        'Financial Advice',
        'Visa & Immigration',
        'Other',
    ],
    5213: [
        'Car Hire',
        'Bus & Coach',
        'Van & Truck Hire',
        'Taxi',
        'Chauffeur & Limousine Hire',
        'Vehicle Hire',
        'Coach Hire',
        'Other',
    ],
};
export const tutorialTopics = [
    'Entrepreneurship',
    'Instruments',
    'IT Certifications',
    'Online Education',
    '3D & Animation',
    'Algebra & Geometry',
    'Advertising',
    'Application Software',
    'Architectural Design',
    'Arts & Crafts',
    'Beauty & Make-Up',
    'Biology',
    'Blockchain & Cryptocurrency',
    'Business Intelligence',
    'Business Software',
    'CAD',
    'Calculus',
    'Career Development',
    'Chemistry',
    'Cloud Services',
    'Communication Skills',
    'Computer Systems Analyst',
    'Content Marketing',
    'Creativity',
    'Data Analysis',
    'Development Tools',
    'Digital Marketing',
    'Digital Photography',
    'Electrical Engineering',
    'English',
    'Fashion Design',
    'Fitness',
    'French',
    'Game Development',
    'German',
    'Graphic Design',
    'Information Technology',
    'IT Security',
    'Interior Design',
    'Management & Leadership',
    'Media',
    'Mobile Apps Development',
    'Network & Security',
    'Music Fundamentals',
    'Product Design',
    'Physics',
    'Product Marketing',
    'Programming Languages',
    'Project Management',
    'Real Estate',
    'Video Editing',
    'Test Prep',
    'Other',
];

// tradesman category
export const tradesmanType = {
    5803: [
        'Physical Security',
        'Electronic Security',
        'Cybersecurity',
        'Event Security',
        'Transportation & Cargo Security',
        'Asset Protection',
        'Private Investigation',
        'Event Security Planning',
        'Home Security',
        'Government & Public Security',
    ],
    5804: [
        'Cabinetry',
        'Roofer',
        'Repair and Restoration',
        'Home Renovator',
        'Deck and Porch',
        'Wooden Stairs and Railings',
        'Custom Woodworking',
        'Custom Millwork',
        'Design Services',
        'other',
    ],
    5805: [
        'Residential Interior Designer',
        'Commercial Interior Designer',
        'Hospitality Interior Designer',
        'Healthcare Interior Designer',
        'Kitchen and Bath Designer',
        'Retail Interior Designer',
        'Sustainable Interior Designer',
        'Universal Design Specialist',
        'Set Designer',
        'Corporate Interior Designer',
        'Color Consultant',
        'Furniture and Product Designer',
        'Luxury Interior Designer',
        'Minimalist Interior Designer',
        'Scandinavian Interior Designer',
        'Retro or Vintage Decorator',
        'Virtual Interior Designer',
        'Eclectic Decorator',
    ],
    5806: ['Funmigation', 'Cleaning'],
    5807: [
        'Preventative Maintenance',
        'Residential Drain',
        'Commercial Drain',
        'Emergency Plumbing Services',
        'Hygienic Drain',
        'Septic System Maintenance',
        'Sump Pump Maintenance',
        'Storm Drain',
        'Grease Trap',
        'Gutter and Downspout',
        'Sewer Line',
        'Drain Cleaning',
    ],
    5808: ['Installation', 'Repair', 'Diagnostics', 'Inspection'],
    5809: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
    ],
    5810: [
        'Fleet Maintenance',
        'Hybrid & Electric Vehicle Technicians',
        'Performance & Tuning Specialists',
        'Diesel Engine Technicians',
        'Tire Technicians',
        'Collision Repair Technicians',
        'HVAC',
        'Electrical & Electronics Technicians',
        'Engine Technician',
        'Transmission Technician',
        'Brake & Suspension Technician',
        'Automotive Diagnostic',
        'Automotive Service Technicians',
    ],
    5811: [
        'Cardio',
        'Basketball',
        'Circuit Training',
        'Dance',
        'Fitness',
        'Football',
        'Swimming',
        'Tennis',
        'Virtual Training',
        'Weight Training',
        'Yoga',
        'Other',
    ],
    5812: [
        'Specialized',
        'E-commerce',
        'Cold Chain',
        'Reverse Logistics',
        'Customs Brokerage & Compliance',
        'Supply Chain Consulting',
        'Inventory Management',
        'Warehousing & Distribution',
        'Transportation Services',
        'Delivery Services',
    ],
    5813: [
        'Network Solutions',
        'Software Development',
        'Cybersecurity',
        'Cloud Computing',
        'Data Management & Analytics',
        'IT Support & Help Desk',
        'Hardware Solutions',
        'Virtualization & Cloud Services',
        'IT Consulting',
        'IT Project Management',
        'ERP (Enterprise Resource Planning)',
        'IoT (Internet of Things)',
        'Digital Transformation',
    ],
};
export const tradesmanArea = {
    5802: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5804: ['Domestic', 'Industrial', 'Commercial', 'Real Estate', 'Corporate Sector', 'All'],
    5805: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5806: ['Residential', 'Industrial', 'Commercial', 'All'],
    5807: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5808: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Emergency',
        'Inspection & Code Compliance',
        'Specialized services',
        'All',
    ],
    5809: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5810: ['Nationwide', 'International', 'Locally', 'All'],

    5812: ['Nationwide', 'International', 'Locally', 'All'],
    5813: [
        'IT Consultation',
        'Training & Knowledge Transfer',
        'Scalability & Upgrades',
        'Monitoring & Maintenance',
        'Security & Compliance',
        'IT Support & Help Desk',
        'Data Management',
        'Cloud Services',
        'Network Setup & Security',
        'Software Development',
        'Procurement & Implementation',
        'Solution Design',
    ],
    default: ['Residential', 'Industrial', 'Commercial', 'All'],
};
export const tradesmanForms = {
    5811: ['Corporate', 'Group', 'Fitness Consultation', 'Pair', 'Personal'],
    5803: [
        'Physical Security',
        'Electronic Security',
        'Cybersecurity',
        'Event Security',
        'Transportation & Cargo Security',
        'Asset Protection',
        'Private Investigation',
        'Event Security Planning',
        'Home Security',
        'Government & Public Security',
    ],
    5809: [
        'Peel and Stick Tiling',
        'Outdoor Tiling',
        'Decorative Tiling',
        'Patterned Tiling',
        'Wood-Look Tiling',
        'Cement Tiling',
        'Terracotta Tiling',
        'Travertine Tiling',
        'Natural Stone Tiling',
        'Glass Tiling',
        'Porcelain Tiling',
        'Ceramic Tiling',
    ],
};

// pet category
export const petBreeds = {
    6001: [
        'American Eskimo',
        'Boerboel',
        'Caucasian Shepherd',
        'German Shepherd',
        'Lhasa Apso',
        'Affenpinscher',
        'Akita',
        'American Bulldog',
        'American Bully',
        'American English Coonhound',
        'American Pit Bull Terrier',
        'Australian Shepherd',
        'Australian Terrier',
        'Basenji',
        'Basset Hound',
        'Beagle',
        'Belgian Malinois',
        'Belgian Sheepdog',
        'Bichon Frise',
        'Bolognese',
        'Border Terrier',
        'Boston Terrier',
        'Boxer',
        'Bull Terrier',
        'Bulldog',
        'Bullmastiff',
        'Cane Corso',
        'Chihuahua',
        'Chinese Shar-Pei',
        'Chinook',
        'Chow Chow',
        'Cocker Spaniel',
        'Collie',
        'Coton de Tulear',
        'Dalmatian',
        'Doberman Pinscher',
        'Dogo Argentino',
        'Dutch Shepherd',
        'English Cocker Spaniel',
        'English Setter',
        'English Toy Spaniel',
        'Finnish Spitz',
        'Fox Terrier',
        'French Bulldog',
        'German Shorthaired Pointer',
        'Golden Retriever',
        'Great Dane',
        'Havanese',
        'Jack Russell Terrier',
        'Japanese Spitz',
        'Labrador Retrieve',
        'Maltese',
        'Maltese Shih Tzu',
        'Mastiff',
        'Mongrel (No Breed)',
        'Neapolitan Mastiff',
        'Pekingese',
        'Pembroke Welsh Corgi',
        'Pocket Beagle',
        'Pomeranian',
        'Poodle',
        'Pug',
        'Puggle',
        'Puli',
        'Rat Terrier',
        'Rhodesian Ridgeback',
        'Rottweile',
        'Saint Bernard',
        'Samoyed',
        'Shih Tzu',
        'Siberian Husky',
        'Soft Coated Wheaten Terrier',
        'Standard Schnauzer',
        'Tibetan Mastiff',
        'Tibetan Spaniel',
        'Tibetan Terrier',
        'West Highland White Terrier',
        'Other',
    ],
    6004: [
        'American Shorthair',
        'Exotic',
        'Persian',
        'American Wirehair',
        'Turkish Angora',
        'Abyssinian',
        'American Bobtail',
        'American Curl',
        'Balinese',
        'Bengal',
        'Birman',
        'Bombay',
        'British Shorthair',
        'Egyptian Mau',
        'Maine Coon',
        'Mongrel (No Breed)',
        'Ocicat',
        'Scottish Fold',
        'Siamese',
        'Siberian',
        'Snowshoe',
        'Tabby',
        'Turkish Van',
        'Other',
    ],
};
export const petTypes = {
    6002: ['Fish for aquariums', 'Air Stones', 'Air Blower', 'Fish for food', 'Other'],
    6003: [
        'Cages',
        'Pets foods',
        'Pet house',
        'The feeds',
        'Hygiene of Pets',
        'Toys',
        'Vitamins',
        'Collar',
        'Dog tag',
        'Leash',
        'Food and water bowls',
        'Harness',
        'Bed',
        'Poo bags (for walks)',
        'Crate and/or travel carrier',
        'Other',
    ],
    6005: [
        'Eagle',
        'Pigeon',
        'Finch',
        'Canary',
        'Crow',
        'Parrot',
        'Peacock',
        'Sparrow',
        'Woodpecker',
        'Other',
    ],
    default: ['Mixed Breed', 'Pure Breed'],
};

// agriculture category
export const agricultureTypes = {
    5301: [
        'All',
        'Fish',
        'Snails',
        'Sheeps',
        'Roosters',
        'Pigs',
        'Ostriches',
        'Guinea Fowls',
        'Geese',
        'Ducks',
        'Cane Rats',
        'Cows',
        'Turkeys',
        'Rabbits',
        'Fish',
    ],
    5302: [
        'Palm oil',
        'Rice',
        'Palm kernel',
        'Cassava',
        'Cocoa',
        'Corn',
        'Wheat',
        'Cowpea',
        'Soybean',
        'Cotton',
        'Beans',
        'Other',
    ],
    5303: [
        'Egg Incubators',
        'Knapsack Sprayers',
        'Fish Ponds',
        'Tarpaulin',
        'Irrigation Sprinklers',
        'Scales',
        'Cages',
        'Egg Incubators',
        'Hammer Mills',
        'Irrigation Hoses',
        'Milling Machines',
        'Power Tillers',
        'Rice Destoners',
        'Rice Reapers',
        'Seed Planters',
        'Seed Trays',
        'Weeding Machines',
        'Drinkers',
        'Tiling machine',
        'Filters',
        'Poultry Vaccinators',
        'Seed Trays',
    ],
    5304: [
        'Feeds',
        'Flower Seeds',
        'Supplements',
        'Vegetables Seeds',
        'Fruit Seeds',
        'Herb Seeds',
        'Perennia',
        'Other',
    ],
    5305: [
        'Feeds',
        'Flower Seeds',
        'Supplements',
        'Vegetables Seeds',
        'Fruit Seeds',
        'Herb Seeds',
        'Perennia',
        'Other',
    ],
};

// fashion category
export const fashionBrands = {
    5501: [
        'Louis Vuitton',
        'Alberto Fellini',
        'Adidas',
        'Prada',
        'Versace',
        'Gucci',
        'Air Jordan',
        'Ralph Lauren',
        'Aldo',
        'Balmain',
        'Zanotti',
        'Akube',
        'Aristocrats',
        'Balmain',
        'Ben Sherman',
        'Benetton',
        'Astley Clarke',
        'Armani',
        'Asics',
        'Diadora',
        'DKNY',
        'Dockers',
        'Dolce & Gabbana',
        'DC Shoes',
        'Dunnes',
        'Emporio Armani',
        'Everest',
        'F&F',
        'Fabi',
        'Nike',
        'Other',
    ],
    5503: [
        'Louis Vuitton',
        'Alberto Fellini',
        'Prada',
        'Versace',
        'Gucci',
        'Air Jordan',
        'Ralph Lauren',
        'Aldo',
        'Balmain',
        'Zanotti',
        'Akube',
        'Aristocrats',
        'Balmain',
        'Ben Sherman',
        'Benetton',
        'Astley Clarke',
        'Armani',
        'Asics',
        'Diadora',
        'DKNY',
        'Dockers',
        'Dolce & Gabbana',
        'DC Shoes',
        'Dunnes',
        'Emporio Armani',
        'Everest',
        'F&F',
        'Fabi',
        'Other',
    ],
    5504: [
        'Adore',
        'Affinity Diamond Jewelry',
        'Aldo',
        'Versace',
        'Alexander McQueen',
        'Alfani',
        'Amore',
        'Aldo',
        'Alpha',
        'Aker',
        'Anne Klein',
        'Apollo',
        'Balmain',
        'AURA',
        'Bead Bracelet',
        'Blackstone',
        'Armani',
        'Fendi',
        'Diadora',
        'DKNY',
        'Dockers',
        'Dolce & Gabbana',
        'Cerruti',
        'CHANEL',
        'Cartier',
        'Dior',
        'F&F',
        'Emporio Armani',
        'Other',
    ],
    5506: [
        'Rolex',
        'Hublot',
        'Cartier',
        'Patek Philippe',
        'Acnos',
        'Aigner',
        'Aimecor',
        'Alexandre Christie',
        'Alpha',
        'Aker',
        'Anne Klein',
        'Antoine Preziuso',
        'Apple Watch',
        'Armitron',
        'Baogela',
        'Baume & Mercier',
        'Bell & Ross',
        'Benma',
        'Benyar',
        'Bomberg',
        'Bos',
        'Dolce & Gabbana',
        'Bovet',
        'Bulova',
        'Cartier',
        'Dior',
        'F&F',
        'Emporio Armani',
        'Other',
    ],
    5507: [
        'Weddingstar',
        'Vera Wang',
        'Super Jeweler',
        'Versace',
        'S.L. Fashions',
        'R&M Richards',
        'Nina',
        'LEIN',
        'Jewel',
        'J Kara',
        'Ivory',
        'Grace Loves Lace',
        'Generic',
        'Fifteen Roses',
        'Fair Lady',
        'Ever-Pretty',
        'Aidan Maddox',
        'Amazon Essentials',
        "David's Bridal",
        'Adrianna Papell',
        'Amsale',
        'Atelier Emelia',
        'Claire Pettibone',
        'Emporio Armani',
        'Dreamgirl',
        'Chopard',
        'Fabi',
        'Other',
    ],
    default: [
        'Louis Vuitton',
        'Hermes',
        'Prada',
        'Versace',
        'Gucci',
        'Adire',
        'Ralph Lauren',
        'Aldo',
        'Balmain',
        'Zanotti',
        'Akube',
        'Asooke',
        'Balmain',
        'Ben Sherman',
        'Benetton',
        'Astley Clarke',
        'Armani',
        'Asics',
        'Other',
    ],
};
export const fashionTypes = {
    5501: [
        'Loafers',
        'Sandals',
        'Sneakers',
        'Slippers',
        'Boots',
        'Ballet Shoes',
        'Canvas',
        'Chelsea Boots',
        'Clogs',
        'Crocs',
        'Flip-Flops',
        'Brogues',
        'Football Boots',
        'Half Shoes',
        'Moccasins',
        'Slides',
        'Slingbacks Shoes',
        'Snow Boots',
        'Trainers',
        'Wedge Shoes',
        'Other',
    ],
    5503: [
        'Luggage & Travel Bags',
        'Handbags',
        'Shoulder Bags',
        'Backpacks',
        'Clutches',
        'Ankara Bags',
        'Baby & Diaper Bags',
        'Bags Accessories',
        'Baguette Bags',
        'Barrel Bags',
        'Beach Bags',
        'Bra & Lingerie Travel Cases',
        'Brady Bags',
        'Briefcases',
        'Bucket Bags',
        'Business Bags',
        'Carry-All Bags',
        'Chain Bags',
        'Clothes Storage Bags',
        'Crossbody Bags',
        'Doctor Bags',
        'Duffle Bags',
        'Envelope Bags',
        'Flap Bags',
        'Rope Bags',
        'Saddle Bags',
        'School Bags',
        'Tennis Bags',
        'Tote Bags',
        'Vanity Cases',
        'Acetate',
        'Bamboo',
        'Other',
        'Make-Up Bags & Organizers',
        'Lunch Bags',
        'Micro Bags',
        'Lunch Bags',
        'Laptop Bags & Cases',
        'Waist & Belt Bags',
        'Suitcases',
        'Mini Bags',
        'Satchel Bags',
        'Gym & Sport Bags',
        'Gift Bags',
        'Fishing Bags',
        'Flap Bags',
        'Rucksack',
        'Other',
    ],
    5504: [
        'Necklaces',
        'Bracelets',
        'Jewellery Sets',
        'Earrings',
        'Chains',
        'Bangles',
        'Beaded Jewelry',
        'Body Piercing Jewelry',
        'Brooches',
        'Choker Necklaces',
        'Costume Jewelry',
        'Ear Cuffs',
        'Cufflinks',
        'Ear Cuffs',
        'Jewellery Boxes',
        'Pendants',
        'Rings',
        'Stones & Beads',
        'Teeth Grills',
        'Wristbands',
        'Other',
    ],
    5507: [
        'Rings',
        'Bridal Dresses',
        'Suits',
        'Fans & Parasols',
        'Bouquets',
        'Belts & Sashes',
        'Bridal Hair Accessories',
        'Bridal Jewelry',
        'Bridal Robes',
        'Bridesmaid Dresses',
        'Bridesmaid Robes',
        'Handbags & Bags',
        'Fascinators',
        'Invitations',
        'Shoes',
        'Veils',
        'Wedding Gloves',
        'Wraps & Jackets',
        'Other',
    ],
    default: [
        'Fabrics',
        'Suits',
        'Polo',
        'Jeans',
        'Blouses',
        'Shirts',
        'Blazers',
        'Activewear & Sportswear',
        'Jackets & Coats',
        'Joggers',
        'Dresses',
        'Skirts',
        'Pants',
        'Sleepwear & Pyjamas',
        'Socks & Tights',
        'Sweatshirts & Hoodies',
        'Vests',
        'T-Shirts & Tanks',
        'Tuxedos',
        'Jalabiya',
        'Other',
    ],
};
export const fashionMaterials = {
    5504: [
        'Gold',
        'Leather',
        'Platinum',
        'Silver',
        'Stainless Steel',
        'Acrylic',
        'Cobalt',
        'Glass',
        'Nickel',
        'Niobium',
        'Palladium',
        'Rhodium',
        'Titanium',
        'Tungsten',
        'Zinc',
        'Other',
    ],
    5506: [
        'Aluminium',
        'Ceramic',
        'Faux Leather',
        'Genuine Leather',
        'Nylon',
        'Polyurethane',
        'Rubber',
        'Stainless Steel',
        'Wood',
        'Other',
    ],
    default: [
        'Voile',
        'Wool',
        'Silk',
        'Polyester',
        'Denim',
        'Cotton',
        'Synthetic',
        'Suede',
        'Velvet',
        'Polycotton',
        'Plastic',
        'Plush',
        'Organza',
        'Net',
        'Nylon',
        'Mesh',
        'Merino Wool',
        'Jersey',
        'Lycra',
        'Latex',
        'Leather',
        'Linen',
        'Flax',
        'Faux Silk',
        'Chiffon',
        'Fur',
        'Corduroy',
        'Brocade',
        'Acrylic',
        'Acetate',
        'Bamboo',
        'Other',
    ],
};
export const fashionSizes = {
    5501: ['35', '3', '37', '3', '39', '40', '41', '42', '43', '44', '45', '46', '47', 'Other'],
    default: ['XL', 'S', 'M', 'XXL', 'L', 'XS', '3XL', '4XL'],
};

// home category
export const homeBrands = {
    5701: [
        'Remington',
        'Relax',
        'Pure Comfort',
        'PUR',
        'Pulaski',
        'Pro-Tec',
        'Prime Line Products',
        'Prime',
        'Powerline',
        'Polywood',
        'Platt',
        'Pioneer',
        'Pillow Perfect',
        'Pillow Decor',
        'Petra',
        'Perfect Home',
        'Pearl',
        'PartyLite',
        'Panasonic',
        'OTC',
        'Oriental Furniture',
        'Olympic',
        'Office Star Products',
        'NEXT',
        'New Leaf',
        'Nest',
        'Napoleon',
        'Mouka',
        "Member's Mark",
        'MasterCraft',
        'Master',
        'Mainstays',
        'MacKenzie-Childs',
        'Lv',
        'Lux',
        'Lodge',
        'Lock & Lock',
        'Living Accents',
        'Ligne Roset',
        'Lifetime',
        'Life Mate',
        'LG',
        'Leisure',
        'Legacy',
        'LDR',
        "Lands' End",
        'Kitchen Craft',
        'Kingston Brass',
        'King',
        'Kidkraft',
        'Keebler',
        'Wildkin',
        'Whitmor',
        'Whitehall',
        'White Mountain',
        'Weston',
        'Westcool',
        'west elm',
        'WENKO',
        'WEN',
        'Wedgwood',
        'Weber',
        'Waxman',
        'Watts',
        'Wamsutta',
        'Wallace',
        'Walker',
        'WAGNER',
        'Vollrath',
        'VIVERE',
        'Vita Foam',
        'Villeroy & Boch',
        'Viking',
        'Vigo',
        'VIG Furniture',
        'Victory',
        'Victorian Heart',
        'Vantage',
        'Valspar',
        'Valley Forge',
        'Uttermost',
        'Unifoam',
        'Unbranded',
        'Umbra',
        'Ultra',
        'U-Line',
        'Typhoon',
        'Twinings',
        'Tvilum',
        'Tropitone',
        'Triton',
        'Tripp Lite',
        'Toro',
        'Room Essentials',
        'Roche Bobois',
        'Restoration Hardware',
        'Remington',
        'Relax',
        'Pure Comfort',
        'PUR',
        'Pulaski',
        'Pro-Tec',
        'Prime Line Products',
        'Prime',
        'Powerline',
        'Polywood',
        'Platt',
        'Pioneer',
        'Pillow Perfect',
        'Pillow Decor',
        'Petra',
        'Perfect Home',
        'Pearl',
        'PartyLite',
        'Panasonic',
        'OTC',
        'Oriental Furniture',
        'Olympic',
        'Office Star Products',
        'NEXT',
        'New Leaf',
        'Nest',
        'Timex',
        'Tiffany & Co.',
        'Thermos',
        'The Home Depot',
        'Texsport',
        'Tesco',
        'Terraillon',
        'Tennsco',
        'Techni Mobili',
        'Taymor',
        'Taylor',
        'Target',
        'Tango',
        'SUPRA',
        'Stylemaster',
        'Style Selections',
        'Stressless',
        'Stout',
        'Stool International',
        'Stilnovo',
        'Sticks',
        'Stickley',
        'Sterilite',
        'Stearns & Foster',
        'Stanley Furniture',
        'Stanley',
        'Spa Sensations',
        'Sorbus',
        'Sony',
        'Solo',
        'Solar',
        'SofaSofa',
        'Sloan',
        'Slipstick',
        'Sligh',
        'Sleep Number',
        'Skyline Furniture',
        'Skyline',
        'Skye',
        'SK',
        'Simonton',
        'Signature Collection',
        'Sierra',
        'Sharp',
        'Seville Classics',
        'Serta',
        'Sentry',
        'SEI',
        'Sears',
        'Sealy',
        'Sauder',
        'Sara Foam',
        'SAIT',
        'Safco',
        'SAC',
        'Rubbermaid',
        'RST',
        'Royce Clothing',
        'Royalty',
        'Royal Doulton',
        'Royal Comfort',
        'Royal',
        'ROXY',
        'SWING',
        'Standard',
        'Home Interiors',
        'General',
        'Zojirushi',
        'Zinus',
        'Zenith',
        'Zack',
        'Z Gallerie',
        'Winsome',
        'Windsor',
        'Wilton',
        'Wildon Home',
        'White',
        'Whalen',
        'Wesco',
        'Weave',
        'Village Wrought Iron',
        'Toshiba',
        'Titan',
        'Tilia',
        'Sunbrella',
        'Streamlight',
        'Stein World',
        'Simplex',
        'Rosenthal',
        'Murphy Bed Company',
        'Malibu',
        'Longaberger',
        'King Canopy',
        'Intex',
        'Great Outdoors',
        'Boss Office Products',
        'Better Homes & Gardens',
        'Arden',
        'Other',
        'Zuo Modern',
        'Zodiac',
        'Zodax',
        'Zephyr',
        'ZAR',
        'Za',
        'YORK',
        'Yankee Candle',
        'Yamazaki',
        'Yale',
        'X Rocker',
        'Wright',
        'WORX',
        'Worlds Apart',
        'World Industries',
        'Workforce',
        'Wooster',
        'Woodstock',
        'Wooden Mallet',
        'Woodbridge',
        'Wood-Mode',
        'Wolf',
        'WMF',
        'Winchester',
        'Willow Tree',
        'Williams-Sonoma',
        'Johnson',
        'Jem',
        'Jahnke',
        'Jackson Furniture',
        'Jackson',
        'iSi',
        'International Caravan',
        'InterDesign',
        'IKEA',
        'Ideal',
        'Human Touch',
        'Howard Elliott',
        'Household Essentials',
        'Hooker',
        'HON',
        'Homelite',
        'Homeline',
        'HoMedics',
        'Home Trends',
        'Home Essentials',
        'Hickory Chair',
        'Herman Miller',
        'Heartwood',
        'Handmade',
        'Guardian',
        'GTO',
        'Green Machine',
        'Gree',
        'Golden Mattress',
        'Global',
        'Gemini',
        'GE',
        'GARDENA',
        'Furgle',
        'Fred',
        'Franklin',
        'Formica',
        'Ford',
        'other',
    ],
    5702: [
        '3M',
        'Accurate',
        'ACE',
        'Master',
        'Thermos',
        'AbsorbaStone',
        'Accoutrements',
        'Acme',
        'AcuRite',
        'Adams',
        'Adler',
        'AEG',
        'aerolatte',
        'AeroPress',
        'Aicok',
        'Al-De-Chef',
        'Aladdin',
        'All American',
        'All Star',
        'All-Clad',
        'Amana',
        'AMCO',
        'Amco Houseworks',
        'American Harvest',
        'AMF',
        'Amway Queen',
        'Anchor Hocking',
        'Andrea by Sadek',
        'Anne Taintor',
        'Anolon',
        'Anova',
        'Apex',
        'Applica',
        'Aquatec',
        'Arcoroc',
        'Armstrong',
        'AROMA',
        'Arrow',
        'Artcraft',
        'ArtGlass',
        'Arthur Court',
        'Ashley Furniture',
        'Astra',
        'Astro',
        'Ateco',
        'Atlas',
        'Avanti',
        'Avon',
        'bamix',
        'Baumalu',
        'Bella',
        'Berndes',
        'Better Chef',
        'Better Homes',
        'Better Homes & Gardens',
        'Binatone',
        'BKR',
        'BLACK & DECKER',
        'BlenderBottle',
        'Blendtec',
        'BLOCK',
        'bobble',
        'BODUM',
        'Bond',
        'BonJour',
        'Bormioli Rocco',
        'Bosch',
        'Boyd',
        'Brabantia',
        'Breadman',
        'Breville',
        'Bron',
        'Brondell',
        'Bruno',
        'BUILT',
        'Bull',
        'Butler',
        'Cake Boss',
        'Calphalon',
        'Camry',
        'CAN',
        'Canon',
        'Carlton',
        'Carrier',
        'CENTURY',
        'Certified',
        'Champion',
        'Charcoal Companion',
        'Charles Viancin',
        'Chef Craft',
        "Chef'sChoice",
        'Circulon',
        'Clover',
        'Cole & Mason',
        'Coleman',
        'Container Store',
        "Cook's",
        "Cook's Essentials",
        'Cooking Concepts',
        'Cooper',
        'Corona',
        'Country Living',
        'Craftsman',
        'Creative Home',
        'CRISTEL',
        'Crock-Pot',
        'Crystal Quest',
        'Cuisinart',
        'CUTIPOL',
        'Daewoo',
        'Dartington',
        'Deco',
        'Delta',
        'DEMDACO',
        'Denby',
        'Deni',
        'Descoware',
        'Dickies',
        'Dior',
        'Disney',
        'DMT',
        'Dora',
        'Duck',
        'DURABLE',
        'Eagle',
        'ECHO',
        'EKCO',
        'Element',
        'Ello',
        "Emeril's",
        'Essential Home',
        'Euro Cuisine',
        'Euro-Pro',
        'Everbrit',
        'Evergreen Solar',
        'Fagor',
        'Falcon',
        'Fiesta',
        'Fit & Fresh',
        'FoodSaver',
        'Ford',
        'Franciscan',
        'GE',
        'Genius',
        'Golden Rabbit',
        'Good Cook',
        'Gorham',
        'Gotham Steel',
        'Gourmet Settings',
        "Grace's Teaware",
        'GreenPan',
        'Haier',
        'Hamilton Beach',
        'Hampton',
        'Hampton Forg',
        'Handmade',
        'Hanson',
        'Happycall',
        'Harris',
        'Hello Kitty',
        'Hexagon',
        'Hisense',
        'Hoffmaster',
        'Hoffritz',
        'Home Basics',
        'Home Collection',
        'Home Essentials',
        'Home Trends',
        'Hostess',
        'Hotpoint',
        'Hurom',
        'Igloo',
        'IKEA',
        'Imperia',
        'Instant Pot',
        'InterDesign',
        'International Silver',
        'JET',
        'Johnson Brothers',
        'Joseph Joseph',
        'Joy',
        'Joyoung',
        'Juiceman',
        'Jura',
        'Kenmore',
        'Kenwood',
        'King',
        'Kitchen Concepts',
        'Kitchen Craft',
        'Kitchen Selectives',
        'KitchenAid',
        'Kiwi',
        'Klean Kanteen',
        'Kohler',
        'Lansky',
        'Laurie Gates',
        'Le Creuset',
        "Leed's",
        'LEM',
        'LG',
        'Libbey',
        'Lucks',
        'Luminarc',
        'Lux',
        'Magic Chef',
        'Manna',
        'Martha Stewart',
        'Max Factory',
        'Maxi-Matic',
        'Maxim',
        'Melannco',
        'Melitta',
        "Member's Mark",
        'Midea',
        'Miele',
        'Mighty Mug',
        'Mikasa',
        'MOTIV',
        'Moulinex',
        'National',
        'Ninja',
        'Nordic Ware',
        'Noritake',
        'Norwex',
        'NOVA',
        'NuWave',
        'OMEGA',
        'ONEIDA',
        'OTOTO',
        'OXO',
        'Panasonic',
        'Paragon',
        'PARK',
        'Pasabahce',
        'Pasta Express',
        'Pelican',
        'Pentek',
        'Perfect Portions',
        'Philips',
        'Picnic at Ascot',
        'PME',
        'Polder',
        'Portobello',
        'Premier',
        'Primo',
        'Princess House',
        'Progressive International',
        'PUR',
        'Rachael Ray',
        'Rainbow',
        'Regal',
        'Richard Ginori',
        'Roland',
        'Royal Albert',
        'Royal Doulton',
        'Royal Prestige',
        'Royalty',
        'Rubbermaid',
        'Russell Hobbs',
        'SABATIER',
        'Sachi',
        'Salter',
        'Salton',
        'Sambonet',
        'Samsung',
        'SANYO',
        'Scanfrost',
        'Sharp',
        'Siam Tropical',
        'Signature Housewares',
        'SiliconeZone',
        'Silverline',
        'Simplicity',
        'Sistema',
        'Smart Planet',
        'SMEG',
        'Snapware',
        'Square D',
        'Stanley',
        'Steelite International',
        'Sticks',
        'Studio Nova',
        'Suehiro',
        'Summit',
        'Supreme',
        'Swann',
        'Tefal',
        'Thermador',
        'Thinksport',
        'Threshold',
        'Tiger',
        'Titan',
        'Tools of the Trade',
        'Toshiba',
        'Towle',
        'Tramontina',
        'Typhoon',
        'Ultimate Chopper',
        'Unbranded',
        'Unicorn',
        'Universal',
        'Vacmaster',
        'Victory',
        'Villeroy & Boch',
        'Vitamix',
        'VonShef',
        'Watts',
        'Weber',
        'Wedgwood',
        'Whirlpool',
        'White',
        'Wilton',
        'WinCo',
        'Wolf',
        'World Tableware',
        'Yoshihiro',
        'Zepter',
        'Ziploc',
        'Zodiac',
        'Zyliss',
        'Other',
    ],
    5704: [
        'Aqua',
        'Dettol',
        'Finish',
        'General',
        'Tide',
        'ACE',
        'Admiral',
        'Air Wick',
        'Ajax',
        'Alpine',
        'Ariel',
        'AROMA',
        'Astonish',
        'Best',
        'Blanco',
        'Bubbly',
        'Cheer',
        'Clorox',
        'Comet',
        'Comfort',
        'Dawn',
        'Dometic',
        'Downy',
        'Eagle',
        'eco+',
        'Ecozone',
        'Elbow Grease',
        'EnviroCare',
        'Essentials',
        'Eureka',
        'Fabuloso',
        'Fairy',
        'Febreze',
        'Flash',
        'Fresh',
        'Gain',
        'GE',
        'Handmade',
        'Hyper',
        'Kirkland',
        'Kirkland Signature',
        'Kitchen Cleaner',
        'Lysol',
        'Members Mark',
        'Method',
        'Neolife',
        'OxiClean',
        'Pampers',
        'Pearl',
        'Persil',
        'Pure Comfort',
        'Purex',
        'Reinex',
        'Royal',
        'Smart Living',
        'Sniper',
        'Solis',
        'Sticks',
        'Unbranded',
        'Vanish',
        'Wd-40',
        'White',
        'Wind Fresh',
        'Woolite',
        'Zep',
        'Other',
    ],
    5705: [
        'Better Homes',
        'Bexel',
        'Binatone',
        'BKR',
        'BLACK & DECKER',
        'BlenderBottle',
        'Blendtec',
        'BLOCK',
        'Blomberg',
        'Blum',
        'Bomann',
        'Bona',
        'Bonavita',
        'Bond',
        'Bosch',
        'Boscon',
        'Braun',
        'Breville',
        'Brita',
        'Bruno',
        'Buchymix',
        'BUILT',
        'BUNN',
        'Burn Jikokoa',
        'Burton',
        'Bush',
        'Bushburgh',
        'Cake Boss',
        'Calor',
        'Cambro',
        'CAMCO',
        'Camp Chef',
        'Camry',
        'CAN',
        'Candy',
        'Cannon',
        'Canon',
        'Carrier',
        'Carson',
        'Caso',
        'CBK',
        'CDN',
        'CENTURY',
        'Cepsa(Butano)',
        'Certified',
        'Champion',
        'Charcoal Companion',
        'Cheerpower',
        'Chef Craft',
        "Chef'sChoice",
        'Chemex',
        'Chicago Metallic',
        'Chigo',
        'Citizens',
        'Cliff',
        'Clover',
        'Cntronic',
        'Coaster',
        'Cobra',
        'Comark',
        'Container Store',
        "Cook's",
        "Cook's Companion",
        "Cook's Essentials",
        'Cooking Concepts',
        'Cookwork',
        'Cooper',
        'Corona',
        'CRISTEL',
        'Crock-Pot',
        'Cway',
        'Daewoo',
        'Daichi',
        "De'Longhi",
        'Deco',
        'Delta',
        'Deluxe',
        'Dessini',
        'Digitrex',
        'Dove',
        'Dsp',
        'Dualit',
        'Dunelm',
        'Dura Volt',
        'DURABLE',
        'Dzire',
        'EKCO',
        'Elb',
        'Electra',
        'Electriq',
        'Electrolux',
        'Elite Products',
        'Emel',
        'Rite-tek',
        'Rohnson',
        'Royal Albert',
        'Royal Doulton',
        'Royal Family',
        'Royal Prestige',
        'Royal Swiss',
        'Royaltek',
        'Royaltronic',
        'Royalty',
        'Russ',
        'Russell Hobbs',
        'Saint Martins',
        'Saisho',
        'Salter',
        'Samsung',
        'Sandford',
        'Sanford',
        'SANYO',
        'Savanna',
        'Sayona',
        'Scanfrost',
        'SCANPAN',
        'Scarlett',
        'SCHOTT ZWIESEL',
        'Setro',
        'Severin',
        'Sf-400',
        'Shake And Take',
        'Sharp',
        'Sharper Image',
        'Siemens',
        'SiliconeZone',
        'Silver Crest',
        'Silverline',
        'Sinbo',
        'Sky-Oppien Turkey',
        'Skybar',
        'Skyline',
        'Sliver Crest',
        'Smart Home',
        'Smart Planet',
        'SMEG',
        'Smiths',
        'Snowsea',
        'Sokany',
        'Sonifer',
        'Sonik',
        'Sony',
        'Sq Professional',
        'Starlux',
        'Startek',
        'Sterling',
        'Stirling',
        'Su Tai',
        'Sunnex',
        'Super Crown',
        'Supersony',
        'Supreme',
        'Sur La Table',
        'Swan',
        'Swann',
        'Sweethome',
        'Syinix',
        'T.O.P.',
        'Taurus',
        'Tcl',
        'Techno Cool',
        'Tecno Cool',
        'Tefal',
        'Thermocool',
        'ThermoPro',
        'Thermos',
        'Tiger',
        'Toastmaster',
        'Tokunbo',
        'Tornado',
        'Toshiba',
        'Total Gas',
        'Towle',
        'Trifone',
        'Trinity',
        'Tristar',
        'Ugasun',
        'Ultimate Chopper',
        'Unbranded',
        'Universal',
        'Usha',
        'Vacuum Sealer',
        'Vera Wang',
        'Veronica',
        'Vertex',
        'Vinikiz',
        'Vitamix',
        'Vivateck',
        'VonShef',
        'Vtcl',
        'Waring',
        'Watts',
        'Westcool',
        'Westpoint',
        'Whirlpool',
        'White',
        'WinCo',
        'Winning Star',
        'Xper',
        'Yam Pounder',
        'Yohako',
        'Zanussi',
        'Zenker',
        'Zitalo',
        'Essential Home',
        'Euro Premium',
        'Euro-Pro',
        'Eurosonic',
        'Microwave',
        'Excella',
        'Fadar Plus',
        'Fagor',
        'Falcon',
        'Flavia',
        'Flavorwave',
        'Flourish',
        'FoodSaver',
        'Freezeclime',
        'Freshware',
        'Fridgemaster',
        'Frigidaire',
        'Fruit Press',
        'Gaggia',
        'GANZ',
        'Gas Cooker',
        'Gas Land',
        'Gasa',
        'Gates',
        'GE',
        'Geepas',
        'Gemat',
        'Genius',
        'George Foreman',
        'George Home',
        'Gibson',
        'Gift Master',
        'Glamstar',
        'Goldcrown',
        'Goldencrown',
        'Good Cook',
        'Gotham Steel',
        'Gourmet Settings',
        'Gourmia',
        'Gs',
        'GSR',
        'Haeger',
        'Haier',
        'Haier Thermocool',
        'Hamilton Beach',
        'Hana',
        'Handmade',
        'Happy Home',
        'Happycall',
        'Harri',
        'Havells',
        "Heinrich'S",
        'Henkel',
        'Hicel',
        'Hitachi',
        'Hobart',
        'Hoffman',
        'Hoffmaster',
        'Hoffner',
        'Home Basics',
        'Home Collection',
        'Home Essentials',
        'Home Styles',
        'Home Trends',
        'Homeflower',
        'Hoomex',
        'Hoover',
        'Horizon',
        'Hotpoint',
        'Hubert',
        'Hunter',
        'Hurom',
        'Husky',
        'Ideal',
        'Igloo',
        'Ignis',
        'IKEA',
        'IMAGE',
        'Indesit',
        'Instant Pot',
        'Itel',
        'Jd Smp',
        'Jenn-Air',
        'Jikokoa',
        'Johnson Brothers',
        'Joyoung',
        'Juiceman',
        'Kalorik',
        'Kanwood',
        'Kanzi',
        'Kenmore',
        'Kenstar',
        'Kilner',
        'Kinelco',
        'King',
        'King Kooker',
        'King Style',
        'Kitchen Concepts',
        'Kitchen Craft',
        'Kitchen Genie',
        'Kitchen Selectives',
        'KitchenAid',
        'KitchenIQ',
        'Krups',
        'Kuhn Rikon',
        'KUVINGS',
        'Lady Choice',
        'Lavazza',
        'Lec',
        'Legacy',
        'Legend',
        'Lexical',
        'Lexmark',
        'Liebherr',
        'Linkrich',
        'Logik',
        'Lontor',
        'Lux',
        'MAC Knife',
        'Madesmart',
        'Magic',
        'Magic Bullet',
        'Magic Chef',
        'Magic Mill',
        'Manna',
        'Marts Mac',
        'Master',
        'Master Chef',
        'Max Factory',
        'Maxi',
        'Maxi-Matic',
        'Maxim',
        'Maytag',
        'Medion',
        'Midea',
        'Miele',
        'Mika',
        'Mikachi',
        'Mikasa',
        'Montel',
        'Morphy Richards',
        'Mossy Oak',
        'Moulinex',
        'Mpm',
        'Mr. Steel',
        'Murphy Richards',
        'Nakai',
        'National',
        'NESCO',
        'Nespresso',
        'Nesta',
        'Newage',
        'Newcastle',
        'Newmatic',
        'Newtrend',
        'Nexus',
        'Nikai',
        'Nima',
        'Ninja',
        'Nobility Plate',
        'NOVA',
        'Nulek',
        'NutriBullet',
        'NuWave',
        'Omaha',
        'OMEGA',
        'Opaicn',
        'Oraimo',
        'Orienth',
        'Other Brand',
        'Otheritage',
        'Ottimo',
        'Padex',
        'Paloma',
        'Panasonic',
        'Petra',
        'Phiima',
        'Philips',
        'Phima',
        'Pinnacle',
        'PolyScience',
        'Polystar',
        'Power Deluxe',
        'Powerline',
        'Premier',
        'Prestige',
        'Presto',
        'Prime',
        'Primo',
        'Privilege',
        'Progress',
        'Rico',
        'Proline',
        'Pyramid',
        'Qasa',
        'Qlink',
        'Qualy',
        'Quinix',
        'Rada Cutlery',
        'Radof',
        'Raf',
        'Rangemaster',
        'Rangemate',
        'Rinnai',
        'Rashnik',
        'Regency',
        'Repsol',
        'Respoint',
        'Restpoint',
        'Other',
    ],
    5706: [
        'Home Interiors',
        'Powerline',
        'Royal Heritage',
        'VIP',
        'Abercrombie & Ferguson',
        'Adairs',
        'Adairs Kids',
        'Adam Home',
        'Adams',
        'AFC',
        'Agent Provocateur',
        'Agiville',
        'Air Wick',
        'AirCloud',
        'Akai',
        'Akt',
        'Aladdin',
        'Alamode Home',
        'Alfresco',
        'Allen',
        'ALLURE',
        'Aloha',
        'Alpine',
        'AmazonBasics',
        'Ambesonne',
        'Ambiance',
        'AmeliaHome',
        'Amity Home',
        'Amsons',
        'Amy Butler',
        'Andersen',
        'Anka',
        'ANN',
        'Ann Gish',
        'Anna Griffin',
        'Anne Stokes',
        'Any',
        'Apartmento',
        'Apc',
        'Apex',
        'April Cornell',
        'Archipelago',
        'Arctic',
        'Ardor',
        'Argos Home',
        'ARIGHTEX',
        'Ariston',
        'ARK',
        'Aromatique',
        'Artistic Accents',
        'Arya',
        'Ashley Furniture',
        'At Home',
        'Atlantique',
        'Authentic Models',
        'Avondale Manor',
        'Balenciaga',
        'Bali',
        'BALL',
        'Baloo',
        'Bambury',
        'Bar III',
        'Bare Home',
        'Baseus',
        'Bassett',
        'BeA',
        'Beautissu',
        'Becky Cameron',
        'Bed Bath & Beyond',
        'Bedding House',
        'BeddingOutlet',
        'Bedmaker',
        'Bedsure',
        'Beldray',
        'bella notte',
        'Bella Russo',
        'Bellora',
        'Bespoke',
        'BHS',
        'Binatone',
        'Bird',
        'Bktd',
        'Blancho Bedding',
        'BlessLiving',
        'bluebellgray',
        'Bluestone',
        'Bond',
        'Borg',
        'Brandream',
        'Brayden Studio',
        'Brentwood',
        'BRIELLE',
        'Brimix',
        'Brother',
        'Bull',
        'Bulldog',
        'Burlington',
        'Bush',
        'BW',
        'Cabbages & Roses',
        'California Design Den',
        'Calming Comf',
        'Candy',
        'Unbranded',
        'Unifoam',
        'Urban Unique',
        'VCNY',
        'VCNY HOME',
        'Vellmax',
        'Vemax',
        'Veratex',
        'Veron',
        'Versace',
        'Victoria',
        'Victoria Classics',
        'vidaXL',
        'Viking',
        'Vintage Design Homewares',
        'Vintage Maison',
        'Vita Supreme',
        'Vitafoam',
        'Vital Choice',
        'Vue',
        'Wallace',
        'Water Drum',
        'Waterford',
        'Westex',
        'WestPoint Home',
        'Westport',
        'Where The Polka Dots Roam',
        'White',
        'Whitney Home Textile',
        'Wildon Home',
        'Williams Sonoma Home',
        'Windsor',
        'Wolf',
        'Wongs Bedding',
        'Woolric',
        'Word of Dream',
        'Wright',
        'WWE',
        'Xforc',
        'Xg',
        'Xhilaration',
        'YEPINS',
        'Yh',
        'YnM',
        'YORK',
        'Yves Delorme',
        'Z Gallerie',
        'ZAR',
        'ZENSATIO',
        'ZHH',
        'Zodiac',
        'Cannon',
        'Carisder',
        'Caroline',
        'Casablanca',
        'Case',
        'Casper',
        'CAT',
        'Cathay Home',
        'Catimini',
        'Celine Linen',
        'Centa-Star',
        'Century',
        'Cepia',
        'Champion',
        'Charisma',
        'Charlton Home',
        'Chezmoi Collection',
        'Christy',
        'City Scene',
        'CL',
        'Classic Home',
        'Clean',
        'Clorox',
        'Cloth & Canopy',
        'CLOTHKNOW',
        'Clover',
        'Coastal',
        'Coca-Cola',
        'Cocoon',
        'Coleman',
        'Colourful Snail',
        'Comfort Spaces',
        'Company Kids',
        'Cooper',
        'Cotton House',
        'Cottonbox Kids',
        'Country Curtains',
        'Covers & Co',
        'Coyuchi',
        'CRAFT',
        'Creative Home',
        'Crystal',
        'CTI',
        'Ctorch',
        'Cubby House Kid',
        'Cuddledown',
        'D. Porthault',
        'D.light',
        'Dansk',
        'DaVinci',
        'DC',
        'DEA',
        'Debenham',
        'Deco',
        'Deny',
        'Descanso',
        'Design Art',
        'Design Port',
        'Designers Choice',
        'Designers Guild',
        'Disney',
        'Dobnig',
        'Dolce Mela',
        'Dolphin',
        'Donna Karan',
        'Dora',
        'DORMA',
        'Dp',
        'Dreaming Wapiti',
        'Duck',
        'DURABLE',
        'Eagle',
        'EASELAND',
        'Eastern Accents',
        'EasyFit',
        'ECHO',
        'Ecko',
        'Ecomin',
        'EDS',
        'Egyptian Bedding',
        'Elegance',
        'Elegant Comfort',
        'Elegant Home',
        'ELEMENTS',
        'Elepaq',
        'Elite Home Products',
        'Elite Products',
        'Empire',
        'en Vogue',
        'EnvioHome',
        'Essential Home',
        'Essentials',
        'Essina',
        'Estella',
        'Everyday',
        'Expressions',
        'Fab Organizers',
        'FABRIC FANTASTIC',
        'Family',
        'Fashion',
        'Fast',
        'FenDie',
        'Fine Linens',
        'Finlayson',
        'Firman',
        'Florence Broadhurst',
        'Fred',
        'Frette',
        'Frontgate',
        'GABEL',
        'GANZ',
        'Garnet Hill',
        'Geepee',
        'General',
        'Genie',
        'George',
        'Goldwell',
        'Goodcom',
        'Grand Hotel',
        'Gree',
        'Green Lion',
        'GSR',
        'Hampton',
        'Handboss',
        'Handicraft-Palace',
        'Handmade',
        'Happy Kids',
        'Happy Linen Company',
        'Harmony',
        'Harris',
        'Harrods',
        'HC COLLECTION',
        'Heart of House',
        'Hearth & Hand with Magnolia',
        'Hisense',
        'Hobby',
        'Hollander',
        'Home and Living',
        'Home Collection',
        'Home Decorators Collection',
        'Home Essence',
        'Home Essentials',
        'Homebase',
        'HOMEIDEAS',
        'Homescapes',
        'Hotel Collection',
        'House & Home',
        'Huawei',
        'Hunter',
        'Ideal',
        'IKEA',
        'Imex',
        'Imperial Rooms',
        'In Home',
        'Ingco',
        'Intelligent Design',
        'Italian Bed Linen',
        'Itel',
        'Iwin',
        'Jay Franco and Sons, Inc.',
        'JML',
        'John Lewis',
        'Just Home',
        'K Living',
        'KA',
        'Kamisafe',
        'Karcher',
        'Kaws',
        'Kenwood',
        'Kenyon',
        'Kiki',
        'KIND',
        'King',
        'KingLinen',
        'Kirkland',
        'Kitbag',
        'Koo',
        'Latitude Run',
        'Ldnio',
        'lemontree',
        'LG',
        'Liberty',
        'LIFEREVO',
        'Lifesmart',
        'Linden Street',
        'Linear',
        'Lobster Creek',
        'Lonen',
        'Lontor',
        'Loris',
        'Louisiana Bedding',
        'Lux',
        'Lux Decor Collection',
        'Lynx',
        'M&Co',
        'Marie Claire',
        'Martex',
        'Marvel',
        'Master',
        'Matt & Rose',
        'Maxim',
        "Member's Mark",
        'Mercer',
        'Mercury',
        'Merit Linens',
        'Merryfeel',
        'Midea',
        'Millefiori Milano',
        'Mindy',
        'Mixinini',
        'Mmaat',
        'Moon',
        'Moonlight Bedding',
        'Morris',
        'Morrisons',
        'Mothercare',
        'Mouka',
        'Mouka Foam',
        'Mucalis',
        'My World',
        'Natural Comfort',
        'Nautica',
        'Nedens',
        'Nest',
        'New Haven',
        'New Look',
        'Newgain',
        'Newline',
        'NEXT',
        'Night Comfort',
        'Noble Excellence',
        'Nordisk',
        'Normal Bedcover',
        'Nova',
        'Oake',
        'Oraimo',
        'Orange',
        'Orient Sense',
        'Orl',
        'Osram',
        'Ox',
        'Panasonic',
        'Papillon',
        'Patricia Rose',
        'Pearl',
        'Pendleton',
        'Pennine',
        'Pest Reject',
        'Peter Reed',
        'Philips',
        'Pillowfort',
        'Polystar',
        'Portobello',
        'Potter',
        'PRADA',
        'Premier',
        'Prime',
        'Prolinen',
        'PUR',
        'Pure Comfort',
        'Qasa',
        'Rachael Ray',
        'Rainbow',
        'Ralph Lauren',
        'Red Nomad',
        'Regency',
        'Republic',
        'RiNGLEY',
        'Room Essentials',
        'Rosebys',
        'Royal Comfort',
        'Royal Tradition',
        'Sacvin',
        'Scanfrost',
        'Scotsman',
        'Senwei',
        'Serena & Lily',
        'Shark',
        'Sheridan',
        'Shoe Rack',
        'Sia',
        'Signature Bedding',
        'Sijo',
        'Silentnight',
        'Silver',
        'Silver Crest',
        'Silverline',
        'Simon',
        'Simple Luxury',
        'Simplicity',
        'SK',
        'Sleep & Beyond',
        'Sleepcomfort',
        'SLEEPSCENE',
        'Sleeptime',
        'Sleepwell',
        'SNURK',
        'Softan',
        'Sokany',
        'Sona',
        'Sonia Moer',
        'Sonia Rykiel',
        'Sonik',
        'Sony',
        'Spiral',
        'Splendid',
        'Stanle',
        'Sterling',
        'Studio 3B',
        'Style & co',
        'Sumec Fireman',
        'Sunway',
        'Superior',
        'Supreme bedding',
        'Sutefoto',
        'Swan',
        'Sweet Home Collection',
        'Swift Home',
        'TAG',
        'Target',
        'TEC',
        'Ted Baker',
        'The Bed Linen Store',
        'The Better Sleep Company',
        'The Big Sleep',
        'The Company Store',
        'The Industrial Shop',
        'Thermocool',
        'Thermolineo',
        'Thomasville',
        'Threshold',
        'TJC',
        'Todd English',
        'Tommy Hilfiger',
        'Top Breeze',
        'Town',
        'Tranquility',
        'Trina Turk',
        'Truly Soft',
        'Tuya',
        'Ultra',
        'Other',
    ],
    5707: [
        'CENTURY',
        'Hisense',
        'LG',
        'Ox',
        'Panasonic',
        '2gig',
        '3M',
        '3Q',
        '4walls',
        'A&Bt',
        'Accubrush',
        'Accumulair',
        'Accuride',
        'Accuspray',
        'ACE',
        'Acme',
        'AcuRite',
        'Adams',
        'ADT',
        'Advantage',
        'AEG',
        'AEON',
        'Aero-Flo',
        'Aerus',
        'African Master',
        'Afrione',
        'Agri-Fab',
        'AIMS Power',
        'Air King',
        'Air Vent',
        'Air Wick',
        'Airfree',
        'Airlessco',
        'Akai',
        'Akira',
        'Akt',
        'Aladdin',
        'ALEKO',
        'Alfa',
        'Alfi',
        'All Star',
        'Allen',
        'Allen + Roth',
        'AllerAir',
        'Allis-Chalmers',
        'ALLURE',
        'ALNO',
        'Alpine',
        'Alsons',
        'Amaecom',
        'Amarr',
        'Amazon',
        'Amcor',
        'American Standard',
        'American Tourister',
        'AmerTac',
        'AMETEK',
        'AMF',
        'AMP',
        'Amtech',
        'Amway',
        'Andrakk',
        'Anker',
        'Anysew',
        'Apc',
        'Apex',
        'Apollo',
        'Apple',
        'Aqua Mix',
        'AquaSource',
        'Arctic',
        'Arctic Air Ultra',
        'Arctic King',
        'Argo',
        'Ariel',
        'Ariston',
        'ARK',
        'Aroma Coffee',
        'Arrow',
        'Astro',
        'Atlantic',
        'Atlas Homewares',
        'Aube',
        'Aucma',
        'Avon',
        'B-P',
        'Bai',
        'Bajaj',
        'Banan Appeal',
        'Baseus',
        'Baxi',
        'Bayco',
        'Bb',
        'BeA',
        'Beautiful',
        'Beckett',
        'Behr',
        'Beko',
        'Beldray',
        'Belkin',
        'Belwith',
        'Bemis',
        'Best Buy',
        'Bestek',
        'Beyond',
        'Bianco',
        'Bianco Power',
        'Binatone',
        'Bionaire',
        'BISSELL',
        'Black & Decker',
        'Blanco',
        'Blueair',
        'Bluegate',
        'BluWorld',
        'Blyss',
        'Bomann',
        'Bond',
        'Bosch',
        'Boscon',
        'Bostitch',
        'Bradley',
        'Braun',
        'Bravo',
        'Brentwood',
        'Breville',
        'Bright',
        'Brimix',
        'Brookstone',
        'Brother',
        'Bruce',
        'Bruhm',
        'BT',
        'Buddyfly',
        'Burnham Commercial',
        'Bush',
        'Butterfly',
        'C Power',
        'CAMCO',
        'Camry',
        'CAN',
        'Canadian Solar',
        'Candy',
        'Carlton',
        'Caroma',
        'Carrier',
        'Challenge',
        'Challenger',
        'Chicago Electric',
        'Chigo',
        'Citel',
        'Citizen',
        'Classic Home',
        'Cloud',
        'Coleman Cable',
        'Comfortaire',
        'Cooper',
        'Corolla',
        'Crossfire',
        'Crown',
        'Crownstar',
        'Cway',
        'Daewoo',
        'Daikin',
        'Danyo',
        'DBL',
        'Ddk 995+',
        'Deco',
        'Delta',
        'DEWALT',
        'Dimplex',
        'Djack',
        'DMP',
        'Do It Best',
        'Dp',
        'Dp.Led Light',
        'Dstv',
        'DURABLE',
        'DuraVent',
        'Duravit',
        'Duravolt',
        'DuroMax',
        'Dyson',
        'Easy Home',
        'eco+',
        'ELC',
        'Electrolux',
        'Elemax',
        'Elepaq',
        'Elite Products',
        'Emel',
        'Essential Home',
        'Ete',
        'Eurosonic',
        'EZ-FLO',
        'Fadar',
        'Famicare',
        'Fantech',
        'Fineco',
        'Fireman',
        'Flotec',
        'Frigidaire',
        'Fujitsu',
        'Gasa',
        'Gates',
        'GE',
        'Geepee Tank',
        'General',
        'General Tools',
        'Generator',
        'Generic',
        'Genesis',
        'Genius',
        'Glamstar',
        'Global',
        'Goldcrown',
        'Golden Breeze',
        'Golden Diamond',
        'Google',
        'Gotv',
        'Gp',
        'Gree',
        'Greenlee',
        'GSR',
        'Haier',
        'Haier Thermocool',
        'Harman',
        'Havells',
        'Havit',
        'Henry',
        'Hikvision',
        'Hillman',
        'Hitachi',
        'Homax',
        'Home Essentials',
        'Homebase',
        'HoMedics',
        'Homeflower',
        'Homeline',
        'HomeSafe',
        'HON',
        'Honda',
        'Honeywell',
        'Hoover',
        'Hornet',
        'Hotpoint',
        'HP',
        'Huawei',
        'Hudong',
        'Hyundai',
        'Idea',
        'IGNIS',
        'iHome',
        'IKEA',
        'Imose',
        'Indesit',
        'Ingco',
        'InterDesig',
        'Ipower',
        'iRobot',
        'ITE',
        'Itec',
        'Itel',
        'Iwin',
        'Jackson',
        'Jaki',
        'Janome',
        'Jason',
        'Jbl',
        'Jd Smp',
        'JET',
        'Jinling',
        'Jobar',
        'Johnson',
        'Jr',
        'Juki',
        'Juky',
        'Kamisafe',
        'Karcher',
        'Kartel',
        'Kawasaki',
        'KD',
        'Kdk',
        'Keg',
        'Kelvinator',
        'Kemage',
        'Kenmore',
        'Kenstar',
        'Kenwood',
        'Kiki',
        'Kinelco',
        'King',
        'Kingy',
        'Kitchen',
        'Lakewood',
        'LDR',
        'Legend',
        'LENNOX',
        'Lexical',
        'LG Sourcing',
        'Liebherr',
        'Logik',
        'Loki',
        'Longaberger',
        'Lontor',
        'Lucky',
        'Luminou',
        'Lutian',
        'Lutron',
        'Lux',
        'M.Maat',
        'MAC',
        'Majestic',
        'Makita',
        'Mars2',
        'Master Chef',
        'Max Mech',
        'Maxi',
        'Maxi-Torq',
        'Maxim',
        'Maxon',
        'Maxwell',
        'Maytag',
        'Midea',
        'Mercury',
        'Metabo',
        'Mewe',
        'Middle Atlantic Products',
        'Midea',
        'Miele',
        'Mikano',
        'MINI',
        'Mitsubishi',
        'Mkt',
        'Mooved',
        'Morphy Richards',
        'Mouka',
        'MrSteam',
        'Myfan',
        'National',
        'Navigator',
        'Necchi',
        'New Comfort',
        'Newcastle',
        'Newclime',
        'Nexus',
        'Nikai',
        'NOVA',
        'Ok',
        'Olympia',
        'Omaha',
        'Omron',
        'Oraimo',
        'Orbit',
        'ORICO',
        'Orl',
        'Oxygen',
        'Padex',
        'Peak',
        'Pelonis',
        'Perfect Home',
        'Pfaff',
        'Philips',
        'Pinnacle',
        'Polar Bear',
        'Polaris',
        'Poly Vision',
        'Polystar',
        'PONY',
        'Porodo',
        'Power Deluxe',
        'Power Pro',
        'PowerLine',
        'Powerology',
        'Powertec',
        'Prag',
        'Presto',
        'Privileg',
        'PRO',
        'Pro-Tec',
        'Pyramid',
        'Qasa',
        'Qlink',
        'QO',
        'RADOF',
        'Rashnik',
        'Restpoint',
        'Rico',
        'Ring',
        'Rite-Tek',
        'Rosewill',
        'Rowenta',
        'Royal',
        'Royal Sovereign',
        'RST',
        'Rubi',
        'Russ',
        'Russell Hobbs',
        'Ryobi',
        'Saisho',
        'Salpha',
        'Salter',
        'Samsonite',
        'Samsung',
        'Sanford',
        'SANYO',
        'Sara Foam',
        'Scanfrost',
        'Scotch',
        'SEM',
        'Senci',
        'Senwei',
        'Shark',
        'Sharp',
        'Sharp Gold',
        'Siemens',
        'Signature',
        'Silverline',
        'Simply Copper',
        'Singer',
        'SK',
        'Skye',
        'Skyrun',
        'SkyTech',
        'Smarthome',
        'SmartSecurity',
        'Smc',
        'Snowsea',
        'Sokany',
        'Solar',
        'Solarex',
        'Solis',
        'Solitec',
        'Solstar',
        'Sonik',
        'Sony',
        'Starlite',
        'StarTech',
        'Stc',
        'Steamist',
        'Sumec Firman',
        'Sumo Premium',
        'Sunking',
        'Super Master',
        'Super Vision',
        'SuperiorBilt',
        'Swann',
        'Sweethome',
        'SYINIX',
        'TCL',
        'TEC',
        'Techno Cool',
        'Tefal',
        'Thermocool',
        'Tiger',
        'Tiger Claw',
        'TMS',
        'Tmt',
        'Tobi',
        'Toro',
        'Toshiba',
        'Total',
        'Tower',
        'Toyota',
        'TPI',
        'Transparent',
        'Tuya',
        'Two Lion',
        'Ultra',
        'Unique',
        'Universal Tool',
        'USI Electric',
        'Vaporella',
        'Vax',
        'Vesta',
        'Village Wrought Iron',
        'Visonic',
        'Voltplus',
        'Wahl',
        'Water Ace',
        'Waterworks',
        'west elm',
        'Westpoint',
        'Whirlpool',
        'Wiha',
        'WinCo',
        'Wireless Intercom',
        'Woods',
        'Xiantypical',
        'Xiaomi',
        'Yamaha',
        'Yamata',
        'Yoko',
        'YORK',
        'Zanussi',
        'Zenith',
        'Zephyr',
        'Zk',
        'Other',
    ],
    default: [
        'AmazonBasics',
        'Best',
        'Better Homes & Gardens',
        'Garden',
        'General',
        'A B TOOLS',
        'ACE',
        'Allen',
        'AMES',
        'Amtech',
        'Antelco',
        'Aqualin',
        'Aussie',
        'Avon',
        'BLACK+DECKER',
        'Blue',
        'Briers',
        'Brookstone',
        'Bulldog',
        'Burgon & Ball',
        'CAMCO',
        'Case',
        'Craftsman',
        'DURABLE',
        'Falcon',
        'GARDENA',
        'Gardeners Supply Company',
        'Green Blade',
        'Heavy Duty',
        'Hilka',
        'hOme',
        'K Tool',
        'MacKenzie-Childs',
        'Mainstays',
        'McGuire-Nicholas',
        'PARK',
        'Parkside',
        'Perfect Home',
        'Professional',
        'Regal',
        'SE',
        'Spear & Jackson',
        'T.O.P.',
        'Trend',
        'Truper',
        'Wilkinson Sword',
        'WOLF-Garten',
        'Other',
    ],
};
export const homeTypes = {
    5701: [
        'Chairs',
        'Tables',
        'Sofas',
        'Beds & Bed Frames',
        'TV Stands & Mounts',
        'Armchairs',
        'Bag Racks',
        'Bar Carts',
        'Bed Headboards & Footboards',
        'Benches, Stools & Bar Stool',
        'Bookcases & Shelving',
        'Cabinets & Cupboards',
        'CD & DVD Racks',
        'Couches',
        'Dining Sets',
        'Drawers',
        'Dressers',
        'Electric Fireplaces',
        'Frameless Furniture',
        'Furniture Accessories',
        'Furniture Parts',
        'Futons, Frames & Covers',
        'Hangers',
        'Hat Stands',
        'Home Office Desks',
        'Kitchen Cabinets & Islands',
        'Lockers',
        'Make-Up Stations',
        'Mattresses',
        'Mirrors',
        'Nightstands',
        'Plant Stands',
        'Poufs & Footstools',
        'Pulpits',
        'Screens & Room Dividers',
        'Shelving Units',
        'Shoe Racks',
        'Side Tables',
        'Sideboards & Buffets',
        'Sun Loungers',
        'Trunks & Chests',
        'Vanities & Makeup Tables',
        'Wardrobes',
        'Other',
    ],
    5702: [
        'Pots & Pans',
        'Cooking Utensils',
        'Flasks',
        'Dinner Sets',
        'Kitchen Racks',
        'Airfryer Liners',
        'Aprons',
        'Baking Utensils',
        'Bar & Cocktail Tools',
        'Bottle Stoppers & Corks',
        'Bowls',
        'Bread Boxes',
        'Butter Dishes',
        'Cake Decorations',
        'Cake Stands',
        'Can Openers',
        'Canisters & Jars',
        'Carafes & Water Pitchers',
        'Chippers',
        'Citrus Press',
        'Cling Film, Foil & Food Wraps',
        'Colanders, Strainers & Sifters',
        'Cooler Bags',
        'Corkscrews & Openers',
        'Cutting Boards',
        'Flatware Sets',
        'Food Dispensers',
        'Food Storage Bags',
        'Food Storage Containers',
        'Garlic Press',
        'Glassware',
        'Graters & Zesters',
        'Ice Buckets',
        'Ice Cubes, Trays & Molds',
        'Kettles & Teapots',
        'Kitchen & Steak Knives',
        'Kitchen Holders',
        'Kitchen Peelers & Slicers',
        'Lids & Covers',
        'Measuring Utensils',
        'Mortar And Pestle',
        'Mugs',
        'Napkins',
        'Oil Filters',
        'Oven Mitts & Pot Holders',
        'Pie, Flan & Tart Tins',
        'Plastic Dishes, Cups & Cutlery',
        'Plates',
        'Platters',
        'Salt & Pepper Shakers & Mills',
        'Scissors & Shears',
        'Sharpeners',
        'Single Flatware Pieces',
        'Straws',
        'Trays',
        'Wine Racks & Bottle Holders',
        'Other',
    ],
    5704: [
        'Multipurpose Liquid Soaps',
        'Laundry Detergents',
        'Toilet Cleaners',
        'Repellents',
        'Kitchen Cleaners',
        'Bathroom Cleaners',
        'Bleach',
        'Carpet and Rug Cleaners',
        'Descalers',
        'Dishwasher Detergents',
        'Disinfectants',
        'Floor Cleaners',
        'Glass Cleaners',
        'Rust Cleaners',
        'Sink & Drain Cleaners',
        'Stain Removers',
        'Tub & Tile Cleaners',
        'Other',
    ],
    5705: [
        'Refrigerators',
        'Cookers',
        'Freezers',
        'Blenders',
        'Microwaves',
        'Air Fryers',
        'Bread Makers',
        'Breakfast Machines',
        'Canisters & Storage',
        'Chafing Dishes',
        'Charcoal Stove',
        'Coffee Grinders',
        'Coffee Machines',
        'Cotton Candy Machines',
        'Deep Fryers',
        'Dehydrators',
        'Dishwashers',
        'Egg Cookers',
        'Food Choppers',
        'Food Grinders',
        'Food Processors',
        'Food Steamers',
        'Food Thermometers',
        'Food Warmers',
        'Gas Cylinders',
        'Gas Detectors',
        'Gas Lighters',
        'Grills & Outdoor Cooking',
        'Heating Mugs & Cups',
        'Hobs',
        'Hot Plates',
        'Ice Cream Makers',
        'Ice Makers',
        'Juicers',
        'Kettles',
        'Kitchen Scales',
        'Knife Sharpeners',
        'Meat Mincers',
        'Mixers',
        'Multi Cooker',
        'Oil Extractors',
        'Ovens',
        'Pancake Makers',
        'Pasta Machines',
        'Pizza Makers',
        'Popcorn Makers',
        'Preserving Cooker',
        'Range Hoods',
        'Rice Cookers',
        'Sandwich Makers',
        'Shawarma Machines',
        'Shawarma Toasters',
        'Slow Cookers',
        'Sous Vide Cookers',
        'Spice Grinders',
        'Thermo Pots',
        'Toasters',
        'Vacuum Sealers',
        'Waffle Irons',
        'Water Dispensers',
        'Water Filters',
        'Yam Pounding Machine',
        'Other',
    ],
    5706: [
        'Lighting',
        'Chandeliers',
        'Curtains, Drapes & Shades',
        'Rugs',
        'Wallpaper',
        '3D Wall Panels',
        'Air Fresheners & Diffusers',
        'Bathroom Textiles',
        'Bedding',
        'Buckets',
        'Candle Holders & Candle Accessories',
        'Candles',
        'Chair Covers',
        'Christmas Tree',
        'Cleaning Accessories',
        'Cleaning Brush',
        'Cleaning Tools',
        'Clocks',
        'Clothes Dryers',
        'Clothes Racks',
        'Curtain Rods & Rails',
        'Decorative Accessories',
        'Decorative Figurines & Statues',
        'Decorative Pillows & Cushion Covers',
        'Decorative Plates, Bowls & Dishes',
        'Dish Cloths',
        'Dish Rack & Dish Drainers',
        'Doormats',
        'Floodlights',
        'Gloves',
        'Hangers',
        'Incense Burners',
        'Ironing Boards',
        'Kitchen Hoods',
        'Kitchen Linens & Textiles',
        'Lanterns',
        'Laundry Accessories',
        'Laundry Baskets',
        'Laundry Cabinets & Shelving',
        'Lightbulbs',
        'Mirrors',
        'Mops',
        'Mosquito Killer',
        'Mosquito Lamps',
        'Mosquito Nets',
        'Noticeboards, Memo boards & Bulletin Boards',
        'Organizer',
        'Padlocks',
        'Pegs',
        'Pendant Lights',
        'Personal Scales',
        'Photo Frames',
        'Plant Pots & Stands',
        'Plants & Flowers',
        'Shoes Racks',
        'Soap Dispensers',
        'Soap Racks',
        'Storage Boxes',
        'Table Cloths & Runners',
        'Table Mats & Placemats',
        'Tissue Holders',
        'Toilet Brushes',
        'Toilet Roll Holder',
        'Toilet Seat Covers',
        'Toothbrush Holders',
        'Toothpaste Dispensers',
        'Vases',
        'Wall Brackets',
        'Wall Decor',
        'Wall Hangers',
        'Waste Bins',
        'Windows Blind',
        'Other',
    ],
    5707: [
        'Air Conditioners',
        'Washing Machines',
        'Fans',
        'Sewing Machines',
        'Irons',
        'Air Coolers',
        'Air Purifiers',
        'Alarm Systems',
        'Bathroom Scales',
        'Dehumidifiers',
        'Door Alarms',
        'Door Phones',
        'Doorbells',
        'Fire Alarms System',
        'Garment Steamer',
        'Hand Dryers',
        'High-Pressure Washers',
        'Humidifiers',
        'Landline Phones',
        'Room Heaters',
        'Smoke Detectors',
        'Towel Warmers',
        'Vacuum Cleaners',
        'Voltage Regulators',
        'Voltage Stabilizers',
        'Water Heaters',
        'Water Tanks',
        'Other',
    ],
    default: [
        'Artificial Grass',
        'Pressure Washers',
        'Plants',
        'Flower Pots',
        'Canopies',
        'Artificial Plants',
        'Bird Houses',
        'Garden & Lawn Stakes',
        'Garden Edging & Borders',
        'Garden Lighting',
        'Garden Sun Umbrellas',
        'Garden Swings',
        'Gardening Gloves & Protective Gear',
        'Gardening Hand Tools',
        'Gazebos',
        'Ground Reinforcement',
        'Hammocks',
        'Insect Traps & Baits',
        'Insect Zappers',
        'Insecticides',
        'Lawn Mowers',
        'Ornaments & Statues',
        'Pebbles, Stones & Step Stones',
        'Pergola',
        'Plant Stands',
        'Planters & Seeders',
        'Plaques & Signs',
        'Watering Equipment',
        'Wheelbarrow',
        'Other',
    ],
};
export const homeMaterials = [
    'Fabric',
    'Leather',
    'Marble',
    'MDF',
    'Wood',
    'ABS',
    'Acacia',
    'Acrylic',
    'Acrylic Blend',
    'Agate',
    'Alde',
    'Aluminium',
    'Artificial Leather',
    'Ash',
    'Aspen',
    'Bakelite',
    'Bamboo',
    'Beech',
    'Beech Heartwood',
    'Birch',
    'Bras',
    'Bronze',
    'Cane',
    'Canvas',
    'Cast Iron',
    'Cedar',
    'Ceramic',
    'Cherry',
    'Chestnut',
    'Chrome',
    'Composite Wood',
    'Copper',
    'Cotton',
    'Cotton Blend',
    'Crystal',
    'Ebony',
    'Eucalyptus',
    'Faux Leather',
    'Fir',
    'Formica',
    'Fur',
    'Glass',
    'Gold',
    'Iron',
    'Jarra',
    'Lacquer',
    'Laminate',
    'Linen',
    'Mahogany',
    'Mango',
    'Maple',
    'MDF / Chipboard',
    'Melamine',
    'Metal',
    'Mirror',
    'Mother of Pearl',
    'Nickel',
    'Nylon',
    'Oak',
    'Particle Board',
    'Pewte',
    'Pine',
    'Plastic',
    'Plywood',
    'Polycotton',
    'Polyester',
    'Poplar',
    'Porcelain',
    'PVC',
    'Rattan',
    'Recycled Wood',
    'Resin',
    'Rosewood',
    'Rubber',
    'Rubberwood',
    'Satinwood',
    'Shell',
    'Silk',
    'Silver',
    'Solid Wood',
    'Spruce',
    'Stainless Steel',
    'Steel',
    'Sterling Silver',
    'Suede',
    'Synthetic',
    'Teak',
    'Timber',
    'Tin',
    'Velvet',
    'Vinyl',
    'Walnut',
    'Wicker',
    'Wire',
    'Wool',
    'Wrought Iron',
    'Yew',
    'Zinc Alloy',
    'Other',
];
export const furnitureFor = [
    'Bedroom',
    'Dining Room',
    'Home Office / Study',
    'Kitchen',
    'Living Room',
    'Attic',
    'Balcony',
    'Basement',
    'Bathroom',
    'Dressing Room',
    'Foyer',
    'Garage',
    'Guestroom',
    'Hallway',
    'Laundry / Utility Room',
    'Other',
    'Patio',
    'Playroom',
    'Porch',
    'Sport Room',
    'Sunroom',
];
export const homeChemicals = [
    'Capsules',
    'Concentrate (Mix With Water)',
    'Crystals',
    'Gel',
    'Granules / Pellets',
    'Liquid',
    'Lotion',
    'Packs',
    'Paste',
    'Powder',
    'Solid',
    'Spray',
    'Tablets',
    'Wipes',
    'Other',
];

// electronics category
export const displaySizes = [
    '10.1"',
    '11" / 11.6"',
    '12" / 12.3"',
    '13" / 13.3"',
    '15" / 15.6"',
    '16"',
    '17" / 17.3"',
    '19"',
    '20.1"',
    '21"',
    '21" and more',
];
export const electronicsBrands = {
    5401: [
        'Apple',
        'Dell',
        'HP',
        'Logitech',
        'Universal',
        '4K',
        '4K Ultrahd',
        '4K Hdmi',
        'Acer',
        'Adesso',
        'Airspace',
        'Airtel',
        'Alienware',
        'Allsop',
        'Aluratek',
        'Anker',
        'Aoc',
        'APC',
        'ASUS',
        'Atlantic',
        'Atlona',
        'Barcode Scanner',
        'Baseus',
        'Belkin',
        'Benq',
        'Blackbook',
        'Bluegate',
        'Bolt',
        'BTI',
        'Buyor',
        'Canon',
        'Ch-31',
        'ChargeHub',
        'Chupez',
        'Cisco',
        'Coolbell',
        'CORSAIR',
        'Crossfire',
        'Crown',
        'Cursor',
        'CyberPower',
        'D-Link',
        'Das Keyboard',
        'Dermalog',
        'Digirich',
        'Digital Innovations',
        'Digital Persona',
        'Dynex',
        'E-Clips',
        'Eaget',
        'Eagle',
        'Earldom',
        'Eaton',
        'Enet',
        'ENHANCE',
        'Epson',
        'Ethernet',
        'Evergood',
        'Ezcap',
        'Fellowes',
        'Fujitsu',
        'Futronic',
        'Gaomon',
        'Garmin',
        'Generic',
        'Genius',
        'Google Chrome Cast',
        'Greenlion',
        'Halo',
        'Havit',
        'Haysenser',
        'Hikvision',
        'Hiti',
        'Hiview',
        'Hsdpa',
        'Huawei',
        'Huion',
        'Hyper',
        'HyperX',
        'iBenzer',
        'Incase',
        'Infocus',
        'Itel',
        'j5create',
        'Jabra',
        'Jaster',
        'Jbl',
        'Jedel',
        'Juiceboxx',
        'Kaspersky',
        'Kensington',
        'Key Digital',
        'Keychron',
        'Kingston',
        'Kodak',
        'Kojak Integrated',
        'Kojak Scanner',
        'Kston',
        'Kvm',
        'Kyocera',
        'Lacie',
        'LandingZone',
        'LapGear',
        'Ldnio',
        'Ledetech',
        'Ledger',
        'Lenovo',
        'Lg',
        'Lion',
        'Mac Book',
        'Marsriva',
        'Maxtron',
        'Meetion',
        'Mercury',
        'Microkingdom',
        'Micron',
        'Microsoft',
        'Millennals',
        'Mind Reader',
        'Moshi',
        'Mousepad',
        'Mtn',
        'Netlink',
        'New Age',
        'Nexigo',
        'Norton',
        'Olax',
        'Optoma',
        'Oraimo',
        'Panamax',
        'Panasonic',
        'Penclic',
        'Philips',
        'Porodo',
        'Powerology',
        'Prestige',
        'Qlt',
        'Quick Heal',
        'Rapoo',
        'Razer',
        'REDRAGON',
        'Ricoh',
        'ROCCAT',
        'Romoss',
        'SaharaCase',
        'Samsung',
        'Sandisk',
        'Sanyo',
        'Satechi',
        'Seagate',
        'Secugen',
        'Sharp',
        'Sk Hynix',
        'Smaat',
        'Sony',
        'Spectranet',
        'Starlink',
        'Startech.Com',
        'SteelSeries',
        'Targus',
        'Teamgroup',
        'Telenet',
        'TG3 Electronics',
        'Topaz',
        'Toshiba',
        'TP-Link',
        'Transcend',
        'Transparent',
        'Tt eSPORTS',
        'Twelve South',
        'Ucom',
        'Ugreen',
        'Unbranded',
        'Verbatim',
        'Vinsa',
        'Vivateck',
        'Wacom',
        'WD',
        'Western Digital',
        'Wiwu',
        'X&X',
        'Xiaomi',
        'Xp-Pen',
        'Xprinter',
        'Yoobao',
        'Zealot',
        'Zinox',
        'ZKTeco',
        'Zornwee',
        'ZTE',
        'Other',
    ],
    5402: [
        'HP',
        'Dell',
        'Samsung',
        'LG',
        'Asus',
        'Acer',
        'Alienware',
        'AOC',
        'Apple',
        'Aser',
        'BenQ',
        'Cisco',
        'Fujitsu',
        'Generic',
        'Hanns G',
        'Hisense',
        'Iiyama',
        'Lenovo',
        'Maxview',
        'Medion',
        'MSI',
        'NEC',
        'Newsync',
        'Philips',
        'Porodo',
        'Sceptre',
        'Smaat',
        'Terra',
        'ViewSonic',
        'Xiaomi',
        'Other',
    ],
    5403: [
        'Apple',
        'JBL',
        'Oraimo',
        'Samsung',
        'Sony',
        '1More',
        'A-Audio',
        'Abingo',
        'Accering',
        'Accessonico',
        'Accessory House',
        'Acctrend',
        'Accutone',
        'Acekool',
        'Aceyoon',
        'Acid Eye',
        'Acure',
        'ADJ',
        'Affordable',
        'Aftershokz',
        'Aigital',
        'Ailihen',
        'Ainope',
        'Air Pro',
        'Airbuds',
        'Airpod Skins',
        'Airsounds',
        'AKG',
        'Akz',
        'Alctron',
        'Altec Lansing',
        'Alti Brands',
        'Amazonbasics',
        'Ambar',
        'American Audio',
        'Anker',
        'Antiee',
        'Aproca',
        'Artix',
        'Astro',
        'Audi',
        'Audio-Technica',
        'Audiomate',
        'Aukey',
        'Avantree',
        'Avid',
        'Awei',
        'B39',
        'Banbrick',
        'Bang & Olufsen',
        'Baseman',
        'Baseus',
        'Bass Jaxx',
        'Bcelife',
        'Be Headwear',
        'Beats',
        'Beexcellent',
        'Behringer',
        'Belkin',
        'Beyerdynamic',
        'Blaupunkt',
        'Blueant',
        'Bluedio',
        'Boomph',
        'Bose',
        'Boss',
        'Bosstouch',
        'Brookstone',
        'Bryte Gear',
        'BT',
        'C&E',
        'Candy',
        'Catheadset',
        'Catnee',
        'Celebrat',
        'Cisco',
        'Clarity',
        'Clearsounds',
        'Cloud Fox',
        'Cool Elephant',
        'Coolcat',
        'Corsair',
        'Cowin',
        'Cygnett',
        'D-power',
        'Damson',
        'Dell',
        'Digifon',
        'Direct Sound',
        'Doqaus',
        'Dudios',
        'Ear Bud',
        'Earbudi',
        'Earstudio',
        'Edifier',
        'Enjoy-Unique',
        'Evisu',
        'Fil',
        'Fineblue',
        "Fresh 'n Rebel",
        'Gabba Goods',
        'Generic',
        'Genius',
        'Gerleek',
        'Google',
        'Grde',
        'Greenlion',
        'Groove',
        'H Hifihear',
        'Harman Kardon',
        'Havit',
        'HBQ',
        'Hello Kitty',
        'Hi-Fi',
        'Hifi Walker',
        'Hiotech',
        'Hoco',
        'House Of Marley',
        'HP',
        'Hspro',
        'HTC',
        'Huawei',
        'Humixx',
        'Hyperx',
        'I9S',
        'Icon',
        'Ifrogz',
        'Ihip',
        'Ihome',
        'Ilogic',
        'IMax',
        'Infinix',
        'Interphone',
        'Itel',
        'J&L Brands',
        'Jabra',
        'JAM',
        'Jaybird',
        'Jays',
        'Jlab',
        'JVC',
        'Kitsound',
        'Klipsch',
        'Kptec',
        'KRK',
        'Kscat',
        'KZ',
        'Lenovo',
        'Letsfit',
        'LG',
        'Lightimetunnel',
        'Logitech',
        'Lstn Sound',
        'Magnavox',
        'Maono',
        'Marley',
        'Marshall',
        'Megadream',
        'Merkury Innovations',
        'Meze',
        'Microkingdom',
        'Microsoft',
        'Mifo',
        'MK',
        'Mol',
        'Monster',
        'Monster High',
        'Motorola',
        'Moxom',
        'Mpow',
        'MSI',
        'Ncredible',
        'Neewer',
        'New Age',
        'New Bee',
        'Nia',
        'Noisehush',
        'Nokia',
        'Numark',
        'NYZ',
        'Oculus',
        'Olaf',
        'Omnitech',
        'Oneodio',
        'Oneplus',
        'Onikuma',
        'ONN',
        'Oppo',
        'Orit',
        'P47',
        'P9',
        'Philips',
        'Pinna Labs',
        'Pioneer',
        'Pioneer Dj',
        'Plantronics',
        'Playstation',
        'Pom Gear',
        'Poolee',
        'Porodo',
        'Powerbeast',
        'Powerneer',
        'Presonus',
        'Pro 750',
        'Proht',
        'Promate',
        'Pzoz',
        'QCY',
        'QKZ',
        'Rane',
        'Rapoo',
        'Razer',
        'Realme',
        'Recrsi',
        'Redmi',
        'Remax',
        'RHA',
        'Rock Space',
        'Rocketfish',
        'Ryobi',
        'S2E',
        'Samson Technologies',
        'Sennheiser',
        'Sentry',
        'Shenzhen',
        'Shhr',
        'Shplus',
        'Shure',
        'Silverstone Technology',
        'Skullcandy',
        'Skybuds',
        'Smart Walkie',
        'Sms Street',
        'Sodo',
        'Sol Republic',
        'Sonixx',
        'Soundcore',
        'Soundmagic',
        'Soundpeats',
        'Spigen',
        'Sports Pro',
        'Steelseries',
        'Sudio',
        'Super Me',
        'Takstar',
        'Tall Plus',
        'Targus',
        'Tayogo',
        'Techcode',
        'Tecno',
        'Threecat',
        'Transparent',
        'Tribit',
        'Tronic Master',
        'Trueaudio',
        'Tucci',
        'Turtle Beach',
        'Twayrdio',
        'TWS',
        'Unbrand',
        'Urbanears',
        'Usams',
        'V-Moda',
        'Vivitar',
        'Vivtar',
        'Vjjb',
        'Weile',
        'Wesc',
        'Winwolf',
        'WIW',
        'WXY',
        'XBT',
        'Xiaomi',
        'Xpower',
        'Yamaha',
        'Yison',
        'Yoga',
        'Yogo',
        'Yokon',
        'Yoobao',
        'Zealot',
        'Other',
    ],
    5404: [
        'Canon',
        'Epson',
        'HP',
        'Konica Minolta',
        'Sharp',
        '3D Systems',
        '3M',
        'Acer',
        'Adesso',
        'Agfa',
        'Avision',
        'Bixolon',
        'Black Box',
        'Brady',
        'Brother',
        'Buyor',
        'Card Scanning Solutions',
        'Casio',
        'Citizen',
        'CZUR',
        'Datacard',
        'Datamax',
        'Dell',
        'Develop',
        'DigitalPersona',
        'DNP',
        'Dymo',
        'ECTACO',
        'Evolis',
        'Fargo',
        'Fujitsu',
        'Geeetech',
        'General',
        'Gestetner',
        'HID',
        'HiTi',
        'Honeywell',
        'HPE',
        'IBM',
        'IRIS',
        'Kodak',
        'Kojak',
        'Kyocera',
        'Lexmark',
        'LG',
        'Magnasonic',
        'Mercury',
        'Minolta',
        'Mitsubishi',
        'Mustek',
        'Neat',
        'NEC',
        'Nikon',
        'OKI',
        'Olivetti',
        'Olympus',
        'Output Technology',
        'Panasonic',
        'Pantum',
        'PeriPage',
        'Phomemo',
        'PlanOn',
        'Plustek',
        'Ricoh',
        'RISO',
        'Rollo',
        'Samsung',
        'Sawgrass',
        'Sharper Image',
        'Sony',
        'Star Micronics',
        'Suprema',
        'Toshiba',
        'Unbranded',
        'Utax',
        'Veeda',
        'Xerox',
        'Xiaomi',
        'Xprinter',
        'XYZprinting',
        'Yinghe',
        'Zebra',
        'ZyXEL',
        'Other',
    ],
    5405: [
        'Cisco',
        'D-Link',
        'MTN',
        'TP-Link',
        'Ubiquiti Networks',
        '2Wire',
        '3Com',
        '9Mobile',
        'Acer',
        'ACP',
        'Action-Tec',
        'Aico',
        'Air Live',
        'Airlink',
        'Airtel',
        'Alcatel-Lucent',
        'Alfa-Net',
        'Alink',
        'Amplifi',
        'Apc',
        'Apple',
        'Arris',
        'Aruba Networks',
        'Ashata',
        'ASUS',
        'AT&T',
        'Avaya',
        'Baofeng',
        'Belkin',
        'Bolt+',
        'Brandrex',
        'BT',
        'Busy',
        'Bvot',
        'Cambium Networks',
        'Channel Vision',
        'Check Point',
        'Chupez',
        'Comfast',
        'Commando',
        'Commscope',
        'Comtrend',
        'CP Technologies',
        'CrystalView',
        'CscoSystems',
        'Dahua',
        'Ddk',
        'Dell',
        'Digi',
        'Dintek',
        'DrayTek',
        'Dtech',
        'Dymo',
        'ElctronicStore',
        'EnGenius',
        'Estream Networks',
        'F-Secure',
        'Fortinet',
        'Gateway',
        'Generic',
        'GigaFast',
        'Glo',
        'Glo Netpro',
        'Google',
        'Grandstream',
        'Hikvision',
        'HiLink',
        'HiLook',
        'HooToo',
        'HP',
        'HPE',
        'Hsdpa',
        'Huawei',
        'Ike',
        'Imose',
        'Itel',
        'Jazz',
        'Jio',
        'Juniper Networks',
        'LB-Link',
        'LevelOne',
        'Linksys',
        'Lintratek',
        'Logitech',
        'Lte Cpe',
        'Maxis',
        'Medialink',
        'Mercusys',
        'Microsoft',
        'MikroTik',
        'Millennals',
        'Moniepoint',
        'Motorola',
        'NEC',
        'NetComm',
        'NetGear',
        'Netis',
        'Netlink',
        'Netpro',
        'Nokia',
        'NovAtel',
        'Ntel',
        'OEM',
        'Olax',
        'Onv',
        'Open Mesh',
        'Optus',
        'Oraimo',
        'Palmpay',
        'Panasonic',
        'PIX-Link',
        'Pro-Net',
        'Rock',
        'Ruckus',
        'S-Tech',
        'Samsung',
        'Shux',
        'Siemens',
        'SKE',
        'Smart',
        'SmartWi',
        'SMC',
        'Smile',
        'Sonicwall',
        'Sony',
        'Sophos',
        'Spectranet',
        'Starlink',
        'StarTech',
        'Swift',
        'Synology',
        'Tecno',
        'Tele2',
        'Telenet',
        'Teltonika',
        'Tenda',
        'Tiger',
        'Tulsat',
        'UniFi',
        'Universal',
        'Uniview',
        'Vida',
        'Vis-Link',
        'Vodafone',
        'Vonets',
        'WatchGuard',
        'Wavlink',
        'Western Digital',
        'Wi-Tek',
        'Wifi Repeater',
        'WirEng',
        'Xiaomi',
        'Yeastar',
        'Zonet',
        'Zong',
        'Zonyer',
        'ZTE',
        'ZyXEL',
        'Other',
    ],
    5406: [
        'Apple',
        'Samsung',
        'Tecno',
        'Infinix',
        'Xiaomi',
        'Acer',
        'AEG',
        'Afrione',
        'Alba',
        'Alcatel',
        'AllCall',
        'Allview',
        'Amazon',
        'Asus',
        'AT Mobile',
        'BlackBerry',
        'Blackview',
        'BLU',
        'Bontel',
        'BQ',
        'Casio',
        'Cat',
        'Coolpad',
        'Cubot',
        'Dell',
        'Doogee',
        'Elephone',
        'Essential Products',
        'Fero',
        'Fly',
        'FreeYond',
        'Gionee',
        'Google',
        'H-mobile',
        'Hisense',
        'HomTom',
        'Honor',
        'Hotwav',
        'HP',
        'HTC',
        'Huawei',
        'i-mobile',
        'Imose',
        'InFocus',
        'iPRO',
        'Iridium',
        'Itel',
        'K-Touch',
        'Kenxinda',
        'Kgtel',
        'Kyocera',
        'Lava',
        'LeEco',
        'Lenovo',
        'LG',
        'Lumigon',
        'Maxfone',
        'Meizu',
        'Mi-Tribe',
        'Microsoft',
        'Mione',
        'Motorola',
        'MTN',
        'Nokia',
        'Nothing Phone',
        'Oale',
        'OnePlus',
        'Oppo',
        'Oukitel',
        'Pantech',
        'Poptel',
        'Qmobile',
        'Qtek',
        'Razer',
        'Realme',
        'RED',
        'S-Mobile',
        'Siccoo',
        'Smart+',
        'Smartisan',
        'SmartOpus',
        'Sony',
        'Sony Ericsson',
        'Sowhat',
        'SQ',
        'Sugar',
        'T-Mobile',
        'TCL',
        'Thuraya',
        'Trifone',
        'Ulefone',
        'Umi',
        'Umidigi',
        'Vernee',
        'Vertu',
        'Vivo',
        'Vodafone',
        'Wiko',
        'X-Tigi',
        'ZTE',
        'Other Brand',
    ],
    5407: [
        'Microsoft',
        'Midas',
        'Mighty Pro Audio',
        'Minirig',
        'MIPOW',
        'Monitor Audio',
        'Mosfet',
        'Motorola',
        'MTX',
        'Mxl',
        'N-Jack',
        'N-Tek',
        'Nektar',
        'NEO',
        'Neutrik',
        'Nevir',
        'Newcastle',
        'NewRixing',
        'NINETEC',
        'Nns',
        'Novation',
        'Numan',
        'Numark',
        'Nunix',
        'Nuvo',
        'Nux',
        'NXG',
        'Oceanic',
        'Omax',
        'OMEGA',
        'Onix',
        'Onkyo',
        'ONN',
        'Onyx Studio 6',
        'Onyx Studio 7',
        'Oraimo',
        'OSD Audio',
        'Oxcarcia',
        'Pan Bose',
        'Panasonic',
        'Peakomar',
        'Pearl',
        'Peavey',
        'Philips',
        'Phoenix',
        'Phonic',
        'Pioneer',
        'PodSpeakers',
        'Polk Audio',
        'Polycom',
        'Polystar',
        'Poolee',
        'Porodo',
        'Power Bass',
        'Powerology',
        'Premier England',
        'PreSonus',
        'Prime Audio',
        'Pro Hero Sound',
        'Pro hero soun',
        'Pro Sound',
        'Proel',
        'Proking',
        'Promic',
        'PRONOMIC',
        'PSB',
        'Pyle',
        'R-MUSIC',
        'Rane One',
        'Razer',
        'REL',
        'Remax',
        'RockJam',
        'Rockview',
        'Rode',
        'Rokit',
        'Roland',
        'Royal',
        'Russound',
        'Sabian',
        'Samick',
        'Samson',
        'Samsung',
        'SANYO',
        'Saramonic',
        'Scarlett',
        'Sea Piano',
        'Sennheiser',
        'Serato',
        'Sharp',
        'Signature',
        'Behringer',
        'JBL',
        'LG',
        'Shure',
        'Yamaha',
        '1 BY ONE',
        'A11',
        'Accuphase',
        'Accurian',
        'Adam',
        'ADC',
        'Adesso',
        'ADIN',
        'Aduro',
        'Advent',
        'Aerial Acoustics',
        'Ahuja',
        'Ailipu',
        'AIRIS',
        'Aiwa',
        'Ajc',
        'Ak Super',
        'Akai',
        'AKASO',
        'Akason',
        'Akb',
        'AKG',
        'Alba',
        'Alctron',
        'Alesis',
        'Allen & Heath',
        'Allison',
        'Alphasonik',
        'Alpine',
        'Altec',
        'Alto',
        'Amaz',
        'Amazon',
        'AMP',
        'Ampex',
        'AMX',
        'Anchor',
        'Anker',
        'Apex',
        'Apogee',
        'Apollo',
        'Apple',
        'Approx',
        'Arcam',
        'ArchiTech',
        'Arcus',
        'Arion Legacy',
        'Ariz Sound',
        'Arturia',
        'Arylic',
        'Asound',
        'Astatic',
        'Atalax',
        'Atlantic',
        'Atlantic Technology',
        'Atrend',
        'Audica',
        'Boncadio',
        'Boombeatz',
        'Boombest',
        'Bosch',
        'BOSE',
        'Boss',
        'Bower',
        'Boya',
        'BRAVEN',
        'Britz',
        'Brookstone',
        'Bt 3401',
        'BUC s',
        'Bugera',
        'BUILT',
        'Bush',
        'Bx8',
        'Bytech',
        'Cabasse',
        'Cadence',
        'Cafini',
        'Camac',
        'Canic',
        'Casio',
        'Castle',
        'CAV',
        'Celestion',
        'Celsus',
        'CENTURY',
        'Champion Sound',
        'Ciare',
        'Cisco',
        'Citronic',
        'Clarity',
        'Classic',
        'Classic Audio',
        'ClearOne',
        'Conkar',
        'Conrad',
        'Coral',
        'Costway',
        'Crate Audio',
        'Crosley',
        'Crown',
        'Cvr',
        'Cydon',
        'D-Marc',
        'Dametek',
        'Damson',
        'Darkblue',
        'Darock Pro Audio',
        'Dart',
        'Db',
        'DBX',
        'De Boss',
        'Dell',
        'Denon',
        'Design Acoustics',
        'Deviale',
        'Devon',
        'Diamond',
        'Digifon',
        'Digitrex',
        'Divoom',
        'Djack',
        'Dji',
        'DMX',
        'Dolphin',
        'Dolvin',
        'DOSS',
        'Drummer Boss',
        'Dsppa',
        'Dvon',
        'DYNASONIC',
        'Eagle',
        'eAudio',
        'Eben',
        'ECHO',
        'Edifier',
        'Elostar',
        'Eltax',
        'Emgold',
        'Eminence',
        'Enkor',
        'Eurolite',
        'Evp',
        'Excellent',
        'Exlg',
        'Extreme',
        'F&D',
        'Fane',
        'Fdb',
        'Fender',
        'FIFINE TECHNOLOGY',
        'First Alert',
        'Focusrite',
        'Furman',
        'Fusion',
        'G-Project',
        'Gear4',
        'Gemini',
        'General',
        'Gipson',
        'Global Link',
        'Glorik',
        'Goodmans',
        'Goodnews',
        'Google',
        'Grace',
        'Grace Digital Audio',
        'Grace Sound',
        'Grammar Sound',
        'Greatsound',
        'Green Lion',
        'Greenlight',
        'Gunice',
        'H&H',
        'H@F',
        'Hallmark',
        'Hamson',
        'Harman Kardon',
        'Hartke',
        'HAVIT',
        'Hi-Max',
        'HiFi Works',
        'High Class',
        'Hisense',
        'Hisonic',
        'Hitachi',
        'Homeflower',
        'Honeywell',
        'Hopestar',
        'Ibanez',
        'Icom',
        'Iloud Micro Monitor',
        'Imc',
        'Infinity',
        'Intempo',
        'ION',
        'Irig Stream',
        'Itel',
        'Jabra',
        'Jaguar',
        'Jamo',
        'Jiepak',
        'JL Audio',
        'Jmlab',
        'John Lewis',
        'Juice',
        'JVC',
        'K35',
        'K8',
        'Karma',
        'Kenwood',
        'Kilpsch',
        'Kimiso',
        'King',
        'Kisonli',
        'Koda',
        'Koleer',
        'Komplete',
        'Korg',
        'KRK',
        'Kustom',
        'L8S',
        'Lava',
        'Lavalier',
        'Lax',
        'Legend',
        'Lensgo',
        'LG XBOOM',
        'Libratone',
        'Lidimi',
        'Line6',
        'Logitech',
        'Lontor',
        'Lp',
        'Lp V6',
        'LTC Audio',
        'Lucky Tone',
        'Luxury Sound',
        'M-Audio',
        'Mackie',
        'Mackkie',
        'Magnat',
        'Magnavox',
        'Magnetic',
        'Majestic',
        'Majority',
        'Maono',
        'Marcsonic',
        'Marshall',
        'Martin Audio',
        'Master Mix',
        'Master Piece',
        'Matushi',
        'Max',
        'Maxell',
        'MEDION',
        'Mega',
        'Meirende',
        'Mercury',
        'Mi',
        'Micro Boom',
        'Temeisheng',
        'Thor',
        'Thorens',
        'THUNDER',
        'Tinmo',
        'Titan',
        'Titanic',
        'Tivoli',
        'Tonor',
        'Toshiba',
        'Tovaste',
        'Tribit',
        'Tronsmart',
        'Trust',
        'Tundra',
        'Tws',
        'UHF',
        'Ulanzi',
        'Ultra',
        'UNITEK',
        'Universal',
        'Universum',
        'Vizio',
        'Volt',
        'Soundmaster',
        'Sp',
        'Speakerlab',
        'Speaqua',
        'Special',
        'Ssl2',
        'Standard (Japan)',
        'Stanton',
        'Steck Audio',
        'Steren',
        'Stereostone',
        'STRONG',
        'Studio Acoustics',
        'Sunbuck',
        'Super Sound',
        'Supersonic',
        'Surpass',
        'Swan',
        'System Audio',
        'T&G',
        'Takstar',
        'Tama',
        'Tannoy',
        'Tascam',
        'TCL',
        'Technics',
        'Tecno',
        'Silver Bird',
        'SilverLabel',
        'Sinclair',
        'Skullcandy',
        'Skytec',
        'Smart',
        'Smarthome',
        'Sonac',
        'Sonance',
        'Sonivia',
        'Sonok',
        'Sonos',
        'Sony',
        'Sonymax',
        'SonyXBoss',
        'Sound Around',
        'Sound Code',
        'Sound Lab',
        'Sound Piece',
        'Sound Prince',
        'Soundcraftsmen',
        'Soundking',
        'Soundklass',
        'Soundlogic',
        'other',
    ],
    5408: [
        'Canon',
        'Dji',
        'Nikon',
        'Panasonic',
        'Sony',
        'AEE',
        'Alpa',
        'Alpha',
        'Andoer',
        'Andowl',
        'Autel',
        'Axis',
        'Baofeng',
        'Benq',
        'Besteker',
        'Blackmagic',
        'Casio',
        'Drone X Pro',
        'Easyn',
        'Epson',
        'Fujifilm',
        'Garmin',
        'GoPro',
        'Hasselblad',
        'Havit',
        'HDRC',
        'Hikvision',
        'Hiview',
        'HP',
        'HVR',
        'ION',
        'JJRC',
        'JVC',
        'Kodak',
        'Konica Minolta',
        'Lumix',
        'Mevo',
        'Ocom',
        'Olympia',
        'Olympus',
        'Pentax',
        'Polaroid',
        'Polo',
        'Polycom',
        'Potensic',
        'Promark',
        'Red5',
        'Samsung',
        'Sandisk',
        'Sanyo',
        'Sharp',
        'Sigma',
        'Universal',
        'Upair',
        'Viewslim',
        'Vivitar',
        'Xiaomi',
        'Yashica',
        'Yongnuo',
        'Yunteng',
        'Other',
    ],
    5409: [
        'HP',
        'Dell',
        'Samsung',
        'LG',
        'Asus',
        'Acer',
        'Alienware',
        'AOC',
        'Apple',
        'Aser',
        'BenQ',
        'Cisco',
        'Fujitsu',
        'Generic',
        'Hanns G',
        'Hisense',
        'Iiyama',
        'Lenovo',
        'Maxview',
        'Medion',
        'MSI',
        'NEC',
        'Newsync',
        'Philips',
        'Porodo',
        'Sceptre',
        'Smaat',
        'Terra',
        'ViewSonic',
        'Xiaomi',
        'Other',
    ],
    5410: [
        'Ausno',
        'Dahua',
        'Generic',
        'Hikvision',
        'ZKTeco',
        '101 Av Inc',
        'A-Zone',
        'Abtech',
        'Acceskings',
        'Alfawise',
        'Alician',
        'Amcrest',
        'Amiccom',
        'Annke',
        'Anran',
        'Anspo',
        'Apexis',
        'Aqara',
        'Arlo',
        'Ashata',
        'Axisvision',
        'Baofeng',
        'Bayit Home',
        'Besd',
        'Blink',
        'BW',
        'Camitel',
        'Cctv Kit',
        'Cctv Power Supply',
        'CencoVision',
        'Centurion',
        'Chloride Uk',
        'Clarion View',
        'Confidence',
        'Costar',
        'CP Plus',
        'Cytex Vision',
        'D-Link',
        'D-Tech',
        'DBM',
        'Dcsec',
        'Detrinity',
        'Digiteck',
        'Dji',
        'EasyN',
        'Eufy',
        'Eversecu',
        'Evertech',
        'Ezviz',
        'Focus',
        'Fourthvision',
        'Garrett',
        'Gawker',
        'Gent',
        'Geovision',
        'Google',
        'GrandVision',
        'GSA',
        'GW Security',
        'GZ SONY',
        'HDVD',
        'HDview',
        'HI Xmedia',
        'Hikview',
        'HiLook',
        'Hiseeu',
        'Hivideo',
        'Honeywell',
        'Huawei',
        'Huaxing',
        'Hybrid',
        'Ike',
        'Imou',
        'Intelligent Lock',
        'Ivtech',
        'Jooan',
        'Jovision',
        'JVC',
        'Kolaura',
        'Kubix',
        'Lechange',
        'Logitech',
        'Longse',
        'Lorex',
        'Low Power',
        'M-Teck',
        'Majestic',
        'Mapesen',
        'Motorola',
        'MultiStar',
        'N-Track',
        'Nemtek',
        'Nest',
        'Optimax',
        'Oscarvision',
        'P T Z Solar Camera',
        'Panasonic',
        'Paxvision',
        'Polyvision',
        'Powerology',
        'Proline Uk',
        'Prolynx',
        'PTZ',
        'Reolink',
        'Ring',
        'Safehome',
        'Samsung',
        'Sannce',
        'Seagate',
        'Sheenwang',
        'Skyvision',
        'Smart Security Club',
        'Smart View',
        'Smartlock',
        'SmartSF',
        'Sonoff',
        'Sony',
        'Sricam',
        'Stanificent',
        'Techtronica',
        'TP-Link',
        'Tuya',
        'Ubiquiti',
        'UK Link',
        'Uniview',
        'Veecome',
        'Videosecu',
        'Viewtec',
        'Vitek CCTV',
        'Vivotek',
        'Vr Cam',
        'Vstarcam',
        'Wanscam',
        'Wansview',
        'Watchmen',
        'Wd Purple',
        'Wecas',
        'Wietec',
        'Winsposse',
        'World Vision',
        'Xiaomi',
        'XMeye',
        'Zebronics',
        'Zmodo',
        'ZunVision',
        'Other',
    ],
    default: [
        'HP',
        'Dell',
        'Apple',
        'Lenovo',
        'Asus',
        '3XS',
        'Acer',
        'Advent',
        'Airis',
        'Alienware',
        'Avantis',
        'Brian',
        'Chuwi',
        'Clevo',
        'Compaq',
        'Cyberpower',
        'CyberpowerPC',
        'E-System',
        'EduPad',
        'eMachines',
        'Evoo',
        'Fujitsu',
        'Gateway',
        'Geo',
        'Gigabyte',
        'Google',
        'Haier',
        'Huawei',
        'i-Life',
        'iBUYPOWER',
        'Itel',
        'LG',
        'Linx',
        'Maingear',
        'Medion',
        'Microsoft',
        'Monster',
        'MSI',
        'NEC',
        'Nextbook',
        'Nokia',
        'Novatech',
        'Origin PC',
        'Packard Bell',
        'Panasonic',
        'Prostar',
        'Razer',
        'RM Minibook',
        'Sager',
        'Samsung',
        'Sony',
        'Stone',
        'Toshiba',
        'Touchmate',
        'Trekstor',
        'Vinovo',
        'Xiaomi',
        'XPG Adata',
        'Yepo',
        'Yoga',
        'Zinox',
        'Zoostorm',
        'Other',
    ],
};
export const electronicsType = {
    5404: [
        'Dot-Matrix Printer',
        'Flatbed Scanner',
        'Ink-Jet Printer',
        'Laser Printer',
        'Photo Printer',
        'Photocopier',
        'Portable Scanner',
        'Sheet-Fed Scanner',
        'Other',
    ],
    5405: [
        'Access Point',
        'IP Phones',
        'Mifi',
        'Modem',
        'Network Cables',
        'Router',
        'Switch',
        'WiFi Repeater',
        'Other',
    ],
    5407: [
        'Speakers',
        'Microphones',
        'Home Theater Systems',
        'Sound Systems',
        'Music Mixers',
        'Acoustic Shields & Panels',
        'Amplifiers',
        'Audio Compressors & Limiters',
        'Audio Interfaces',
        'Cassette Players',
        'CD Players',
        'DJ Controller',
        'DJ Mixers',
        'Drum Machines',
        'Equalizers',
        'Hi-Fi Systems',
        'Karaoke',
        'Loudspeakers & Subwoofers',
        'Megaphones',
        'Midi Controllers',
        'MP3 Players',
        'PA Systems',
        'Radios',
        'Receivers',
        'Soundcards',
        'Studio Monitors',
        'Turntables',
        'Voice Recorders',
        'Walkie Talkies',
        'Other',
    ],
    5408: [
        'Action Cameras',
        'Digital Cameras',
        'Drones',
        'DSLR Cameras',
        'Film Cameras',
        'Video Cameras',
        'Other',
    ],
    5410: [
        'Access Control',
        'CCTV Camera',
        'CCTV Kit',
        'CCTV Tester',
        'Digital Video Recorder',
        'IP Camera',
        'Motion Detector',
        'Nanny Cams',
        'Spy Clock',
        'Spy Glasses',
        'Spy Pen',
        'Other',
    ],
    default: null,
};
export const ramSize = [
    '1GB',
    '1.5GB',
    '2GB',
    '3GB',
    '4GB',
    '6GB',
    '8GB',
    '12GB',
    '16GB',
    '20GB',
    '24GB',
    '32GB',
    '40GB',
    '48GB',
    '64GB',
    '256GB',
];
export const storageSize = [
    '4GB',
    '8GB',
    '16GB',
    '32GB',
    '40GB',
    '48GB',
    '60GB',
    '72GB',
    '128GB',
    '140GB',
    '160GB',
    '250GB',
    '256GB',
    '320GB',
    '350GB',
    '500GB',
    '512GB',
    '640GB',
    '700GB',
    '750GB',
    '1T',
    '1.5T',
    '2T',
    '3T',
    '4T',
];
export const storageType = ['eMMC', 'HDD', 'HDD+SSD', 'SSD', 'SSHD (Hybrid)', 'SSHD+SSD'];
export const processors = [
    'AMD',
    'AMD A4',
    'AMD A6',
    'AMD A8',
    'AMD A10',
    'AMD Ryzen',
    'AMD Ryzen 3',
    'AMD Ryzen 5',
    'AMD Ryzen 7',
    'AMD Ryzen 9',
    'Apple M1',
    'Apple M1 Pro',
    'Apple M1 Max',
    'Apple M2',
    'Apple M2 Ultra',
    'Intel',
    'Intel Celeron',
    'Intel Pentium',
    'Intel Core 2 Duo',
    'Intel Core 2 Quad',
    'Intel Core i3',
    'Intel Core i5',
    'Intel Core i7',
    'Intel Core i9',
    'Intel Core M',
    'Intel Xeon',
    'Nvidia',
    'Other',
];
export const operatingSystems = [
    'Windows XP',
    'Windows Vista',
    'Windows 8.1',
    'Windows 8',
    'Windows 7',
    'Windows 11',
    'Windows 10',
    'Ubuntu',
    'Non OS',
    'Mac OS',
    'Linux',
    'Free DOS',
    'DOS',
];
export const resolution = [
    'Ultra HD 4K 3840x2160',
    'Quad HD 2560x1440',
    'HD 1280x720',
    'Full HD 1920x1080',
    '1920x1200',
    'Full 4K 4096x2160',
    '8K 7680x4320',
    '800x600 • 6 ads',
    '6K 6016x3384',
    '5K 5120x2880',
    '3840x1600',
    '3840x1200',
    '3840x1080',
    '3440x1440',
    '2560x1600',
    '2560x1080',
    '1600x900',
    '1440x900',
    '1280x1024',
];
export const simType = [
    'Single Nano/e-SIM',
    'Single Nano-SIM',
    'Nano-SIM',
    'Hybrid Dual Nano-SIM',
    'Dual Nano-SIM',
    'Triple SIM',
    'Triple Micro-SIM',
    'Single SIM',
    'Single Nano-SIM/eSIM',
    'Single Nano-SIM/e-SIM',
    'Single Mini-SIM',
    'Single Micro-SIM',
    'Quad Mini-SIM',
    'Nano-SIM/eSIM',
    'Nano-SIM and eSIM',
    'Mini-SIM',
    'Micro-SIM',
    'Hybrid Dual SIM',
    'Hybrid Dual Mini-SIM',
    'Hybrid Dual Micro/Nano-SIM',
    'Hybrid Dual Micro-SIM',
    'eSIM',
    'Dual SIM',
    'Dual Nano-SIM/eSIM',
    'Dual Nano-SIM and eSIM',
    'Dual Nano SIM',
    'Dual Mini/Micro-SIM',
    'Dual Mini-SIM',
    'Dual Micro/Nano-SIM',
    'Dual Micro-SIM',
    'Dual eSIM',
];
export const displayTechnology = [
    'Super Retina OLED',
    'Retina IPS LCD',
    'OLED',
    'IPS LCD',
    'AMOLED',
    'CRT',
    'VA',
    'TN',
    'TFT',
    'Super LCD3',
    'Super LCD2',
    'Super LCD',
    'Super AMOLED',
    'STN',
    'S-LCD',
    'S-IPS LCD',
    'Retina IPS',
    'PLS LCD',
    'PLS',
    'P-OLED+',
    'P-OLED',
    'Monochrome',
    'LCD',
    'IPS',
    'Grayscale',
    'CSTN',
];

// sports category
export const sportBrands = {
    6202: [
        'Behringer',
        'Casio',
        'Fender',
        'Ibanez',
        'Yamaha',
        'ADMIRA',
        'Agile',
        'Aguilar',
        'Alembic',
        'Alhambra',
        'Allparts',
        'Alvarez',
        'ammoon',
        'Amptweaker',
        'Analog Man',
        'Aria',
        'Art & Lutherie',
        'Artist',
        'Asturias',
        'Augustine',
        'Avatar',
        'AXL',
        'B-Band',
        'Baker',
        'Bare Knuckle',
        'BK Butler',
        'Black Arts Toneworks',
        'Black Cat',
        'Black Diamond',
        'Blade',
        'Bogner',
        'Boss',
        'Burns',
        'Burswood',
        'Cardinal',
        'Cole Clark',
        'Composite Acoustics',
        'Conklin',
        'Cort',
        'Crafter',
        'Crescent',
        'CTS',
        'Custom',
        "D'Addario",
        'DBZ',
        'Dean Guitars',
        'Diezel',
        'DigiTech',
        'Donner',
        'DR',
        'Duncan Designed',
        'Eastman',
        'Eastwood',
        'Encore Electronics',
        'Epiphone',
        'ESP',
        'Esp Guitars',
        'Esteban',
        'EVH',
        'Fernandes',
        'First Act',
        'Fretlight',
        'G&L',
        'Gallien-Krueger',
        'Gator',
        'Gibson',
        'Gold Tone',
        'Greco',
        'Gretsch',
        'Gruv Gear',
        'Guild',
        'Hallmark-UK',
        'Halo',
        'Hamer',
        'Harley Benton',
        'Harmony',
        'Headway',
        'Hi-Story',
        'Italia',
        'JB Player',
        'Ken Smith',
        'Kona',
        'L.R. Baggs',
        'LAG',
        'Line 6',
        'LTD',
        'LUNA',
        'Maestro',
        'Magnatone',
        'Manuel Rodriguez',
        'Markbass',
        'Marshall',
        'Martin',
        'Martin Guitars',
        'Maxam',
        'Michael Kelly',
        'Mitchell',
        'Mooer',
        'Morgan Monroe',
        'Music Man',
        'National',
        'NUX',
        'One Control',
        'Oscar Schmidt',
        'Ovation',
        'Parker',
        'Peavey',
        'Pedulla',
        'Phil Jones Bass',
        'Pro-Line Racing',
        'PRS',
        'Red Panda',
        'Reverend',
        'Richwood',
        'Rockbox',
        'Rockman',
        'Rogue',
        'Samick',
        'Schecter',
        'Seymour Duncan',
        'Shine',
        'Sigma',
        'Silvertone',
        'SKB',
        'Source Audio',
        'Squier',
        'Suhr',
        'Supro',
        'Suzuki',
        'SX',
        'Tacoma',
        'Tanglewood',
        'Taylor',
        'Tom Anderson',
        'Truetone',
        'Tune',
        'Two-Rock',
        'Univox',
        'VENTURA',
        'Vibramate',
        'Vox',
        'Washburn',
        'Westfield',
        'Westone',
        'Wolf',
        'YAMAKI',
        'Z.Vex',
        'Other',
    ],
    6203: [
        'American Fitness',
        'Bodyfit',
        'Bodygym',
        'Everlast',
        'Universal',
        '3G Cardio',
        '66Fit',
        'A&W',
        'Ab Coaster',
        'Ab Doer Twist',
        'Ab Rocket',
        'Abgymnic',
        'Abtronic',
        'Adidas',
        'Afg',
        'Afrocanfit',
        'Airex',
        'Ancheer',
        'Apollo',
        'Aquajogger',
        'Arena',
        'Artengo',
        'Asics',
        'Avex',
        'Babolat',
        'Bally',
        'Best Choice Products',
        'Bestway',
        'Bh Fitness',
        'Black Mountain',
        'Blue Idea',
        'Bmx',
        'Body Sculpture',
        'Body-Solid',
        'Bodyblade',
        'Bodyflex',
        'Bodylastics',
        'Bodyworx',
        'Bosu',
        'Bowflex',
        'Bremshey',
        'Brooks',
        'Btwin',
        'Callaway',
        'Cap',
        'Capital Sports',
        'Captains Of Crush',
        'Carlton',
        'Casall',
        'Champion',
        'Christopeit',
        'Confidence Fitness',
        'Costway',
        'Cybex',
        'De Young',
        'Diamond Back',
        'Domyos',
        'Drive',
        'Dunlop',
        'Dynamix',
        'Easy 8',
        'Eco-Fit',
        'Elevation',
        'Elops',
        'Emrad Billards',
        'Endurance',
        'Energetics',
        'Enjoy Fit',
        'Ergo-Fit',
        'Everfit',
        'Exerpeutic',
        'Fdf',
        'Fila',
        'Fit4Home',
        'Fitball',
        'Fitness Quest',
        'Fitness Reality',
        'Fitnessclub',
        'Fitnex',
        'Flx',
        'Forclaz',
        'Fortis',
        'Freemotion',
        'Fuelbelt',
        'Garmin',
        'Gategold',
        'Generic',
        'Genesis',
        'Genki',
        'German Machine',
        'Getfit',
        'Ght',
        'Giant',
        'Gng Fitness',
        'Gofit',
        "Gold's Gym",
        'Gramax',
        'Gripmaster',
        'Gym Master',
        'Gymboss',
        'Gymstick',
        'Haggai',
        'Hammer',
        'Harbinger',
        'Head',
        'Hero',
        'Hippie Runner',
        'Horizon',
        'Horizon Fitness',
        'Housefit',
        'Hudora',
        'Huffy',
        'Hy-Skate',
        'Icon Health & Fitness',
        'Impulse',
        'Intex',
        'Iron Gym',
        'Ironman',
        'Ironmind',
        'J&S',
        'Jako',
        'Weslo',
        'Wilson',
        'Wish',
        'Wonder Core',
        'Woodway',
        'Xterra',
        'Xterra Fitness',
        'Revolt',
        'Riley',
        'Rio',
        'Rockrider',
        'Rumbleroller',
        'Sand Socks',
        'Schwinn',
        'Scsports',
        'Shimano',
        'Sigma',
        'Simba',
        'Simply Fit',
        'Six Pack Care',
        'Skyland',
        'Smith',
        'Sole',
        'Sole Fitness',
        'Soozier',
        'Spalding',
        'Spec',
        'Speedo',
        'Spibelt',
        'Spirit',
        'Spirit Fitness',
        'Sport Schmidt',
        'Sportcraft',
        'Sportplus',
        'Sportsart',
        'Spot On',
        'Spri',
        'Stairmaster',
        'Stamina',
        'Star Trac',
        'Stiga',
        'Striker Butterfly',
        'Supermax',
        'Supermax Pro',
        'Suunto',
        'Suzanne Somers',
        'Talon',
        'Tarmak',
        'Tcm',
        'Technofitness',
        'Technogym',
        'Tempo Fitness',
        'Tempt',
        'The Firm',
        'Total Core',
        'Total Gym',
        'Trackmaster',
        'Trek',
        'Triban',
        'Trojan',
        'True Fitness',
        'Tummy Trimmer',
        'Tunturi',
        'Uhlsport',
        'Umbro',
        'Unbranded',
        'Upper Bounce',
        'V-Fit',
        'Valeo',
        'Venum',
        'Vibro Action',
        'Vision',
        'Vision Fitness',
        'Weider',
        'Well Care',
        'Jll',
        'Joola',
        'Jumpking',
        'Jumpsport',
        'Jx',
        'K2',
        'Kazu',
        'Kettler',
        'Keys Fitness',
        'La Gear',
        'Landice',
        'Leadsuper',
        'Li Link',
        'Life Fitness',
        'Lifeline',
        'Lifespan',
        'Loki',
        'LSG',
        'Magnum Fitness',
        'Marcy',
        'Marin',
        'Marshal Fitness',
        'Matrix',
        'Matrix Fitness',
        'Mercedes Benz',
        'Mikasa',
        'Molten',
        'Mongoose',
        'Nashua',
        'New Balance',
        'Newgen',
        'Next',
        'Nike',
        'Ninja',
        'Nordic',
        'Nordictrack',
        'Octane Fitness',
        'Olympus',
        'Opti',
        'Oxelo',
        'Pacemaster',
        'Passion',
        'Perfect Fitness',
        'Physical Company',
        'Ping',
        'Pivot',
        'Power Max',
        'Power Plate',
        'Powerball',
        'Powertrain',
        'Prince',
        'Pro Fitness',
        'Pro Sport',
        'Pro Tech',
        'Proform',
        'Progear',
        'Prolife',
        'Promaxima',
        'Pulse',
        'Puma',
        'Raleigh',
        'Rebounder',
        'Reebok',
        'Yes4All',
        'Yogarat',
        'Yogistar',
        'Yonex',
        'York',
        'York Fitness',
        'Zumba',
        'Other',
    ],
    6206: [
        'A.E.S',
        'ABUS',
        'ACE',
        'Acme',
        'General',
        'ACDelco',
        'activa',
        'Adams',
        'AE Light',
        'AEG',
        'AeroBed',
        'AFC',
        'Aigle',
        'Aladdin',
        'ALEKO',
        'Alite',
        'Allen',
        'Alpine',
        'AMP',
        'Ampro',
        'Amtech',
        'AR',
        'Armstrong',
        'Badger',
        'Barska',
        'Bear Grylls',
        'Berger',
        'Best',
        'BGS',
        'Big K',
        'BLACK+DECKER',
        'Blacks',
        'Brunton',
        'Bush',
        'CAMCO',
        'CamelBak',
        'CAN',
        'CENTURY',
        'Coleman',
        'Craftsman',
        'Do It Best',
        'Easy Camp',
        'EVEREADY',
        'Garden Pleasure',
        'Garmin',
        'GB',
        'Henderson',
        'Hi Gear',
        'Hyundai',
        'Joy',
        'Karrimor',
        'Leisure',
        'Naturehike',
        'Nikon',
        'Outdoor Products',
        'Ozark Trail',
        'PRO',
        'Royal',
        'SILVA',
        'Sunex',
        'Other',
    ],
};
export const sportTypes = {
    6201: [
        'TV, DVD & VCR Accessories',
        'Televisions, Plasma & LCD TVs',
        'Smart TV',
        'Other TV, DVD & Video',
        'DVD Players & Recorders',
        'TV Reception & Set-Top Boxes',
        'Satellite & Cable Equipment',
        'Security & Surveillance Systems',
        'Blu-ray Players & Recorders',
        'Video Players & Recorders',
        'TV Projectors',
        'GPS Devices',
        'Portable DVD & Blu-ray Players',
        'Audiobooks',
        'Movies',
        'Music',
        'Training',
        'Tutorial',
        'Other',
    ],
    6202: [
        'Electronic Keyboards',
        'Acoustic Drum Sets',
        'Acoustic Guitars',
        'Bass Guitars',
        'Electric Guitars',
        'Accordions',
        'Bass Drums',
        'Bongo Drums',
        'Bugles',
        'Cellos',
        'Clarinets',
        'Congas',
        'Cornets',
        'Cymbals',
        'Double Basses',
        'Electronic Drum Sets',
        'Flutes',
        'Frame Drums',
        'Guitar & Bass Effects',
        'Guitar Amp Heads',
        'Guitar Cabs',
        'Guitar Combos',
        'Guitar Preamps',
        'Harmonicas',
        'Harps',
        'Horns',
        'Maracas',
        'Melodicas',
        'Midi Keyboards',
        'Music Bags & Cases',
        'Music Stands',
        'Organs',
        'Parts & Accessories',
        'Pianos',
        'Saxophones',
        'Snare Drums',
        'Talking Drums',
        'Tambourines',
        'Tom Drums',
        'Trombones',
        'Trumpets',
        'Tubas',
        'Ukuleles',
        'Violins',
        'Xylophones',
        'Other',
    ],
    6203: [
        'Snooker Tables',
        'Treadmills',
        'Bicycles & Tricycles',
        'Massagers',
        'Tennis Tables',
        'Ab Exercise Machine',
        'Agility Ladders',
        'Air Hockey Tables',
        'Arm Blasters',
        'Badminton Nets',
        'Badminton Rackets',
        'Badminton Stands',
        'Balance Boards',
        'Ball Pumps',
        'Barbells',
        'Baseball Bats',
        'Baseball Gloves',
        'Basketball Balls',
        'Basketball Stands',
        'Benches',
        'Bike Accessories',
        'Bike Baskets',
        'Bike Brakes',
        'Bike Clothes',
        'Bike Computers & GPS',
        'Bike Covers',
        'Bike Fenders',
        'Bike Gloves',
        'Bike Helmets',
        'Bike Horns',
        'Bike Lights & Reflectors',
        'Bike Pedals & Cleats',
        'Bike Phone Holder',
        'Bike Pumps',
        'Bike Repair & Multi-Function Tools',
        'Bike Saddles',
        'Bike Security & Locks',
        'Bike Tyres & Inner Tubes',
        'Bodyboards',
        'Bottle Cage',
        'Boxing Gloves',
        'Boxing Wraps',
        'Cricket Bats',
        'Cross Trainers',
        'Crossfit Racks',
        'Dartboard',
        'Dip Bars',
        'Diving Snorkels',
        'Dumbbells',
        'Exercise Bikes',
        'Exercise Ropes',
        'Flags and Flag Stands',
        'Foam Roller',
        'Football Goals',
        'Football Tables',
        'Goalkeeper Gloves',
        'Golf Balls',
        'Golf Gloves',
        'Golf Sets',
        'Gym Balls',
        'Gym Gloves',
        'Gym Mats',
        'Gymnastics Rings',
        'Hand Grips',
        'Hockey Sticks',
        'Hoverboards',
        'Hula Hoops',
        'Jump Boxes',
        'Kettlebell',
        'Kickboards',
        "Kids' Vehicle",
        'Leg Machines',
        'Medicine Balls & Slam Balls',
        'Multi-Station Gym',
        'Orbitreks',
        'Pedometers',
        'Protective Gear',
        'Pull-Up Bars',
        'Punching Bags',
        'Push-Up Bars',
        'Resistance Power Bands',
        'Roller Skates',
        'Rowing Machines',
        'Rugby Balls',
        'Scooter',
        'Skateboarding Helmets',
        'Skateboards',
        'Skipping Rope',
        'Snooker Balls',
        'Snooker Cue Sticks',
        'Soccer Balls',
        'Squash Balls',
        'Stability Balls',
        'Stair Mills',
        'Step Boards',
        'Steppers',
        'Stopwatches',
        'Substitution Boards',
        'Swimming Caps',
        'Swimming Flippers',
        'Swimming Goggles',
        'Swimming Masks',
        'Swimming Pools',
        'Table Tennis Rackets',
        'Tennis Balls',
        'Tennis Nets & Posts',
        'Tennis Rackets',
        'Training Cones',
        'Trampolines',
        'Twister Disc',
        'Vibrating Platforms',
        'Volleyballs',
        'Wearable Weights',
        'Weight Racks',
        'Weighted Bags',
        'Whistles',
        'Wrist Bandages',
        'Other',
    ],
    6204: [
        'Awards & Trophies',
        'Carving Tools',
        'Crochet Hooks',
        'Drawing Tools',
        'Medals',
        'Pictures',
        'Sculptures',
        'Yarn',
        'Gift Ideas',
        'Other',
    ],
    6205: ['Games', 'Books', 'Other'],
    6206: [
        'Furniture',
        'Cooking Supplies',
        'Compasses',
        'Binoculars',
        'Trekking Poles',
        'Lanterns & Headlamps',
        'Sleeping Bags',
        'Telescopes',
        'Tents',
        'Other',
    ],
};

// health category
export const healthProductFormulation = {
    5603: ['Oil', 'Pencil', 'Roll-on', 'Body spray'],
    5602: [
        'Capsule',
        'Drink',
        'Liquid',
        'Powder',
        'Tablets',
        'Caplet',
        'Chewable',
        'Cream',
        'Crystal',
        'Drops',
        'Effervescent Powder',
        'Effervescent Tablet',
        'Gel',
        'Granule',
        'Gum',
        'Gummy',
        'Lozenge',
        'Nutritional Bar',
        'Oil',
        'Paste',
        'Pills',
        'Sachet',
        'Shake',
        'Softgel',
        'Solid',
        'Spray',
        'Stick',
        'Strip',
        'Suppository',
        'Tea',
        'Other',
    ],
};
export const healthBrands = {
    5601: [
        'Avon',
        'Aura',
        'Alorepair',
        'Beyond Beauty',
        'Blush',
        'African Pride',
        'Bellezza',
        'Bronner Brothers',
        'Clinic Plus',
        'Creme Of Nature',
        'Dove',
        'Dax',
        'Essence',
        'Fanola',
        'Garnier',
        'Astley Clarke',
        'Armani',
        'Hawaiian Silky',
        'Just For Men',
        "L'Oreal",
        'Mac',
        'Mielle',
        'DC Shoes',
        'Dunnes',
        'Himalaya',
        'Oriflame',
        'Nature Republic',
        'Revlon',
        'Other',
    ],
    5602: [
        'Greenlife',
        'Gsk',
        'GU',
        'H.H.N.P',
        'Hairfinity',
        'Hamdard',
        'Hawaii Pharm',
        'Health Garde',
        'Healthaid',
        'Healthpath Natural',
        'Healthy Mood',
        'Healthy Origins',
        'Hella',
        'Hemani',
        'Hempworx',
        'Herbal Delight',
        'Heshoutang',
        'Hi-Tech',
        'Himalaya',
        'Himalaya Health Care',
        'Himalaya Herbals',
        'Horbaach',
        'Iforce Nutrition',
        'Ironmaxx',
        'Irwin Naturals',
        'J-Chen',
        'Jamu Elita',
        'Jarrow Formulas',
        'Jiangang',
        'Jianxi',
        'Jigsimur',
        'Joju',
        'Juice Plus+',
        'Juvenate',
        'KAL',
        'Kedi',
        'Kedi Healthcare',
        'Kenbroth',
        'Kind',
        'Kirkland Signature',
        'Kosdaq',
        'Kumiko',
        'Kyolic',
        "L'Il Critters",
        'Ladies Shine',
        'Lamosa',
        'Lennox',
        'Lexi',
        'Life Extension',
        'Lilong',
        'Livegood',
        'Livepure',
        'Longrich',
        'Lucky Brand',
        'Magnum',
        'Major',
        'Mannatech',
        'Maritzmayer',
        'Mason Natural',
        'Max Factor',
        'Max International',
        'Megafood',
        'Meiji',
        'Mejic',
        'Met-Rx',
        'Milnapath',
        'Min Min',
        'Miracell',
        'Miracle Seed Ultima',
        'Miracle White',
        'Miss Smarty Pants',
        'Multistream',
        'Muscle Milk',
        'Muscletech',
        'Mutant',
        'Myprotein',
        'Natrol',
        'Naturade',
        'Natural Access',
        'Natural Factors',
        'Natural Vitality',
        'Nature Craft',
        'Nature Cure',
        'Nature Leaf',
        'Nature Made',
        "Nature's Answer",
        'Schiff',
        'Scitec Nutrition',
        'Secret',
        'Seven Seas',
        'Shineway',
        'Shineway Healthcare',
        'Six Star',
        'Skandal',
        'Skinny Body Care',
        'Slim Fast',
        'Smartshake',
        'So White',
        'Softhealth',
        'Solgar',
        'Songtai Life',
        'Source Naturals',
        'Spring Valley',
        'Ssa',
        'Sumifun',
        'Sundown Naturals',
        'Sunhome Technology',
        'Supaworld',
        'Superlife',
        'Supple',
        'Supreme Gluta White',
        'Swanson Health Products',
        'Swisse',
        'Tasly',
        'The Protein Works',
        'Thorne Research',
        'TimJan Wonder',
        'Tradomed',
        'Trevo',
        'Fafor life',
        'Health Plus',
        'Herbalife',
        'Neolife',
        'Norland',
        '21St Century',
        '4Life',
        '5-Hour Energy',
        'A&G',
        'Abbott',
        'Ace',
        'Aci',
        'Acorbic',
        'Activlab',
        'Advocare',
        'Alcon',
        'Alfa',
        'Alfasigma',
        'Alli',
        'Alliance Global',
        'Amazing Herbs',
        'American Health',
        'Animal Pump',
        'Apetamin',
        'Applied Nutrition',
        'APS',
        'Aqua Skin',
        'Arbonne',
        'Atkins',
        'Aura White',
        'Azo',
        'Baidyanath',
        'Basic Supplement',
        'Bausch + Lomb',
        'Bayer',
        'Beachbody',
        'Bell Lifestyle',
        'Benefit',
        'Berocca',
        'Best Naturals',
        'Better Bodies',
        'Bf Suma',
        'Biotech',
        'Biotrend',
        'Biotrust',
        'Bodi Goal',
        'Body Fortress',
        'Boldgains',
        'Boric Acid',
        'BPI',
        'Bragg',
        'Builders',
        'Bulk Powders',
        'Cardiovax',
        'Carlyle',
        'Carrot-Top Drugs',
        'Celerity from Max',
        'Cellucor',
        'Centrum',
        'Clean',
        'Complan',
        'Country Life',
        'Crazymass',
        'Crystal',
        'CVS',
        'Cybergenics',
        'Dabur',
        'Daynee',
        'Detoxi Slim',
        'Deva',
        "Doctor's Best",
        'Double Wood',
        "Dr. Ohhira's",
        'Dxn',
        'Dymatize',
        'Dymatize Nutrition',
        'Dynace',
        'Dynace Global',
        'Dynamic Health',
        'Dynewell',
        'Dynwell',
        'Earth Creation',
        "Earth'S Creation",
        'Edible Herbs',
        'Edmark',
        'Edmark International',
        'Efamol',
        'Elite Nutrition',
        'Elken Global',
        'Emergen-C',
        'Ensure',
        'Equate',
        'Organic India',
        'Organo',
        'Oriflame',
        'Orion',
        'Osteo Biflex',
        'Ozempic',
        'Partner.Co',
        'Perfectil',
        'Pfizer',
        'Pharmanex',
        'Phytoscience',
        'Piping Rock',
        'Precious Skin',
        'Premier Edition',
        'Premier Protein',
        'Prolife',
        'Pure Encapsulations',
        'Pure Protein',
        'Purely Inspired',
        "Puritan's Pride",
        'Rain',
        'Rain International',
        'Redcon1',
        'Revive Active',
        'Revoobit',
        'Rida',
        'Rite Aid',
        'Rule 1',
        'Sambucol',
        'Satin Skinz',
        "Nature's Blend",
        "Nature's Bounty",
        "Nature'S Field",
        "Nature's Life",
        "Nature's Plus",
        "Nature'S Renaissance",
        "Nature's Sunshine",
        "Nature's Way",
        'Naturefield',
        'Natures Aid',
        'Natures Cure',
        'Neocell',
        'Nestle',
        'New Hope Global',
        'New Look',
        'New Nordic',
        'Next Level',
        'Nicole',
        'Nil',
        'Nordic Naturals',
        'Novo Nordisk',
        'Now',
        'Now Foods',
        'Now Sports',
        'Nozie',
        'NRI',
        'Nuevergold',
        'Nutrabolics',
        'Nutrex',
        'Nutricost',
        'Nutrilite',
        'Nvisionu',
        'Olly',
        'One A Day',
        'Onecure',
        'Optimum Nutrition',
        'Orgain',
        'Organic Barley Grass',
        'Organic Health Essence',
        'Eu Natural',
        'Evergreen',
        'Everhealth',
        'Evgenis',
        'EVL',
        'Exeline',
        'Faforon',
        'Fairhaven Health',
        'Farforon',
        'Finaflex',
        'Fitness Labs',
        'Flat Tummy Tea',
        'FM',
        'Fohow',
        'Force Factor',
        'Forever',
        'Forever Living',
        'Frozen',
        'Fudge',
        'Futurebiotics',
        'Gamma',
        'Garden Of Life',
        'Gaspari',
        'Gaspari Nutrition',
        'GAT',
        'Ght',
        'Glaxon',
        'Global Healing Center',
        'Gluta Berry',
        'Gluta Frozen',
        'Gluta Prime',
        'Gluta White',
        'Glutanex',
        'Glutax',
        'GNC',
        'Goli Nutrition',
        'Great',
        'Great Lakes',
        'Greatea',
        'Green World',
        'Twinlab',
        'Tylenol',
        'Uatd',
        'Ultimate Maca',
        'Ultimate Maca Plus',
        'Ultimate Nutrition',
        'Ultra',
        'Unbranded',
        'Universal Nutrition',
        'USN',
        'Usplabs',
        'Vasia Supplement',
        'Vega',
        'Vibrant Health',
        'Vitabiotics',
        'Vitafusion',
        'Vital Proteins',
        'Viva',
        'Viviscal',
        'VPX',
        'Weider',
        'Whey Protein',
        'Wholesome Story',
        'Windmill',
        'Wins Town',
        'Winston',
        'XS',
        'Yes Global',
        'Young Living',
        'Youngevity',
        'Youtheory',
        'Zazzee',
        'Zeal',
        'Zipfizz',
        'Other',
    ],
    5603: [
        'Arabian Perfume',
        'Ard Al Zaafaran',
        'Fragrance World',
        'Lattafa',
        'Oriflame',
        'Accendis',
        'Acqua Di Parisis',
        'Acqua di Parma',
        'Adidas',
        'Afnan',
        'Ajmal',
        'Al Haramain',
        'Al Wataniah',
        'Al-Rehab',
        'Aleda',
        'Alhambra',
        'Alina Corel',
        'Amber Elixir',
        'Amore',
        'Amouage',
        'Amouroud',
        'Angel Schlesser',
        'Annick Goutal',
        'Antonio Banderas',
        'Arabiyat',
        'Aramis',
        'Argerville',
        'Argeville',
        'Armaf',
        'Armand Basi',
        'Aro-Fac',
        'Asdaaf',
        'Avanti',
        'Aventos',
        'Avon',
        'Azzaro',
        'Bebe',
        'Bentley',
        'Berries Weekend',
        'Betres',
        'Beyonce',
        'Bijan',
        'Blend Oud',
        'Boadicea',
        'Body Philosophy',
        'Bond No',
        'Boucheron',
        'Breed',
        'Britney Spears',
        'Burberry',
        'Bvlgari',
        'Byredo',
        'Cacharel',
        'Cadillac',
        'Calvin Klein',
        'Carbbean Vanilla',
        'Carolina Herrera',
        'Cartier',
        'Castle Bejar',
        'Cerruti',
        'Chanel',
        'Chris Adams',
        'Christian Dior',
        'Classic Creation',
        'Clinique',
        'Clive Christian',
        'Concur',
        'Confetti',
        'Cool Girl',
        'Copaci',
        'Creation Lamis',
        'Creed',
        'Crown Perfumes',
        'Cybele',
        'David Beckham',
        'Davidoff',
        'Dhamma',
        'Diesel',
        'DKNY',
        'Dolce & Gabbana',
        'Dunhill',
        'Elie Saab',
        'Fogg',
        'Francis Kurkdjian',
        'Franck Bocklet',
        'Franck Olivier',
        'French Connection',
        'French Oil',
        'Fuse',
        'Gale Hayman',
        'Gandour',
        'Gdk',
        'Genie',
        'Genie Collection',
        'Geoffrey Beene',
        'Ghost',
        'Giorgio Armani',
        'Giorgio Black',
        'Givana',
        'Givanas',
        'Givenchy',
        'Gucci',
        'Guerlain',
        'Guess',
        'Guy Laroche',
        'Hamilton',
        'Havex',
        'Hermes',
        'Hugo Boss',
        'Iceberg',
        'Imperio',
        'Issey Miyake',
        'Jacomo',
        'Jacques Bogart',
        'Jacques Fath',
        'Jaguar',
        'Jean Paul Gaultier',
        'Jeanne Arthes',
        'Jennifer Lopez',
        'Jimmy Choo',
        'Joop',
        'Juicy Couture',
        'Justin Bieber',
        'Kenneth Cole',
        'Kenzo',
        'Khalis',
        'Kilian',
        'Kim Kardashian',
        'Lacoste',
        'Lady Gaga',
        'Lalique',
        'Lancome',
        'Lanvin',
        'Le Labo',
        'Liquides Imaginaires',
        'Lolita Lempicka',
        'Louis Cardin',
        'Louis Vuitton',
        'Madonna',
        'Maison Fragrance',
        'Maison Oud',
        'Mancera',
        'Nishane',
        'Marc Jacobs',
        'Marque',
        'Memo',
        'Mercedes Benz',
        'Milton Lloyd',
        'Ministry Of Oud',
        'Monster Fragrance',
        'Mont Blanc',
        'Moresque',
        'Moschino',
        'Mosuf',
        'Mousuf',
        'My Dear Body',
        'Myk',
        'Mystical',
        'Narciso Rodriguez',
        'Naseem',
        'Nasomatto',
        'Nautica',
        'Nedens',
        'Nina Ricci',
        'Nivea',
        'OAK',
        'Ocean Pacific',
        'Only You',
        'Oros',
        'Oud Luxury Collection',
        'Paco Rabanne',
        'Pandora',
        'Parfums De Marly',
        'Parfums Gres',
        'Paris Corner',
        'Paris Hilton',
        'Pendora Scents',
        "Penhaligon's",
        'Perry Ellis',
        'Philz',
        'Porsche Design',
        'Pra',
        'Prestige',
        'Ralph Lauren',
        'Rasasi',
        'Rave',
        'RB',
        'Repetto',
        'Riggs',
        'Rihanna',
        'Roberto Cavalli',
        'Roja Dove',
        'Rue Broca',
        'Salvatore Ferragamo',
        'Sarah Jessica Parker',
        'Scenabella',
        'Sean John',
        'Secret Amor',
        'Sex In The City',
        'Sillage',
        'Smart Collection',
        'Smart Collections',
        'Smart World',
        'So Oud',
        'Storm',
        'Style Parfums',
        'Suave',
        'Surrati',
        'Thierry Mugler',
        'Tom Ford',
        'Tommy Hilfiger',
        'Touch',
        'Usher',
        'Valentino',
        'Van Cleef & Arpels',
        'Vera Wang',
        'Versace',
        'Vertigo',
        "Victoria's Secret",
        'Viktor & Rolf',
        'Ville',
        'Vince Camuto',
        'Vurv',
        'Yves Saint Laurent',
        'Zandas',
        'Zara',
        'Other Brand',
        'Elizabeth Arden',
        'Elizabeth Taylor',
        'Elysees Fashion',
        'Emir',
        'Emper',
        'Emporio Armani',
        'Enchanteur',
        'Escada',
        'Essencia',
        'Estee Lauder',
        'Etienne Aigner',
        'Explore',
        'FA Paris',
        'Ferrari',
        'other',
    ],
    5604: [
        'Classic Erotica',
        'HOT',
        'No-Name',
        'Oriflame',
        'Sextreme',
        'A&G',
        'Abreva',
        'Aichun Beauty',
        'AMOUR',
        'Apollo',
        'B Swish',
        'Bad Kitty',
        'Baile',
        'Beano',
        'Belgo-Prism',
        'Best Herb',
        'BlissJoy',
        'Blush',
        'Blush Novelties',
        'Bodywand',
        'Butterfly',
        'Carejoy',
        'Classics',
        'Cobeco',
        'Colt',
        'Crystal',
        'CURVE',
        'Diblong',
        'Double Root',
        'Durex',
        'Electrastim',
        'Envy',
        'Everhealthy',
        'Faak',
        'Faforlife',
        'Fairhaven Health',
        'Fantasy',
        'Fashion',
        'Fetish Fantasy',
        'Fleshlight',
        'Fohow',
        'Forever',
        'Foxshow',
        'Fun Factory',
        'Ght',
        'Glas',
        'Gold Fly',
        'Greenlife',
        'Hardtoys',
        'Icicles',
        'Icon',
        'Immeri',
        'IMO',
        'Jigsimur',
        'Johnson & Johnson',
        'Joy',
        'K-Y',
        'Kedi',
        'King',
        'Lilo',
        'Love',
        'Lovehoney',
        'LoveLife',
        'Lovense',
        'LOVETOY',
        'Luvkis',
        'Luxe',
        'Magic Wand',
        'Master Series',
        'Max Man',
        'Mk',
        'Neolife',
        'Norland',
        'Now',
        'Nu Sensuelle',
        'Orion',
        'Passion',
        'Perfect Fit',
        'PINK',
        'Pipedream',
        'Pretty Love',
        'Pure Romance',
        'Samsu',
        'Satisfyer',
        'Secret',
        'SexFlesh',
        'Shineway Healthcare',
        'Size Matters',
        'Spanish Gold Fly',
        'Strap U',
        'STUD',
        'Super Viga',
        'SVAKOM',
        'Tenga',
        'Toy Joy',
        'Ultra',
        'Venus',
        'Viga',
        'Vigrx Plus',
        'Wand Essentials',
        'Wet',
        'Wins Town',
        'XOXO',
        'XR Brand',
        'XR Brands',
        'XS',
        'Yes Global',
        'Yoni',
        'Other',
    ],
    5605: [
        'Motec Beauty',
        'Aura',
        'Oriflame',
        'Avon',
        'Zaron',
        'Alpyn beauty',
        'Avour',
        'BH',
        'Blossom',
        'Classic',
        'Dior',
        'Fayre Gold',
        'Freshlook',
        'GlamGals',
        'Heng Fang',
        'Hudabeauty',
        'Karite',
        'Kylie',
        'Just For Men',
        "L'Oreal",
        'Mac',
        "L'Oreal Paris",
        'Laura Mercier',
        'Lush',
        'MAC',
        'Oriflame',
        'Zikel',
        'Revlon',
        'Other',
    ],
    5606: [
        'Bath & Body Works',
        'B. Braun',
        'Axis',
        'AXE',
        'Avon',
        'Aveeno',
        'Astonish',
        'Asantee',
        'Arm & Hammer',
        'Anthony',
        'Annie',
        'Angel',
        'AMBI',
        'Always',
        'Alpha',
        'Aichun Beauty',
        'Agraria',
        'Adidas',
        'AcneFree',
        'A LA MAISON',
        'Oriflame',
        'On',
        'Fresh',
        'Essential',
        'Clean',
        'Zoya',
        'Zoella',
        'Zion Health',
        'Zest',
        'Zermat',
        'Zen',
        'Yves Saint Laurent',
        'Yves Rocher',
        'Young Living Essential Oils',
        'YES TO',
        'YES',
        'Yardley',
        'Worth',
        'World Market',
        'White Rain',
        'VS',
        'Vogue',
        'Viva',
        'Vitamins',
        'Virgo',
        'Village Naturals',
        'Viktor & Rolf',
        "Victoria's Secret",
        'Vespa',
        'Versace',
        'Veetgold',
        'VEET',
        'Vaseline',
        'United Colors of Benetton',
        'Ultra',
        "Two's Company",
        'Tura',
        'Trussardi',
        "Trader Joe's",
        'Tosowoong',
        'Top Gel',
        'Tommy Hilfiger',
        'Thierry Mugler',
        'The Natural Solution',
        'The Body Shop',
        'Technic',
        'Tea Tree Therapy',
        'Tea Tree',
        'Tampax',
        'TAG',
        'Tabac',
        'SURE',
        'Superior',
        'Sunflower',
        'Sumifun',
        'Sugar',
        'Suave',
        'Star',
        'St. Ives',
        'Spongeables',
        'South Moon',
        'Source Naturals',
        'SOTHYS',
        'Softsoap',
        'Soap Wizards',
        'Soap & Glory',
        'Skin Perfection',
        'Skin Doctor',
        'Sk Duchess',
        'Simple',
        'Shea Moisture',
        'SebaMed',
        'Sea of Spa',
        'Sea Breeze',
        'Sanex',
        'San Francisco Soap',
        'Royal',
        'Right Guard',
        'Rexona',
        'Reviva Labs',
        'Remedy',
        'REFRESH',
        'Q7',
        'Pure Naturals',
        'Pure',
        'Plantlife',
        'PINK',
        'Pierre Cardin',
        'Pier 1',
        'Papaya',
        'Pamper Glow',
        'Palmolive',
        "Palmer's",
        'Paco Rabanne',
        'own',
        'ORIGINAL SOURCE',
        'Original',
        'Organo Gold',
        'Organix',
        'Oral B',
        'Only Natural',
        'Old Spice',
        'Olay',
        "O'Carly",
        'O HUI',
        'Now',
        'NOVA',
        'Nourish',
        'Norland',
        'Non applicabile',
        'No-Name',
        'NIVEA',
        'Neutrogena',
        "Nature's Blend",
        'Nature Secrete',
        'MYSORE SANDAL SOAP',
        'Multistream',
        'MOR',
        'ModelSupplies',
        'Mission',
        'Miracle',
        'Medix 5.5',
        'McKesson',
        'Maxi-Peel',
        'Marvel',
        'Makari',
        'Magno',
        'Ma',
        'Lysol',
        'Lynx',
        'Lux',
        'Love Beauty and Planet',
        'Longrich',
        'Listerine',
        'Le Labo',
        'Lasting Impressions',
        'Lanbena',
        'La Roche-Posay',
        "L'Oreal",
        'Kojiesan',
        'Kojic',
        'Kirkland Signature',
        'Kirkland',
        'Kimberly-Clark',
        'Kedi',
        'K Brothers',
        "JOHNSON'S",
        'Johnson & Johnson',
        'Jimpo Ori',
        'Jergens',
        'Jam',
        'Jack Wills',
        'IT Cosmetics',
        'Irish Spring',
        'Imported',
        'Honest Amish',
        'Homemade',
        'Home Health',
        'Himalaya',
        'Herbal Essences',
        'Hemani',
        'Hask',
        'Goody',
        'Garnier',
        'GANZ',
        'Forever Living',
        'Fashion',
        'Fair And White',
        'Fair & White',
        'Fa',
        'Evyan',
        'Everyone',
        'Eucerin',
        'Essence of Beauty',
        'essence',
        'Emami',
        'Efero',
        'Eelhoe',
        'Eden',
        'dunhill',
        'Dudu-Osun',
        'Dry Dry',
        'Drunk Elephant',
        'DREAM',
        'Dr. Teals',
        'Dr Rashel',
        'Dove',
        'Disaar',
        'Diamond',
        'Dettol',
        'Dermacol',
        'Dead Sea',
        'Cure',
        'Cosrx',
        'Colgate',
        'Clinique',
        'Clearly Natural',
        'CLEAR SKIN',
        'Classics',
        'Cetaphil',
        'Cerave',
        'Castelbel',
        'Carotone',
        'Carolina Herrera',
        'Calvin Klein',
        'Boots',
        'Body Essentials',
        'bliss',
        'Bismid',
        'BIODERMA',
        'BIOAQUA',
        'Beyonce',
        'Bella',
        'Baylis & Harding',
        'other',
    ],
    5607: [
        '3M',
        '21st Century',
        '3W Clinic',
        '4VOO',
        'ACE',
        'AcneFree',
        'Active Plus',
        'Acqua di Parma',
        'A&G',
        'African Pride',
        'Alba Botanica',
        'Almond Herbal',
        'Alpyn beauty',
        'Alpha Skin Care',
        'Alva',
        'American Beauty',
        'Amie',
        'Anne French',
        'Artemis',
        'Astley Clarke',
        'Australian Bodycare',
        'Apeiron',
        'Aura',
        'Avila',
        'Avon',
        'Avour',
        'Aztec Secret',
        'Babyganics',
        'Badger',
        'Bag Balm',
        'Beauty Formulas',
        'Beauty Of Joseon',
        'Becca',
        'Bio Claire',
        'Bio-Oil',
        'Bioderma',
        'Biomaris',
        'Biotique',
        'Blemish Care',
        'bliss',
        'Blossom',
        'Bora',
        'Botanics',
        'Bye Bye Blem',
        'Carebeau',
        'Carmex',
        'Caro white',
        'Cetaphil',
        'Cflair',
        'Charlotte Meentzen',
        'CHI',
        'China Glaze',
        'Christian Breton',
        'Cien',
        'Clarins',
        "Clark's Botanicals",
        'Clean',
        'Clean & Clear',
        'Clear Essence',
        'Clear Skin',
        'Clearasil',
        'Clinic Plus',
        'Clinique',
        'Colageina',
        'Collin Paris',
        'CosMedix',
        'Cosmetic Skin Solutions',
        'Cosrx',
        'Creightons',
        'Crest',
        'Crystal',
        'Cure',
        'CVS',
        'Daggett & Ramsdell',
        'Dead Sea Spa Magik',
        'Depend',
        'Derma',
        'DermaSilk',
        'Dermatix',
        'Dermend',
        'Designer Skin',
        'Devee',
        'DFI',
        'DHC',
        'Differin',
        'Disaar',
        'DKNY',
        'Donna Karan',
        'Dove',
        'Dr Adorable',
        'Dr Davey',
        'Dr James',
        'Dr Meinaier',
        'Dr. Brandt',
        'Dr. Hauschka',
        'Dr. Jart+',
        "Dr. Teal's",
        'E-System',
        'EduPad',
        'eMachines',
        'Essence',
        'Evoo',
        'Fujitsu',
        'Garnier',
        'Geo',
        'Gigabyte',
        'GlamGals',
        'Google',
        'Haier',
        'Hawaiian Silky',
        'Heng Fang',
        'Himalaya',
        'Hudabeauty',
        'Huawei',
        'i-Life',
        'iBUYPOWER',
        'Itel',
        'Just For Men',
        'Kylie',
        "L'Oreal",
        "L'Oreal Paris",
        'Laura Mercier',
        'Linx',
        'Lush',
        'MAC',
        'Maingear',
        'Medion',
        'Microsoft',
        'Mielle',
        'Monster',
        'MSI',
        'Nokia',
        'Novatech',
        'Oriflame',
        'Origin PC',
        'Packard Bell',
        'Panasonic',
        'Prostar',
        'Razer',
        'Revlon',
        'RM Minibook',
        'Sager',
        'Samsung',
        'Secret',
        'SebaMed',
        'Sen',
        'Sense',
        'Sepi White',
        'Serious Skincare',
        'Shea Moisture',
        'Simple',
        'Skin Aqua',
        'Skin Doctor',
        'Skin Doctors',
        'Skin Food',
        'SkinLab',
        'Skinn',
        'Skinny Body Care',
        'Smooth-E',
        'Soap & Glory',
        'Softlips',
        'Some By Mi',
        'Sosu',
        'Source Naturals',
        'St. Ives',
        'Standard Process',
        'Suave',
        'Suki',
        'Sumifun',
        'Sun Cut',
        'Sunday Riley',
        'Supreme White',
        'Sure',
        'Swedish Beauty',
        'Tatcha',
        'Tea Tree',
        'Thayers',
        'The Body Shop',
        'The Face Shop',
        'The Healing Garden',
        'The Inkey List',
        'The Ordinary',
        'The Organic Pharmacy',
        'The Skin House',
        'Tiam',
        'Tocobo',
        'Tony Moly',
        'Touch',
        'Toxskincare',
        'Tree Hut',
        'Ulta',
        'Unbranded',
        'Unica',
        'Untamed',
        'Vanicream',
        'Vaseline',
        'Veet',
        'Veetgold',
        'Vichy',
        'Vitabiotics',
        'Vitamin C Naturals',
        'Vitasense',
        'W7',
        'Wei East',
        'White Express',
        'Windmill',
        'Winstown',
        'WR',
        'Xtreme Brite',
        'Yardley',
        'Yc',
        'Yoko',
        'Yoni',
        'Young Living Essential Oils',
        'Yuri',
        'Zapzyt',
        'Zeenat',
        'Zeno',
        'ZGT',
        'Zia',
        'Zozu',
        'Dr Rasheal',
        'Dr Teal',
        'Dr Teals',
        "Dr. Miracle's",
        'Dr. Rashel',
        'Dynamic Health',
        'E45',
        'Easy Glow',
        'Edens Garden',
        'Eelhoe',
        'Egyptian Magic',
        'ELF',
        'Elie Saab',
        'Elizabeth Arden',
        'Ella Bache',
        'Emma Hardie',
        'Environ',
        'Erborian',
        'Etude House',
        'Eucerin',
        'Evanhealy',
        'Everyone',
        'Ex Skincare',
        'Ezanic',
        'Face Facts',
        'Fair & Lovely',
        'Fair & White',
        'Faith in Nature',
        'Fem',
        'Foreo',
        'Forever Living',
        'French Connection',
        'Fresh',
        'G.M. Collin',
        'Garnier',
        'Genie',
        'Gillette',
        'Glamglow',
        'Glow Half Cast',
        'Gluta- C',
        'Glutathione',
        'Golden Pearl',
        'GoldFlower',
        'Good Molecules',
        'GoodSkin Labs',
        'Grassroots',
        'Green People',
        'GreenHealth',
        'Hada Labo',
        'Half Cast',
        'Handmade',
        'Hatomugi',
        'Hawaiian Tropic',
        'Health Garde',
        'Healthy Origins',
        'Heel',
        'Heidi Klum Intimates',
        'Hemani',
        'Hempz',
        'Herb Pharm',
        'Herbal Essences',
        'Herbalife',
        'Himalaya',
        'Himalaya Health Care',
        'Himalaya Herbals',
        'Honest Beauty',
        'Image',
        'Imported',
        'Inner Beauty',
        'Instant White',
        'Isntree',
        'It Works',
        "It's Skin",
        'Jamberry',
        'Jergens',
        'Jimpo Ori',
        'Joey New York',
        'Johnson & Johnson',
        'Jovees',
        'Julie Diamond',
        'Jumiso',
        "Pond's",
        'Pretty Cowry',
        'Pure Body Naturals',
        'Pure Carrot',
        'Pure Egyptian',
        'Purederm',
        'Pureglow',
        "Puritan's Pride",
        'Qei+',
        'Queen Helene',
        'Radha Beauty',
        'Rdl',
        'Remeehi',
        'REN',
        'ReVive',
        'Revlon',
        'Revuele',
        'Right Guard',
        'Rimmel',
        'RoC',
        'Roushun',
        'Royal Glow Beauty Empire',
        'Sadoer',
        'Sanoflore',
        'Sante',
        'K.Brothers',
        'KAL',
        'Kao',
        'Kat Burki',
        'KIND',
        'Kirkland Signature',
        'Kiss My Face',
        'KleanColor',
        'Kneipp',
        'Koji White',
        'Kojie.San',
        'Kos',
        'Kose',
        'Kuu',
        'Kuu Spa',
        "L'Oreal",
        'La Roche-Posay',
        'Lacura',
        'Lanbena',
        'Lancome',
        'Laneige',
        'Lanocreme',
        'Lavera',
        'Lavolta',
        'LipSense',
        'Lipstick Queen',
        'Lirene',
        'LivingStone',
        'Longrich',
        'Lotus',
        'Lotus Herbals',
        'LR',
        'Lumene',
        'Luminesce',
        'Lus',
        'Ma',
        'Madam White',
        'Makari',
        'Mary Kay',
        'MD Skin Care',
        'Mederma',
        'Medix',
        'Medix 5.5',
        'Mena',
        'Menarini',
        'Mgc Philippines',
        'Microscrub',
        'Milani',
        'Mimi White',
        'Miracle Skin Transformer',
        'Missha',
        'Mistine',
        'Mooyam',
        'Moroccanoil',
        'Murad',
        'MyBody',
        'MyChelle',
        'Nadinola',
        'Natrol',
        'Natural Advantage',
        'Natural Factors',
        'Nature Made',
        'Nature Well',
        "Nature's Cure",
        "Nature's Life",
        "Nature's Way",
        'Naturium',
        'Neo G',
        'NeoCell',
        'Neutrogena',
        'Neutrotone',
        'New Look',
        'Nexxus',
        'Nivea',
        'Nixoderm',
        'Nordic Naturals',
        'Norland',
        'Nourish',
        'Now',
        'Nuskin',
        'NutriBiotic',
        "O'Carly",
        'Oilatum',
        'Olay',
        'Old Spice',
        'Ole Henriksen',
        'Organic India',
        'Organic Surge',
        'Oribe',
        'Origins',
        'Osmotics',
        'OXY',
        "Palmer's",
        'Pamper Glow',
        'PanOxyl',
        'Paris Hilton',
        'Parley Goldie',
        "Paula's Choice",
        'Peau De Lune',
        'Pei Mei',
        'Perlay Goldie',
        'Perlier',
        'Persol',
        'Pharmagel',
        'PHD',
        'PhytoScience',
        'Piment Doux',
        'Pixi',
        'other',
    ],
};
export const healthTypes = {
    5601: [
        'Conditioners',
        'Styling Products',
        'Shampoos',
        'Heat Protectors',
        'Hair Treatments & Oils',
        'Hair Serums',
        'Hair Relaxers',
        'Hair Perms',
        'Hair Masks',
        'Hair Color Products',
        'Hair Extensions & Wigs',
        'Hair Brushes & Combs',
        'Hair Care & Styling Sets',
        'other',
    ],
    5602: [
        'Immune System Boosters',
        'Vitamin Supplements',
        'Detox Cleanses',
        'Weight-Loss Products',
        'Beauty Supplements',
        'Adrenal Support Supplements',
        'Amino Acids',
        'Anti-Aging Supplements',
        'Antioxidants',
        'Ayurveda Supplements',
        'Bee Products',
        'Bladder Supplements',
        'Blood Sugar Support Supplements',
        'Blood Supplements',
        'Bone, Joint & Cartilage Supplements',
        'Brain & Cognitive Supplements',
        "Children's Health Supplements",
        'Cholesterol Support Supplements',
        'Circulatory System Supplements',
        'Collagen Supplements',
        'Colon Supplements',
        'Common Cold & Flu Supplements',
        'Detox & Cleanse Supplements',
        'Diabetic Supplements',
        'Digestive System Supplements',
        'Ears Supplements',
        'Electrolytes Supplements',
        'Energy Boosters',
        'Energy Supplements',
        'Enzyme Nutritional Supplements',
        'Essential Fatty Acid Nutritional',
        'Eye Supplements',
        'Fat Acids',
        'Fertility Support',
        'Fish Oil & Omegas',
        'Glandular Extract',
        'Greens & Superfoods',
        'Hair, Skin & Nails Supplements',
        'Heart Supplements',
        'Herbal Supplements',
        'Hyaluronic Acid Nutritional Supplements',
        'Lipid Nutritional Supplements',
        'MCT Oil Nutritional Supplements',
        "Men's Health Supplements",
        'Menstrual & PMS Support Supplements',
        'Minerals Supplements',
        'Mood & Emotional Support Supplements',
        'MSM Nutritional Supplements',
        'Mushrooms Supplements',
        'Oral Health Supplements',
        'Pain Relief Supplements',
        'Prenatal Support',
        'Protein',
        'Respiratory System Supplements',
        'Senior Health Supplements',
        'Sexual Health Supplements',
        'Sleep Supplements',
        'Sports Supplements',
        'Thyroid Support Supplements',
        'Urinary Tract Health Supplements',
        "Women's Health Supplements",
        'Other',
    ],
    5603: [
        'Essential Oils',
        'Eau de Cologne',
        'Eau de Parfum',
        'Body Oils',
        'Eau de Fraiche',
        'Eau de Toilette',
        'Parfum',
    ],
    5604: [
        'Vibrators',
        'Sexual Supplements',
        'Massage Cream & Oil',
        'Fertility Supplements',
        'Lubricants',
        'Anal Sex Toys',
        'Better Sex for Her',
        'Better Sex for Him',
        'Blindfolds, Masks & Gag',
        'Bondage',
        'Bondage for Beginners',
        'Breast Enhancer',
        'Breast Stimulator',
        'Butt Plugs',
        'Chastity Devices',
        'Cock & Ball Toys',
        'Cock Rings',
        'Condoms',
        'Contraception',
        'Dildos',
        'Electro & Medical Fetish',
        'Erotic Lingerie Sets',
        'Fetish Clothing',
        'Handcuffs & Restraints',
        'Intimate Hygiene',
        'Love Eggs & Jiggle Balls',
        'Male Sex Toys',
        'Nipple & Clitoral Toys',
        'Sex Machine',
        'Sex Swings & Machines',
        'Sex Toys for Couples',
        'Sexual Duration Products',
        'Sexy Clothing',
        'Sexy Gifts & Games',
        'Spankers & Ticklers',
        'Strap-Ons',
        'Underwear for Men',
        'Wet Look Lingerie',
        'Other',
    ],
    5605: [
        'Tinted Moisturizers',
        'Setting Spray',
        'Pencils',
        'Mascaras',
        'Lip Balm & Treatment',
        'Liners',
        'Hair Relaxers',
        'Glitter Glue',
        'Make-Up Sets',
        'Blush',
        'Eyeshadows',
        'Foundations',
        'False Eyelashes',
        'Bronzers',
        'Eyelash Serums',
        'Eyebrow Gel',
        'Brushes & Applicators',
        'Blotting Papers',
        'BB Cream',
        'Contour',
        'Color Correctors',
        'Powders',
        'Lipstick',
        'CC Cream',
        'Facial Wipes',
        'Eyelash Glue',
        'Concealers',
        'Other',
        'Illuminators & Highlighters',
        'other',
    ],
    5606: [
        'Soaps',
        'Body Lotions',
        'Body Oils',
        'Shower Gels',
        'Toothpastes',
        'Antiseptics',
        'Bath Bombs & Fizzies',
        'Bath Brushes & Sponges',
        'Bath Foam',
        'Bath Salts',
        'Bath Sets & Kits',
        'Body Butters',
        'Body Creams',
        'Body Powders',
        'Body Scrubs',
        'Body Sprays',
        'Breath Fresheners',
        'Cotton Buds',
        'Dental Floss',
        'Deodorants & Aniperspirants',
        'Essential Oils',
        'Female Cleansers',
        'Hair Removal Creams',
        'Hand Washes',
        'Mouthwashes',
        'Panty Liners',
        'Sanitary Pads',
        'Scar & Stretch Mark Reducers',
        'Shower Caps',
        'Tampons',
        'Teeth Whitening Products',
        'Tongue Cleaner',
        'Toothbrushes',
        'Travel Bottles & Container',
        'Other',
    ],
    5607: [
        'Body Creams & Milks',
        'Face Creams & Gels',
        'Body Oils',
        'Body Wash & Soap',
        'Face Serums & Oils',
        'Advent Calendar',
        'BB & CC Creams',
        'Body Scrubs & Exfoliation',
        'Cosmetics Bags & Organizers',
        'Eye Creams & Treatments',
        'Face Scrubs & Exfoliants',
        'Face Wipes',
        'Face Wash & Cleansers',
        'Facial Peels',
        'Gift Sets',
        'Hydrogel Patches',
        'Lip Balms & Treatments',
        'Make-Up Remover',
        'Neck & Décolleté',
        'Night Creams',
        'Self-Tanners',
        'Skincare Tools',
        'Skin and Hair Ampoules',
        'Sun Care',
        'Toners',
        'Other',
    ],
    5608: [
        'Tins',
        'Snuff Boxes',
        'Pencils',
        'Rolling Paper Filter',
        'Rollers',
        'Pipes',
        'Papers',
        'Nicotine Pouches',
        'Laughing Gas',
        'Flavored Capsules Smoking',
        'Grinders',
        'Cigars',
        'E-Cig Cartridges',
        'Cigarettes',
        'Cases & Stands',
        'Bongs',
        'Ashtrays',
        'Lighters',
        'E-Liquids',
        'Vapes',
        'Hookahs & Accessories',
        'Other',
    ],
};

//software category
export const softwareTypes = [
    'Operating Systems',
    'Application Software',
    'Utility Software',
    'Programming Software',
    'Database Software',
    'Graphics & Design Software',
    'Communication Software',
    'Media Players & Editors',
    'Educational Software',
    'Financial Software',
    'Gaming Software',
    'Medical & Healthcare Software',
    'Navigation Software',
    'Enterprise Software',
    'Security Software',
    'Project Management Software',
    'CAD',
    'Weather Forecasting Software',
    'Artificial Intelligence',
    'IoT (Internet of Things) Software',
    'Other',
];
export const softwarePlatforms = {
    5901: ['Android', 'iOS', 'Linux', 'Mac', 'Windows', 'other'],
    default: [
        'Android',
        'iOS',
        'Linux',
        'Mac',
        'Windows',
        'Microsoft Xbox',
        'Microsoft Xbox One',
        'PC',
        'Sony PlayStation',
        'Sony PlayStation 1-5',
        'Sony PlayStation Vita',
        'Nintendo Switch',
        'Nintendo Wii',
        'other',
    ],
};
export const gameGenre = [
    'Action',
    'Adventure',
    'Shooter',
    'Fighting',
    'Racing',
    'Role Playing',
    'Sports',
    'Strategy',
    'Other',
];

//babies category
export const babiesBrands = {
    6102: [
        'Pep',
        'Crocs',
        'Fashion',
        'Hi-Way',
        'Nike',
        '2K',
        '3M',
        'A&BC',
        'A&G',
        'Abercrombie & Fitch',
        'Accessorize',
        'ACE',
        'Acme',
        'Active',
        'ACTON',
        'Adams',
        'Adidas',
        'adidas',
        'AdTec',
        'AE',
        'After Six',
        'Agatha Ruiz de la Prada',
        'Aigle',
        'Air Balance',
        'Air force',
        'AIRWALK',
        'Albatros',
        'Aldo',
        'All Star',
        'ALTA',
        'AMAZONAS',
        'Amelia',
        'AMI',
        'Amy Coe',
        'AND1',
        'Anderson Bean',
        'Andrea',
        'Angel',
        'Angels Shoes',
        'Annabelle',
        'Anniel',
        'Aquazzura',
        'ARMANI',
        'Athletic Works',
        'B&B',
        'Babybotte',
        'Back To School',
        'Balenciaga',
        'Barbie',
        'Beau',
        'bebe',
        'Bellissimo',
        'Beverly Hills Polo Club',
        'Birkenstock',
        'Bobbie Brooks',
        'Bobdog',
        'Bogs',
        'Boots',
        'BT',
        'Buckle',
        'Buckle my shoe',
        'Calvin Klein',
        'Candies',
        'Canvas',
        'Carter',
        "Carter's",
        'Cat & Jack',
        'Charlie',
        'China',
        'Clarks',
        'Claudia Ghizzani',
        'Conoli',
        'Converse',
        'Cortina',
        'Crystal',
        'Danskin',
        'Designer',
        'Dino',
        'Dior',
        'Disney',
        'Disney Baby',
        'Divine',
        'Easy',
        'Ecosoft',
        'Elefanten',
        'F&F',
        'FILA',
        'Frozen',
        'George',
        'Georgia',
        'Gioseppo',
        'Graceland',
        'Grosby',
        'Gucci',
        'H&M',
        'Hackett',
        'Handmade',
        'HL',
        'ID',
        'Italia',
        'John Lewis',
        'Jojo Siwa',
        'Jordan',
        'Jump',
        'Karl Lagerfeld',
        'Koala Baby',
        'LA',
        'Lilley',
        'Lilly',
        'Lipsy',
        'Ljt',
        'Loop',
        'Loulou',
        'Madden',
        'Magic',
        'Mario',
        'Marks and Spencer',
        'Mary Jane',
        'Matalan',
        'Max Shoes',
        'Meindl',
        'Meng Ke Xuan',
        'Michael Kors',
        'Mix',
        'Mothercare',
        'Natural World',
        'Nautica',
        'ND',
        'New',
        'New Balance',
        'NEXT',
        'Nickelodeon',
        'Nicole Miller',
        'Nike ACG',
        'No-Name',
        'Old Navy',
        'On',
        'Original',
        'Oscar',
        "OshKosh B'gosh",
        'Outdoor',
        'Papillio',
        'Paul Frank',
        'Polo Ralph Lauren',
        'Primark',
        'PRO',
        'PUMA',
        'Pure',
        'Ralph Lauren',
        'Reebok',
        'REN',
        'RIA Menorca',
        'River Island',
        'Roots',
        'Safe T Step',
        'Salvatore Ferragamo',
        'Sebago',
        'SKECHERS',
        'Smartfit',
        'Soft Touch',
        'SpongeBob',
        'Sporto',
        'Starbury',
        'Steve Madden',
        'Summer',
        "The Children's Place",
        'Theme',
        'Timberland',
        'Tingley',
        "Tom's",
        'Tommy Hilfiger',
        'TOP MODA',
        'TU',
        'US Brass',
        'Versace',
        'Wal Mart',
        'Wellington',
        'Wonder Nation',
        'Zara',
        'Other',
    ],
    6103: [
        'Baby King',
        'BabySmart',
        'Disney',
        'LEGO',
        'Little Tikes',
        'Accoutrements',
        'ALEX',
        'American Airlines',
        'Animal Planet',
        'Applause',
        'Athearn',
        'Atouch',
        'Audi',
        'Aurora',
        'Baby Einstein',
        'Baby First',
        'BABY LOOVI',
        'Bandai',
        'Barbie',
        'Barclay',
        'Battat',
        'Bebe',
        'Bestway',
        'Bmw',
        'Bmx',
        'Brick Game',
        'Bright Starts',
        'BRIO',
        'Character',
        'Chicco',
        'Compass',
        'Cool Mini or Not',
        'Costway',
        'Creative Baby',
        'DC Comics',
        'DEMDACO',
        'Discovery Toys',
        'Disney Pixar',
        'DreamWorks',
        'Duncan',
        'Dynacraft',
        'Earlyears',
        'EDUSHAPE',
        'Fantasy Flight Games',
        'Fat Brain Toys',
        'Ferrari',
        'Fisher-Price',
        'Fun Little Toys',
        'Funko',
        'Funtime',
        'Galoob',
        'GOOC',
        'Great Vision',
        'Green Toys',
        'GUND',
        'Hallmark',
        'Handmade',
        'Happy family',
        'Hasbro',
        'HOMOFY',
        'Huffy',
        'Idino',
        'IKEA',
        'Imagination Generation',
        'Infantino',
        'Intex',
        'iPlay, iLearn',
        'Jeep',
        'Judelink',
        "K's Kids",
        'Kidrobot',
        'Kids II',
        'Kids Preferred',
        'Lamaze',
        'LeapFrog',
        'Learning Resources',
        'Lexus',
        'Li-Link',
        'Lionel',
        'Lmv',
        'Marvel Toys',
        'MasterPieces',
        'Matchbox',
        'Mattel',
        'MEGA',
        'Melissa & Doug',
        'Mercedes-Benz',
        'Munchkin',
        'Nickelodeon',
        'Nintendo',
        'North American Bear Company',
        'Origins',
        'Parker Brothers',
        'Pilsan',
        'PlanToys',
        'PlayGo',
        'Playgro',
        'Playskool',
        'Post',
        'Princess',
        'R&L',
        'Racing Champions',
        'Range Rover',
        'Ravensburger',
        'Razor',
        'Rock Band',
        'Rolls Royce',
        'Russ',
        'Sassy',
        'Schleich',
        'SEGA',
        'Skip Hop',
        'Small World Toys',
        'Smoby',
        'Soft Play',
        'Spin Master',
        'Step2',
        'Taggies',
        'Teddy Bear',
        'The First Years',
        'Todays Kids',
        'TOP BRIGHT',
        'Toyk',
        'Toysmith',
        'Ty',
        'Unbranded',
        'Universal',
        'Vktech',
        'Volkswagen',
        'VTech',
        'Vtech Baby',
        'Warner Bros.',
        'WolVol',
        'Ypad',
        'Other',
    ],
    6104: [
        'Babytrend',
        'Chicco',
        'Graco',
        'Lmv',
        'Mothercare',
        'Britax',
        'Bugaboo',
        'Bumbleride',
        'Combi',
        'Cosco',
        'Evenflo',
        'Fisher Price',
        'Graceland',
        'Ingenuity',
        'Jeep',
        'Kolcraft',
        'Maclaren',
        'Mastela',
        'Maxi-Cosi',
        'Next Generation',
        'Orbit Baby',
        'Peg Perego',
        'Safety 1St',
        'Silver Cross',
        'Stokke',
        'Other',
    ],
    6105: [
        'Obaby',
        'Fridababy (NoseFrida)',
        'Tiny Tatty Teddy',
        'Red Kite',
        'Nuna',
        'Skip Hop',
        'Maxi-Cosi',
        'VTech',
        'Tiny Love',
        'Evenflo',
        'Bright Starts',
        'Chicco',
        'Joie',
        'Mamaroo (by 4moms)',
        'BabyBjörn',
        'Bright Starts',
        '4moms',
        'Ingenuity',
        'Graco',
        'Fisher-Price',
        'other',
    ],
    6109: [
        '3M',
        'ACE',
        'American Standard',
        'Graco',
        'Home Interiors',
        'Acme',
        'Adams',
        'Alera',
        'Alessi',
        'Altak',
        'Angel',
        'Arya',
        'Ashley Furniture',
        'Aussie',
        'Authentic Models',
        'Avanti',
        'Baby Trend',
        'Badger',
        'Bed Bath & Beyond',
        'Better Homes & Gardens',
        'Bird',
        'Blanco',
        'blomus',
        'Bravo',
        'BUILT',
        'Bull',
        'Cambridge',
        'CAN',
        'Casual Home',
        'Champion',
        'Chicago',
        'Chicco',
        'Comfort Research',
        'Company Kids',
        'Cosco',
        'Creative Home',
        'Deco',
        'Delta',
        'Disney',
        'Duck',
        'DURABLE',
        'Fisher-Price',
        'Fun Furnishings',
        'GE',
        'Handmade',
        'Hansa',
        'Happy Baby',
        'Home Made',
        'IKEA',
        'Ingenuity',
        'Intex',
        'Judelink',
        'KD',
        'Kidde',
        'Kidsline',
        'LEGO',
        'Little Tikes',
        'Lmv',
        'Mamakids',
        'Mastela',
        'Mothercare',
        'National',
        'Newline',
        'Papilon',
        'Premier',
        'Shaw',
        'Simmons',
        'Summer Infant',
        'SWING',
        'Triton',
        'Unbranded',
        'White',
        'Wood-Mode',
        'Other',
    ],
    6110: [
        '3M',
        'adidas',
        'Angel',
        "Carter's",
        "The Children's Place",
        '2B Real',
        '2XU',
        '3pommes',
        '5th & Ocean',
        '686',
        '7 For All Mankind',
        '77kids',
        'A&BC',
        'A&G',
        'A&W',
        'a.n.a',
        'Abercrombie & Fitch',
        'Absorba',
        'Academy',
        'Accent',
        'acdc',
        'Active',
        'AD',
        'Adam',
        'Adams',
        'Addison',
        'Admiral',
        'Aerie',
        'After Six',
        'AG Adriano Goldschmied',
        'Aigle',
        'AIKO',
        'Air force',
        'Alchemy',
        'Alexander Julian',
        'Alligator',
        'Allison',
        'Almost Famous',
        'Alpha',
        'Alpinestars',
        'Alviero Martini',
        'Amazon',
        'American Princess',
        "Amy's Closet",
        'Anavini',
        'AND1',
        'Anderson',
        'Andrew Fezza',
        'Angelina',
        'Angels',
        'ANNA',
        'Answer',
        'Anthony',
        'Anvil',
        'Apollo',
        'Apple',
        'Archer',
        'Arena',
        'ARMANI',
        'ASOS',
        'Aspen',
        'Aspire',
        'AST',
        'Athena',
        'Atmosphere',
        'Aurora',
        'Avanti',
        'B&G',
        'B.T. Kids',
        'B2',
        'Babolat',
        'Baby Sara',
        'Babylia',
        'BAD BOY',
        'Bailey',
        'Bailey Boys',
        'Balera',
        'Balmain',
        'Bandai',
        'BAPE',
        'Basic Editions',
        'BeBop',
        'Believe',
        'Ben Sherman',
        'Berry',
        'Bianco',
        'Big Chill',
        'Big Dogs',
        'Biscotti',
        'Blizzard',
        'Blossom',
        'Blueberi Boulevard',
        'Bluebird',
        'Bonnie Baby',
        'Bonnie Jean',
        'Brooks Brothers',
        'Brother',
        'Browning',
        'BTC',
        'Buffalo',
        'Burberry',
        'By Design',
        'Callaway',
        'Calvin Klein',
        'Cargo',
        'Cartoon Network',
        'Castles & Crowns',
        'CAT',
        'Cat & Jack',
        'CCM',
        'Celebrity Pink',
        'Champion',
        'Chanel',
        'Chaos',
        'Chaps',
        'Chaser',
        'Cheetah',
        'Cherokee',
        'Cinderella',
        'CL',
        'Clarks',
        'Classics',
        'Cloth',
        'Collections',
        'Comfort Colors',
        'Company Kids',
        'Cotton On Kids',
        'Country Kids',
        'Couture Princess',
        'Covington',
        'CRAFT',
        'Crazy 8',
        'Creative',
        'Cube',
        'Customized & Personalized',
        'D. Jeans',
        'Darling',
        'DB',
        'Denim & Co.',
        'Dickies',
        'Diesel',
        'Dimensions',
        'Dior',
        'Disney',
        'Disney Couture',
        'District',
        'Divided by H&M',
        'DKNY',
        'Dolce&Gabbana',
        'Dreamgirl',
        'Duck',
        'Dunnes',
        'Dunnes Store',
        'Early Days',
        'EF',
        'EG&G',
        'Element',
        'ESCADA',
        'ESS',
        'ET',
        'F&F',
        'Fancy Nancy',
        'FAS',
        'Fendi',
        'Ferugini',
        'FILA',
        'Fox',
        'Freestyle',
        'G&S',
        'GANT',
        'Gap',
        'Garanimals',
        'Garcia',
        'GB',
        'GB girls',
        'Generic Surplus',
        'Genuine Baby by OshKosh',
        'Genuine Stuff',
        'George',
        'Gerber',
        'Gina',
        'Givenchy',
        'GT',
        'Gucci',
        'H by Hudson',
        'H&M',
        'Halo',
        'Handmade',
        'Hanes',
        'Hang Ten',
        'Happy Fella',
        'Healthtex',
        'Hello Kitty',
        'Hibobi',
        'Hilfiger Denim',
        'Hudson',
        'HUGO BOSS',
        'Ideology',
        'Joe Boxer',
        'Jordan',
        'Joules',
        'Juicy Couture',
        'Jumping Beans',
        'Justice',
        'K2',
        'Karl Kani',
        'Key',
        'Kidgets',
        'Kids Headquarters',
        'KIKO MILANO',
        'Lacoste',
        "Lands' End",
        'Laura Ashley',
        'Lauren',
        'Lee',
        'Lily Rose',
        'Limited Too',
        'Little Darlings',
        'Little Lass',
        'LittleMissMatched',
        'Lola',
        'Looney Tunes',
        'Louis Vuitton',
        'Luvable Friends',
        'Lux',
        'Lv',
        "M&M's",
        'Mango',
        'Mario',
        'Marks and Spencer',
        'Matalan',
        'Maxx',
        'Maya',
        'Mayoral',
        'Metro',
        'MIA',
        'Mickey Mouse',
        'Mimi',
        'Mini Boden',
        'Missoni',
        'Moncler',
        'Monsoon',
        'Moschino',
        'Mothercare',
        'MUJI',
        'Nannette',
        'Nautica',
        'NCAA',
        'ND',
        'New Era',
        'NEXT',
        'Nickelodeon',
        'Nike',
        'Not Specified',
        'Nutmeg',
        'Okaidi',
        'Okie Dokie',
        'Olivia',
        'One A',
        'Orchestra',
        'Otto',
        'Ovs',
        'Papillon',
        'Petit Ami',
        'Pilot',
        'Polo Ralph Lauren',
        'Polo Sport',
        'Prada',
        'Prestige',
        'Primark',
        'Prince',
        'PUMA',
        'Quest',
        'Ralph Lauren',
        'Rare Editions',
        'Reebok',
        'RG Costumes',
        'Rockstar',
        'Santa Cruz',
        'Sergio Tacchini',
        'Signature',
        'Skatersocks',
        'Sky',
        'SO',
        'Sunny Fashion',
        'Superdry',
        'Sweet Dreams',
        'Sweet Kids',
        'Tahari',
        'Team Athletics',
        'Tommy Hilfiger',
        'Toughskins',
        'Tucker',
        'Tulle',
        'Tultex',
        'Tutu Du Monde',
        'Ty',
        'Underwraps Costumes',
        'Unik',
        'Unknown Factory',
        'US Polo Assn.',
        'Versace',
        "Victoria's Secret",
        'Vintage Red',
        'VIP',
        'Waves',
        'Wonder Nation',
        'Woodstock',
        'Woolrich',
        'Wrangler',
        'XOXO',
        'Young Hearts',
        'Youngland',
        'Zara',
        'Zella Girl',
        'Other',
    ],
    6111: [
        'Gerber',
        'Beech-Nut',
        "Ella's Kitchen",
        'Plum Organics',
        'Happy Family Organics',
        'Homemade Baby',
        'Sprout Organic',
        "Earth's Best Organic",
        "Parent's Choice",
        'Little Spoon',
        'Peter Rabbit Organics',
        'Organix (UK Brand)',
        'NurturMe',
        'Amara Organic',
        'Once Upon a Farm',
        'Pure Spoon',
        'Purity Organics',
        'Kiddo Feedo',
        'other',
    ],
    default: [
        'Babytrend',
        'Chicco',
        'Graco',
        'Lmv',
        'Mothercare',
        'Britax',
        'Bugaboo',
        'Bumbleride',
        'Combi',
        'Cosco',
        'Evenflo',
        'Fisher Price',
        'Graceland',
        'Ingenuity',
        'Jeep',
        'Kolcraft',
        'Maclaren',
        'Mastela',
        'Maxi-Cosi',
        'Next Generation',
        'Orbit Baby',
        'Peg Perego',
        'Safety 1St',
        'Silver Cross',
        'Stokke',
        'Other',
    ],
};
export const babiesTypes = {
    6101: [
        'Food',
        'Diapers',
        'Feeding Bottles',
        'Lotions',
        'Bath Tubs',
        'Baby Bed Rails',
        'Baby Bed Sheets',
        'Baby Gates',
        'Baby Gift Sets',
        'Baby Grooming Kits',
        'Baby Manicure Sets',
        'Baby Monitors',
        'Baby Oil',
        'Baby Pillow Cases & Shams',
        'Baby Pillows',
        'Baby Powder',
        'Baby Proofing',
        'Baby Scales',
        'Baby Spoons',
        'Baby Wipe Warmers',
        'Bath Accessories',
        'Bathers',
        'Bibs',
        'Blankets & Throws',
        'Bottle Bags',
        'Bottle Brushes',
        'Bottle Drying Racks',
        'Bottle Nipples',
        'Bottle Sterilizers',
        'Bottle Warmers',
        'Bubble Bath',
        'Bumpers',
        'Changing Pads',
        'Changing Pads Covers',
        'Cloth Diapers',
        'Crib Netting & Canopies',
        'Cutlery Sets',
        'Decorative Nursery Pillows',
        'Diaper Bags',
        'Diaper Covers',
        'Diaper Disposal Supplies',
        'Duvet Covers & Sets',
        'Duvets',
        'Formula Dispensers',
        'Mattress Pads & Covers',
        'Nappy Cream',
        'Nappy Sacks',
        'Nasal Aspirators',
        'Nursery Bedding Sets',
        'Pacifier Brushes',
        'Pacifiers',
        'Plates',
        'Potty Training',
        'Shampoo',
        'Shawls',
        'Shower Caps',
        'Sippy Cups & Mugs',
        'Soap',
        'Starter Sets',
        'Sterilizing Tablets',
        'Swim Diapers',
        'Thermometers',
        'Toothbrushes',
        'Toothpaste',
        'Towels',
        'Training Pants',
        'Washcloths',
        'Water Bottles & Cups',
        'Wipes',
        'Other',
    ],
    6102: [
        'Sneakers',
        'School Shoes',
        'Flat Shoes',
        'Sandals',
        'Baby Shoes',
        'Ballet Flats',
        'Boots',
        'Clogs',
        'Flip-Flops',
        'Football Shoes',
        'High Heels',
        'Loafers',
        'Moccasins',
        'Slip-ons',
        'Slippers',
        'Tennis Shoes',
        'Other',
    ],
    6103: [
        'Educational Toys',
        'Bikes',
        'Vehicles',
        'Tricycles, Scooters & Wagons',
        'Outdoor Toys & Play Structures',
        'Action Figures',
        'Arts & Crafts',
        'Baby & Toddler Toys',
        'Balloons',
        'Balls',
        'Basketball Hoops',
        'Books & Coloring Pages',
        'Building Toys',
        'Cereal Toys',
        'Collectible Card Games',
        'Colorforms',
        'Dolls & Dollhouses Supplies',
        'Dress Up & Pretend Play',
        'Electronic & Wind-Up Toys',
        'Etch-A-Sketch',
        'Fast Food Toys',
        'Fidget Spinners',
        'Games',
        'Guns',
        'Jack-in-the-Box',
        'Musical Instruments',
        'Playing Mats',
        'Preschool Toys & Pretend Play',
        'Puppets & Puppet Theaters',
        'RC Models',
        'Robots',
        'Rocking Horses',
        "Rubik's Cube",
        'Slot Cars',
        'Space Toys',
        'Stuffed Animals & Plush Toys',
        'Toy Marbles',
        'Toy Models & Kits',
        'Toy Soldiers',
        'Vintage & Antique Toys',
        'Water Guns',
        'Other',
    ],
    6104: [
        'Rear-Facing Only Infant',
        'Rear-Facing Convertible',
        'Forward-Facing Convertible',
        'High-Back Booster',
        'Backless Booster',
        'Combination Car Seats',
        '3-in-1 Car Seats',
        'All-in-One Car Seats',
        'Special Needs Car Seats',
    ],
    6106: [
        'Breast Pumps',
        'Nursing Pillows',
        'Hospital Delivery Package',
        'Support Belts',
        'Nursing Bras',
        'Breast Pads',
        'Breastmilk Storage Bags',
        'Disposable Pants',
        'Dresses',
        'Fake Pregnancy Belly',
        'Fetal Doppler',
        'Night Gowns',
        'Nipple Shields',
        'Nursing Covers',
        'Pregnancy Seat Belt Adjuster',
        'Sanitary Pads',
        'Sitz Bath',
        'Stretch Marks Cream',
        'Tops',
        'Trousers',
        'Other',
    ],
    6109: [
        'Beds',
        'Chairs',
        'Wardrobes',
        'Tables',
        'Dressers & Drawers',
        'Bed Canopies',
        'Benches',
        'Changing Tables',
        'Desks',
        'Easels',
        'Hooks & Wall Organization',
        'Kids Armoires',
        "Kids' Vanities",
        'Mattresses',
        'Nursery Centers',
        'Nursery Furniture Sets',
        'Nursery Gliders, Rockers & Recliners',
        'Picnic Tables',
        'Play Tents',
        'Rugs',
        'Toy Boxes',
        'Other',
    ],
    6110: [
        'Clothing Sets',
        'Ball Gowns',
        'Dresses',
        'Costumes',
        'Shirts',
        'Agbada',
        'Ballet Camisole',
        'Ballet Dresses',
        'Bathrobes',
        'Bibs',
        'Blazers',
        'Blouses',
        'Bodysuits',
        'Caps',
        'Cardigans',
        'Christening Clothes',
        'Dungarees',
        'Hoodies',
        'Isi Agu',
        'Jeans',
        'Jeggings',
        'Jerseys',
        'Joggers',
        'Jumpsuits',
        'Leggings',
        'Nightwear',
        'Outwear',
        'Overalls',
        'Pants',
        'Pantyhose',
        'Polo Shirts',
        'Pullovers',
        'Rompers',
        'School Uniforms',
        'Shorts',
        'Singlets',
        'Skirts',
        'Socks',
        'Suits',
        'Sweaters',
        'Sweatshirts',
        'Swimwear',
        'T-Shirts',
        'Tops',
        'Tracksuits',
        'Trousers',
        'Underwear',
        'Vests',
        'Other',
    ],
    default: [
        'Jogging Strollers',
        'Double Strollers',
        'All-Terrain Strollers',
        'Carriage or Pram Strollers',
        'Sit and Stand Strollers',
        'High-End Luxury Strollers',
        'Compact/Foldable Strollers',
        'Off-Road or Trail Strollers',
        'Lightweight',
        'Standard',
        'Travel System',
        'Transformable',
        'Other',
    ],
};
export const babiesSizes = [
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
];

// color options
export const colors = [
    'Orange',
    'Pearl',
    'Pink',
    'Brown',
    'Purple',
    'Red',
    'Yellow',
    'Teal',
    'Gold',
    'Off white',
    'Green',
    'Matt Black',
    'Burgundy',
    'Ivory',
    'Black',
    'White',
    'Silver',
    'Blue',
    'Gray',
    'Beige',
    'Other',
];

// years options
const arrayRange = (start, stop, step) =>
    Array.from({ length: (stop - start) / step + 1 }, (value, index) => start + index * step);

export const years = arrayRange(1990, parseInt(new Date().getFullYear()), 1);
